import headerLogo from "../assets/images/header-logo.png";
import facebookLogo from "../assets/logos/Logo-Facebook.svg";
import instagramLogo from "../assets/logos/Logo-Instagram.svg";
import xLogo from "../assets/logos/Logo-X.svg";
import linkedInLogo from "../assets/logos/Logo-LinkedIn.svg";
import nabp from "../assets/images/NABP-certified.png";

export const footerData = {
    copyrightMessage: '© 2025 Moderna, Inc. ',
    imageData: headerLogo,
    socialLinks: [
    {
        metadata: {
        tags: [],
        concepts: []
        },
        sys: {
        space: {
            sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'n9bebhw263o0'
            }
        },
        id: '7efqMp5o0dP7mEOTW2jpaZ',
        type: 'Entry',
        createdAt: '2021-12-15T19:20:19.232Z',
        updatedAt: '2022-10-28T17:39:26.811Z',
        environment: {
            sys: {
            id: 'sandbox',
            type: 'Link',
            linkType: 'Environment'
            }
        },
        publishedVersion: 17,
        revision: 6,
        contentType: {
            sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'socialLink'
            }
        },
        locale: 'en-US'
        },
        fields: {
        title: 'Facebook SocialLink',
        link: {
            metadata: {
            tags: [],
            concepts: []
            },
            sys: {
            space: {
                sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'n9bebhw263o0'
                }
            },
            id: '2a3smvGHyeYARfvkI38Uju',
            type: 'Entry',
            createdAt: '2021-12-15T19:20:08.646Z',
            updatedAt: '2021-12-15T19:20:08.646Z',
            environment: {
                sys: {
                id: 'sandbox',
                type: 'Link',
                linkType: 'Environment'
                }
            },
            publishedVersion: 5,
            revision: 1,
            contentType: {
                sys: {
                type: 'Link',
                linkType: 'ContentType',
                id: 'externalLink'
                }
            },
            locale: 'en-US'
            },
            fields: {
            title: 'Facebook Link',
            label: 'Facebook',
            url: 'https://www.facebook.com/modernatx/'
            }
        },
        icon: {
            metadata: {
            tags: [],
            concepts: []
            },
            sys: {
            space: {
                sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'n9bebhw263o0'
                }
            },
            id: '3p3fBOwbP2ml2V9Hxb7xkg',
            type: 'Asset',
            createdAt: '2022-10-28T17:39:18.324Z',
            updatedAt: '2022-12-15T22:21:22.835Z',
            environment: {
                sys: {
                id: 'sandbox',
                type: 'Link',
                linkType: 'Environment'
                }
            },
            publishedVersion: 16,
            revision: 3,
            locale: 'en-US'
            },
            fields: {
            title: 'Facebook Icon',
            description: '',
            file: {
                url: facebookLogo,
                details: {
                size: 857,
                image: {
                    width: 82,
                    height: 82
                }
                },
                fileName: 'fb.png',
                contentType: 'image/png'
            }
            }
        }
        }
    },
    {
        metadata: {
        tags: [],
        concepts: []
        },
        sys: {
        space: {
            sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'n9bebhw263o0'
            }
        },
        id: '2Dmb8HKJ9Z2NYgwyxTb2a2',
        type: 'Entry',
        createdAt: '2021-12-15T19:23:32.124Z',
        updatedAt: '2022-10-28T17:38:30.502Z',
        environment: {
            sys: {
            id: 'sandbox',
            type: 'Link',
            linkType: 'Environment'
            }
        },
        publishedVersion: 19,
        revision: 7,
        contentType: {
            sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'socialLink'
            }
        },
        locale: 'en-US'
        },
        fields: {
        title: 'Twitter SocialLink',
        link: {
            metadata: {
            tags: [],
            concepts: []
            },
            sys: {
            space: {
                sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'n9bebhw263o0'
                }
            },
            id: '5zPEOXT6elJMyMpLChBuW6',
            type: 'Entry',
            createdAt: '2021-12-15T19:21:54.452Z',
            updatedAt: '2021-12-15T19:21:54.452Z',
            environment: {
                sys: {
                id: 'sandbox',
                type: 'Link',
                linkType: 'Environment'
                }
            },
            publishedVersion: 3,
            revision: 1,
            contentType: {
                sys: {
                type: 'Link',
                linkType: 'ContentType',
                id: 'externalLink'
                }
            },
            locale: 'en-US'
            },
            fields: {
            title: 'X Link',
            label: 'X',
            url: 'https://x.com/moderna_tx'
            }
        },
        icon: {
            metadata: {
            tags: [],
            concepts: []
            },
            sys: {
            space: {
                sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'n9bebhw263o0'
                }
            },
            id: '6VGtxnDHcT2N68cJpgG0hI',
            type: 'Asset',
            createdAt: '2022-10-28T17:38:11.623Z',
            updatedAt: '2022-12-15T22:22:21.078Z',
            environment: {
                sys: {
                id: 'sandbox',
                type: 'Link',
                linkType: 'Environment'
                }
            },
            publishedVersion: 8,
            revision: 2,
            locale: 'en-US'
            },
            fields: {
            title: 'X Icon',
            description: '',
            file: {
                url: xLogo,
                details: {
                size: 1204,
                image: {
                    width: 82,
                    height: 82
                }
                },
                fileName: 'X.png',
                contentType: 'image/png'
            }
            }
        }
        }
    },
    {
        metadata: {
        tags: [],
        concepts: []
        },
        sys: {
        space: {
            sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'n9bebhw263o0'
            }
        },
        id: '6iVHoQKoQHT82WhD97iCsm',
        type: 'Entry',
        createdAt: '2021-12-17T18:33:15.466Z',
        updatedAt: '2022-10-28T17:54:12.824Z',
        environment: {
            sys: {
            id: 'sandbox',
            type: 'Link',
            linkType: 'Environment'
            }
        },
        publishedVersion: 21,
        revision: 7,
        contentType: {
            sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'socialLink'
            }
        },
        locale: 'en-US'
        },
        fields: {
        title: 'Instagram SocialLink',
        link: {
            metadata: {
            tags: [],
            concepts: []
            },
            sys: {
            space: {
                sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'n9bebhw263o0'
                }
            },
            id: '5bojUkeNFpoAuCVVmOhm0u',
            type: 'Entry',
            createdAt: '2021-12-17T18:33:07.849Z',
            updatedAt: '2022-01-19T06:19:29.704Z',
            environment: {
                sys: {
                id: 'sandbox',
                type: 'Link',
                linkType: 'Environment'
                }
            },
            publishedVersion: 5,
            revision: 2,
            contentType: {
                sys: {
                type: 'Link',
                linkType: 'ContentType',
                id: 'externalLink'
                }
            },
            locale: 'en-US'
            },
            fields: {
            title: 'Instagram Link',
            label: 'Instagram',
            url: 'https://www.instagram.com/moderna_tx'
            }
        },
        icon: {
            metadata: {
            tags: [],
            concepts: []
            },
            sys: {
            space: {
                sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'n9bebhw263o0'
                }
            },
            id: '7e6aSUfeu011v2SXhYgPzT',
            type: 'Asset',
            createdAt: '2022-10-28T17:54:00.287Z',
            updatedAt: '2022-12-15T22:22:49.562Z',
            environment: {
                sys: {
                id: 'sandbox',
                type: 'Link',
                linkType: 'Environment'
                }
            },
            publishedVersion: 12,
            revision: 3,
            locale: 'en-US'
            },
            fields: {
            title: 'Instagram Icon',
            description: '',
            file: {
                url: instagramLogo,
                details: {
                size: 1371,
                image: {
                    width: 82,
                    height: 82
                }
                },
                fileName: 'Instagram.png',
                contentType: 'image/png'
            }
            }
        }
        }
    },
    {
        metadata: {
        tags: [],
        concepts: []
        },
        sys: {
        space: {
            sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'n9bebhw263o0'
            }
        },
        id: '4dIvlvBfuddSktPqDMnc6X',
        type: 'Entry',
        createdAt: '2023-05-30T18:50:43.985Z',
        updatedAt: '2023-05-30T18:54:24.749Z',
        environment: {
            sys: {
            id: 'sandbox',
            type: 'Link',
            linkType: 'Environment'
            }
        },
        publishedVersion: 6,
        revision: 2,
        contentType: {
            sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'socialLink'
            }
        },
        locale: 'en-US'
        },
        fields: {
        title: 'LinkedIn SocialLink',
        link: {
            metadata: {
            tags: [],
            concepts: []
            },
            sys: {
            space: {
                sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'n9bebhw263o0'
                }
            },
            id: '4CcCib7VOG8u510FaBuJH2',
            type: 'Entry',
            createdAt: '2021-12-17T18:34:03.109Z',
            updatedAt: '2021-12-17T18:34:03.109Z',
            environment: {
                sys: {
                id: 'sandbox',
                type: 'Link',
                linkType: 'Environment'
                }
            },
            publishedVersion: 4,
            revision: 1,
            contentType: {
                sys: {
                type: 'Link',
                linkType: 'ContentType',
                id: 'externalLink'
                }
            },
            locale: 'en-US'
            },
            fields: {
            title: 'LinkedIn Link',
            label: 'LinkedIn',
            url: 'https://www.linkedin.com/company/modernatx/'
            }
        },
        icon: {
            metadata: {
            tags: [],
            concepts: []
            },
            sys: {
            space: {
                sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'n9bebhw263o0'
                }
            },
            id: 'B4aH3BNhpu7HiKPUoZ5RE',
            type: 'Asset',
            createdAt: '2022-10-28T17:39:46.023Z',
            updatedAt: '2022-12-15T22:23:11.303Z',
            environment: {
                sys: {
                id: 'sandbox',
                type: 'Link',
                linkType: 'Environment'
                }
            },
            publishedVersion: 11,
            revision: 4,
            locale: 'en-US'
            },
            fields: {
            title: 'LinkedIn Icon',
            description: '',
            file: {
                url: linkedInLogo,
                details: {
                size: 946,
                image: {
                    width: 82,
                    height: 82
                }
                },
                fileName: 'LinkedIn.png',
                contentType: 'image/png'
            }
            }
        }
        }
    }
    ],
    footerGroups: [
    {
        subHeading: 'Useful Links',
        label: [
        'Authorized Distributors',
        'Participating Physician Buying Groups',
        'Frequently Asked Questions ',
        'Contact Us',
        'Wholesale Acquisition Cost (CO, CT)',
        'DSCSA Compliance'
        ],
        footerGroupLinks: [
        'authorized-distributor',
        'participating-physician-buying-groups',
        'faqs',
        'contact-us',
        'wac-disclosure',
        'dscsa'
        ]
    },
    {
        subHeading: 'TOOLS & RESOURCES',
        label: [
        'Billing Codes',
        'Tax Exemption Certificate Submission',
        'About Moderna',
        'Newsroom'
        ],
        footerGroupLinks: [
        {
            metadata: {
            tags: [],
            concepts: []
            },
            sys: {
            space: {
                sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'n9bebhw263o0'
                }
            },
            id: '1ZmT8sH6NncPudYT0c4LmS',
            type: 'Entry',
            createdAt: '2023-09-28T21:54:15.576Z',
            updatedAt: '2023-09-28T21:54:15.576Z',
            environment: {
                sys: {
                id: 'sandbox',
                type: 'Link',
                linkType: 'Environment'
                }
            },
            publishedVersion: 3,
            revision: 1,
            contentType: {
                sys: {
                type: 'Link',
                linkType: 'ContentType',
                id: 'externalLink'
                }
            },
            locale: 'en-US'
            },
            fields: {
            title: 'Billing Codes',
            label: 'Billing Codes',
            url: 'https://reimbursement.modernatx.com/'
            }
        },
        {
            metadata: {
            tags: [],
            concepts: []
            },
            sys: {
            space: {
                sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'n9bebhw263o0'
                }
            },
            id: '1vB7kKEXkvSAkiklEh9av3',
            type: 'Entry',
            createdAt: '2023-09-28T21:54:49.933Z',
            updatedAt: '2023-09-28T21:54:49.933Z',
            environment: {
                sys: {
                id: 'sandbox',
                type: 'Link',
                linkType: 'Environment'
                }
            },
            publishedVersion: 3,
            revision: 1,
            contentType: {
                sys: {
                type: 'Link',
                linkType: 'ContentType',
                id: 'externalLink'
                }
            },
            locale: 'en-US'
            },
            fields: {
            title: 'Tax Exemption Certificate Submission',
            label: 'Tax Exemption Certificate Submission',
            url: 'https://taxform.modernatx.com/'
            }
        },
        {
            metadata: {
            tags: [],
            concepts: []
            },
            sys: {
            space: {
                sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'n9bebhw263o0'
                }
            },
            id: 'UISRXQn7QcXzQLw1GvBoS',
            type: 'Entry',
            createdAt: '2021-12-08T16:51:05.258Z',
            updatedAt: '2023-09-29T19:13:01.658Z',
            environment: {
                sys: {
                id: 'sandbox',
                type: 'Link',
                linkType: 'Environment'
                }
            },
            publishedVersion: 6,
            revision: 2,
            contentType: {
                sys: {
                type: 'Link',
                linkType: 'ContentType',
                id: 'externalLink'
                }
            },
            locale: 'en-US'
            },
            fields: {
            title: 'About Moderna Link',
            label: 'About Moderna',
            url: 'https://www.modernatx.com/about-us'
            }
        },
        {
            metadata: {
            tags: [],
            concepts: []
            },
            sys: {
            space: {
                sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'n9bebhw263o0'
                }
            },
            id: '7Das3oZCXBETxaKdXELgve',
            type: 'Entry',
            createdAt: '2021-12-15T18:57:35.795Z',
            updatedAt: '2024-06-04T18:31:16.404Z',
            environment: {
                sys: {
                id: 'sandbox',
                type: 'Link',
                linkType: 'Environment'
                }
            },
            publishedVersion: 10,
            revision: 4,
            contentType: {
                sys: {
                type: 'Link',
                linkType: 'ContentType',
                id: 'externalLink'
                }
            },
            locale: 'en-US'
            },
            fields: {
            title: 'Newsroom Link',
            label: 'Newsroom',
            url: 'https://www.modernatx.com/en-US/newsroom/news-and-media-2024'
            }
        }
        ]
    }
    ],
    footerLinks: [
    {
        metadata: {
        tags: [],
        concepts: []
        },
        sys: {
        space: {
            sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'n9bebhw263o0'
            }
        },
        id: '556dZCOMwLIKu69guk6x42',
        type: 'Entry',
        createdAt: '2022-12-02T04:18:56.045Z',
        updatedAt: '2022-12-02T04:18:56.045Z',
        environment: {
            sys: {
            id: 'sandbox',
            type: 'Link',
            linkType: 'Environment'
            }
        },
        publishedVersion: 6,
        revision: 1,
        contentType: {
            sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'internalLink'
            }
        },
        locale: 'en-US'
        },
        fields: {
        title: 'Privacy Policy Internal Link',
        label: 'Privacy Policy',
        pageReference: {
            metadata: {
            tags: [],
            concepts: []
            },
            sys: {
            space: {
                sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'n9bebhw263o0'
                }
            },
            id: 'EW4a3Hd56gtuvG9WpsS3Z',
            type: 'Entry',
            createdAt: '2022-12-02T04:18:46.677Z',
            updatedAt: '2022-12-02T04:18:46.677Z',
            environment: {
                sys: {
                id: 'sandbox',
                type: 'Link',
                linkType: 'Environment'
                }
            },
            publishedVersion: 10,
            revision: 1,
            contentType: {
                sys: {
                type: 'Link',
                linkType: 'ContentType',
                id: 'page'
                }
            },
            locale: 'en-US'
            },
            fields: {
            name: 'Privacy Policy',
            title: 'Moderna Direct Privacy Policy',
            slug: 'privacy-policy',
            seo: {
                metadata: {
                tags: [],
                concepts: []
                },
                sys: {
                space: {
                    sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'n9bebhw263o0'
                    }
                },
                id: '5wVt4P86v56AQIbQiW4uqD',
                type: 'Entry',
                createdAt: '2022-12-02T04:18:46.768Z',
                updatedAt: '2022-12-02T04:18:46.768Z',
                environment: {
                    sys: {
                    id: 'sandbox',
                    type: 'Link',
                    linkType: 'Environment'
                    }
                },
                publishedVersion: 4,
                revision: 1,
                contentType: {
                    sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'seo'
                    }
                },
                locale: 'en-US'
                },
                fields: {
                name: 'Privacy Policy - Compose: SEO'
                }
            },
            content: {
                metadata: {
                tags: [],
                concepts: []
                },
                sys: {
                space: {
                    sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'n9bebhw263o0'
                    }
                },
                id: '3LQ4u17dvJworzbcVeWMD',
                type: 'Entry',
                createdAt: '2022-12-02T04:18:46.882Z',
                updatedAt: '2023-06-20T16:20:31.348Z',
                environment: {
                    sys: {
                    id: 'sandbox',
                    type: 'Link',
                    linkType: 'Environment'
                    }
                },
                publishedVersion: 14,
                revision: 4,
                contentType: {
                    sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'richTextContentPageTemplate'
                    }
                },
                locale: 'en-US'
                },
                fields: {
                name: 'Privacy Policy - Rich Text Content Page Template',
                modules: [
                    {
                    metadata: {
                        tags: [],
                        concepts: []
                    },
                    sys: {
                        space: {
                        sys: {
                            type: 'Link',
                            linkType: 'Space',
                            id: 'n9bebhw263o0'
                        }
                        },
                        id: '4qpojknXqxo8gNLhMxZz5K',
                        type: 'Entry',
                        createdAt: '2022-12-11T23:10:53.907Z',
                        updatedAt: '2023-06-16T18:23:32.364Z',
                        environment: {
                        sys: {
                            id: 'sandbox',
                            type: 'Link',
                            linkType: 'Environment'
                        }
                        },
                        publishedVersion: 7,
                        revision: 2,
                        contentType: {
                        sys: {
                            type: 'Link',
                            linkType: 'ContentType',
                            id: 'bannerComponent'
                        }
                        },
                        locale: 'en-US'
                    },
                    fields: {
                        title: 'Privacy Statement Banner Component',
                        headline: 'Moderna\'s Privacy Statement',
                        backgroundImage: {
                        metadata: {
                            tags: [],
                            concepts: []
                        },
                        sys: {
                            space: {
                            sys: {
                                type: 'Link',
                                linkType: 'Space',
                                id: 'n9bebhw263o0'
                            }
                            },
                            id: '5zfGJA7or5WGcLdYi4Qde',
                            type: 'Asset',
                            createdAt: '2022-10-28T18:53:29.208Z',
                            updatedAt: '2022-10-28T18:53:29.208Z',
                            environment: {
                            sys: {
                                id: 'sandbox',
                                type: 'Link',
                                linkType: 'Environment'
                            }
                            },
                            publishedVersion: 6,
                            revision: 1,
                            locale: 'en-US'
                        },
                        fields: {
                            title: 'Banner BG Strand Top',
                            description: '',
                            file: {
                            url: '//images.ctfassets.net/n9bebhw263o0/5zfGJA7or5WGcLdYi4Qde/08c261eaf574cefa50f8fe8609ff531d/Banner_BG_Strand_Top_.png',
                            details: {
                                size: 47693,
                                image: {
                                width: 1920,
                                height: 511
                                }
                            },
                            fileName: 'Banner BG Strand Top .png',
                            contentType: 'image/png'
                            }
                        }
                        },
                        country: {
                        metadata: {
                            tags: [],
                            concepts: []
                        },
                        sys: {
                            space: {
                            sys: {
                                type: 'Link',
                                linkType: 'Space',
                                id: 'n9bebhw263o0'
                            }
                            },
                            id: '7sht7920U6vs3CLH2CUyaa',
                            type: 'Entry',
                            createdAt: '2023-05-18T03:23:50.744Z',
                            updatedAt: '2023-05-24T22:55:23.250Z',
                            environment: {
                            sys: {
                                id: 'sandbox',
                                type: 'Link',
                                linkType: 'Environment'
                            }
                            },
                            publishedVersion: 6,
                            revision: 2,
                            contentType: {
                            sys: {
                                type: 'Link',
                                linkType: 'ContentType',
                                id: 'country'
                            }
                            },
                            locale: 'en-US'
                        },
                        fields: {
                            name: 'United States',
                            isocode: 'US',
                            flag: {
                            metadata: {
                                tags: [],
                                concepts: []
                            },
                            sys: {
                                space: {
                                sys: {
                                    type: 'Link',
                                    linkType: 'Space',
                                    id: 'n9bebhw263o0'
                                }
                                },
                                id: '3aYCbZJiL8aoEKRdhjOXyy',
                                type: 'Asset',
                                createdAt: '2023-05-24T22:54:50.939Z',
                                updatedAt: '2023-05-24T22:54:50.939Z',
                                environment: {
                                sys: {
                                    id: 'sandbox',
                                    type: 'Link',
                                    linkType: 'Environment'
                                }
                                },
                                publishedVersion: 5,
                                revision: 1,
                                locale: 'en-US'
                            },
                            fields: {
                                title: 'usa flag',
                                description: 'USA Flag',
                                file: {
                                url: '//images.ctfassets.net/n9bebhw263o0/3aYCbZJiL8aoEKRdhjOXyy/f69a6f932a690dc632e7742c328c276d/usa_flag.svg',
                                details: {
                                    size: 2487,
                                    image: {
                                    width: 36,
                                    height: 26
                                    }
                                },
                                fileName: 'usa_flag.svg',
                                contentType: 'image/svg+xml'
                                }
                            }
                            },
                            locales: [
                            'en-US'
                            ]
                        }
                        }
                    }
                    },
                    {
                    metadata: {
                        tags: [],
                        concepts: []
                    },
                    sys: {
                        space: {
                        sys: {
                            type: 'Link',
                            linkType: 'Space',
                            id: 'n9bebhw263o0'
                        }
                        },
                        id: '3OFyHSrhG9cqdAH1JtdQcK',
                        type: 'Entry',
                        createdAt: '2023-06-16T18:25:11.324Z',
                        updatedAt: '2023-06-16T18:25:11.324Z',
                        environment: {
                        sys: {
                            id: 'sandbox',
                            type: 'Link',
                            linkType: 'Environment'
                        }
                        },
                        publishedVersion: 3,
                        revision: 1,
                        contentType: {
                        sys: {
                            type: 'Link',
                            linkType: 'ContentType',
                            id: 'bannerComponent'
                        }
                        },
                        locale: 'en-US'
                    },
                    fields: {
                        title: 'Privacy Statement Banner Component - DE',
                        headline: 'Moderna\'s Privacy Statement',
                        backgroundImage: {
                        metadata: {
                            tags: [],
                            concepts: []
                        },
                        sys: {
                            space: {
                            sys: {
                                type: 'Link',
                                linkType: 'Space',
                                id: 'n9bebhw263o0'
                            }
                            },
                            id: '5zfGJA7or5WGcLdYi4Qde',
                            type: 'Asset',
                            createdAt: '2022-10-28T18:53:29.208Z',
                            updatedAt: '2022-10-28T18:53:29.208Z',
                            environment: {
                            sys: {
                                id: 'sandbox',
                                type: 'Link',
                                linkType: 'Environment'
                            }
                            },
                            publishedVersion: 6,
                            revision: 1,
                            locale: 'en-US'
                        },
                        fields: {
                            title: 'Banner BG Strand Top',
                            description: '',
                            file: {
                            url: '//images.ctfassets.net/n9bebhw263o0/5zfGJA7or5WGcLdYi4Qde/08c261eaf574cefa50f8fe8609ff531d/Banner_BG_Strand_Top_.png',
                            details: {
                                size: 47693,
                                image: {
                                width: 1920,
                                height: 511
                                }
                            },
                            fileName: 'Banner BG Strand Top .png',
                            contentType: 'image/png'
                            }
                        }
                        },
                        country: {
                        metadata: {
                            tags: [],
                            concepts: []
                        },
                        sys: {
                            space: {
                            sys: {
                                type: 'Link',
                                linkType: 'Space',
                                id: 'n9bebhw263o0'
                            }
                            },
                            id: '7DX7badGk41XRSy4znPNFI',
                            type: 'Entry',
                            createdAt: '2023-05-18T03:24:01.186Z',
                            updatedAt: '2023-05-24T23:04:52.125Z',
                            environment: {
                            sys: {
                                id: 'sandbox',
                                type: 'Link',
                                linkType: 'Environment'
                            }
                            },
                            publishedVersion: 5,
                            revision: 2,
                            contentType: {
                            sys: {
                                type: 'Link',
                                linkType: 'ContentType',
                                id: 'country'
                            }
                            },
                            locale: 'en-US'
                        },
                        fields: {
                            name: 'Germany',
                            isocode: 'DE',
                            flag: {
                            metadata: {
                                tags: [],
                                concepts: []
                            },
                            sys: {
                                space: {
                                sys: {
                                    type: 'Link',
                                    linkType: 'Space',
                                    id: 'n9bebhw263o0'
                                }
                                },
                                id: '1PJ5nPASFqJbHZkqrkOloj',
                                type: 'Asset',
                                createdAt: '2023-05-24T23:04:44.544Z',
                                updatedAt: '2023-05-24T23:04:44.544Z',
                                environment: {
                                sys: {
                                    id: 'sandbox',
                                    type: 'Link',
                                    linkType: 'Environment'
                                }
                                },
                                publishedVersion: 5,
                                revision: 1,
                                locale: 'en-US'
                            },
                            fields: {
                                title: 'Germany Flag',
                                description: 'Germany Flag',
                                file: {
                                url: '//images.ctfassets.net/n9bebhw263o0/1PJ5nPASFqJbHZkqrkOloj/586177dc5c2d17ea76a41a972053c188/de_flag.svg',
                                details: {
                                    size: 1305,
                                    image: {
                                    width: 36,
                                    height: 26
                                    }
                                },
                                fileName: 'de_flag.svg',
                                contentType: 'image/svg+xml'
                                }
                            }
                            },
                            locales: [
                            'en-DE'
                            ]
                        }
                        }
                    }
                    },
                    {
                    metadata: {
                        tags: [],
                        concepts: []
                    },
                    sys: {
                        space: {
                        sys: {
                            type: 'Link',
                            linkType: 'Space',
                            id: 'n9bebhw263o0'
                        }
                        },
                        id: 'I5IZLNooED1CgxC5Kpr9Z',
                        type: 'Entry',
                        createdAt: '2022-12-11T01:44:45.550Z',
                        updatedAt: '2024-07-10T14:10:03.932Z',
                        environment: {
                        sys: {
                            id: 'sandbox',
                            type: 'Link',
                            linkType: 'Environment'
                        }
                        },
                        publishedVersion: 386,
                        revision: 22,
                        contentType: {
                        sys: {
                            type: 'Link',
                            linkType: 'ContentType',
                            id: 'richTextContentComponent'
                        }
                        },
                        locale: 'en-US'
                    },
                    fields: {
                        title: 'Privacy Policy Rich Text Content Component - US',
                        effectiveDateLabel: 'Effective',
                        effectiveDate: '2023-09-01',
                        content: {
                        nodeType: 'document',
                        data: {},
                        content: [
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'This Privacy Statement describes how Moderna Inc. and its worldwide affiliates (“Moderna”, “we”, “our” or “us”) describes how Moderna collects, stores, uses (“processes) your personal data when you:',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'unordered-list',
                            data: {},
                            content: [
                                {
                                nodeType: 'list-item',
                                data: {},
                                content: [
                                    {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                        nodeType: 'text',
                                        value: 'use our website ',
                                        marks: [],
                                        data: {}
                                        },
                                        {
                                        nodeType: 'hyperlink',
                                        data: {
                                            uri: 'https://www.modernatx.com/'
                                        },
                                        content: [
                                            {
                                            nodeType: 'text',
                                            value: 'www.modernatx.com',
                                            marks: [],
                                            data: {}
                                            }
                                        ]
                                        },
                                        {
                                        nodeType: 'text',
                                        value: ' or any other Moderna website that links to this statement;',
                                        marks: [],
                                        data: {}
                                        }
                                    ]
                                    }
                                ]
                                },
                                {
                                nodeType: 'list-item',
                                data: {},
                                content: [
                                    {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                        nodeType: 'text',
                                        value: 'use any of our other digital services, such as an app provided by Moderna, that link or use this statement; or',
                                        marks: [],
                                        data: {}
                                        }
                                    ]
                                    }
                                ]
                                },
                                {
                                nodeType: 'list-item',
                                data: {},
                                content: [
                                    {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                        nodeType: 'text',
                                        value: 'engage with us through our call centers.',
                                        marks: [],
                                        data: {}
                                        }
                                    ]
                                    }
                                ]
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: '“',
                                marks: [],
                                data: {}
                                },
                                {
                                nodeType: 'text',
                                value: 'Personal Data” ',
                                marks: [
                                    {
                                    type: 'italic'
                                    }
                                ],
                                data: {}
                                },
                                {
                                nodeType: 'text',
                                value: 'means information associated with or used to directly or indirectly identify or contact a specific person. Such data can include your name, contact details, relationship with Moderna, etc.',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'Certain Personal Data, such as information about health or medical status (pursuant to all applicable laws) are characterized as sensitive (collectively, “',
                                marks: [],
                                data: {}
                                },
                                {
                                nodeType: 'text',
                                value: 'Sensitive Personal Data',
                                marks: [
                                    {
                                    type: 'italic'
                                    }
                                ],
                                data: {}
                                },
                                {
                                nodeType: 'text',
                                value: '”) and may be subject to stricter regulation and consent requirements than other information.',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'Moderna recognizes the importance of taking steps to protect the privacy of information we collect, and we are committed to respecting your privacy.',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'Carefully read this Privacy Statement to learn more about how we collect, use, disclose and store personal data provided and the steps we take to help protect the often-sensitive personal data provided from unauthorized use or disclosure. When you submit information to or through our sites or services, you consent to the collection, processing and retention of your information as described in this Privacy Statement.',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'IF YOU DO NOT AGREE WITH ANY PART OF THIS PRIVACY STATEMENT, THEN PLEASE DO NOT USE ANY OF THESE SERVICES.',
                                marks: [
                                    {
                                    type: 'bold'
                                    }
                                ],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'Summary of Key Points',
                                marks: [
                                    {
                                    type: 'bold'
                                    }
                                ],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'This summary provides key points from our Privacy Statement, but you can find more information about any of these topics by using the Table of Contents below. ',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: '1. How do we process your personal data?',
                                marks: [
                                    {
                                    type: 'bold'
                                    }
                                ],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'We process your personal data to provide you with the service requested and to improve our service, communicate with you for security purposes and comply with legal obligations. We only process your personal data when we have legal grounds to do so. Please see ',
                                marks: [],
                                data: {}
                                },
                                {
                                nodeType: 'hyperlink',
                                data: {
                                    uri: 'https://www.modernatx.com/en-US/privacy-statement#united-states-privacy-statement-4-how-we-use-personal-data'
                                },
                                content: [
                                    {
                                    nodeType: 'text',
                                    value: 'How We Use Your Personal Data',
                                    marks: [],
                                    data: {}
                                    }
                                ]
                                },
                                {
                                nodeType: 'text',
                                value: ' for more details.',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: '2. Do we process sensitive personal data?',
                                marks: [
                                    {
                                    type: 'bold'
                                    }
                                ],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'We may process sensitive personal data when necessary, with your consent or where required by legal obligations. Click ',
                                marks: [],
                                data: {}
                                },
                                {
                                nodeType: 'hyperlink',
                                data: {
                                    uri: 'https://www.modernatx.com/en-US/privacy-statement#united-states-privacy-statement-1'
                                },
                                content: [
                                    {
                                    nodeType: 'text',
                                    value: 'here',
                                    marks: [],
                                    data: {}
                                    }
                                ]
                                },
                                {
                                nodeType: 'text',
                                value: ' to learn more about Sensitive Personal Data.',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: '3. Where will your data be processed by Moderna?',
                                marks: [
                                    {
                                    type: 'bold'
                                    }
                                ],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'Moderna is a global company which maintains datacenters around the world, including Switzerland and the United States (ModernaTX’s global headquarters). Moderna may process personal data in databases that can be accessed by authorized Moderna personnel worldwide.Transfers of personal data among Moderna and its worldwide affiliates follow applicable laws and our Intracompany Transfer Agreements.Third-party transfers outside of the EU, the EEA, Switzerland or the UK are made in accordance with applicable privacy laws and pursuant to the following safeguard, Standard Contractual Clauses (SCCs) or Model Contracts.',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'unordered-list',
                            data: {},
                            content: [
                                {
                                nodeType: 'list-item',
                                data: {},
                                content: [
                                    {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                        nodeType: 'text',
                                        value: 'For information on SCCs, please visit:',
                                        marks: [],
                                        data: {}
                                        }
                                    ]
                                    },
                                    {
                                    nodeType: 'unordered-list',
                                    data: {},
                                    content: [
                                        {
                                        nodeType: 'list-item',
                                        data: {},
                                        content: [
                                            {
                                            nodeType: 'paragraph',
                                            data: {},
                                            content: [
                                                {
                                                nodeType: 'text',
                                                value: 'If in EU:',
                                                marks: [],
                                                data: {}
                                                }
                                            ]
                                            },
                                            {
                                            nodeType: 'paragraph',
                                            data: {},
                                            content: [
                                                {
                                                nodeType: 'text',
                                                value: '',
                                                marks: [],
                                                data: {}
                                                },
                                                {
                                                nodeType: 'hyperlink',
                                                data: {
                                                    uri: 'http://ec.europa.eu/justice/data-protection/international-transfers/transfer/index_en.htm'
                                                },
                                                content: [
                                                    {
                                                    nodeType: 'text',
                                                    value: 'http://ec.europa.eu/justice/data-protection/international-transfers/transfer/index_en.htm',
                                                    marks: [],
                                                    data: {}
                                                    }
                                                ]
                                                },
                                                {
                                                nodeType: 'text',
                                                value: '',
                                                marks: [],
                                                data: {}
                                                }
                                            ]
                                            }
                                        ]
                                        },
                                        {
                                        nodeType: 'list-item',
                                        data: {},
                                        content: [
                                            {
                                            nodeType: 'paragraph',
                                            data: {},
                                            content: [
                                                {
                                                nodeType: 'text',
                                                value: 'If in Switzerland:',
                                                marks: [],
                                                data: {}
                                                }
                                            ]
                                            },
                                            {
                                            nodeType: 'paragraph',
                                            data: {},
                                            content: [
                                                {
                                                nodeType: 'text',
                                                value: '',
                                                marks: [],
                                                data: {}
                                                },
                                                {
                                                nodeType: 'hyperlink',
                                                data: {
                                                    uri: 'https://www.edoeb.admin.ch/edoeb/de/home/datenschutz/handel-und-wirtschaft/uebermittlung-ins-ausland.html#-291511647'
                                                },
                                                content: [
                                                    {
                                                    nodeType: 'text',
                                                    value: 'https://www.edoeb.admin.ch/edoeb/de/home/datenschutz/handel-und-wirtschaft/uebermittlung-ins-ausland.html#-291511647',
                                                    marks: [],
                                                    data: {}
                                                    }
                                                ]
                                                },
                                                {
                                                nodeType: 'text',
                                                value: '',
                                                marks: [],
                                                data: {}
                                                }
                                            ]
                                            }
                                        ]
                                        },
                                        {
                                        nodeType: 'list-item',
                                        data: {},
                                        content: [
                                            {
                                            nodeType: 'paragraph',
                                            data: {},
                                            content: [
                                                {
                                                nodeType: 'text',
                                                value: 'If In UK:',
                                                marks: [],
                                                data: {}
                                                }
                                            ]
                                            },
                                            {
                                            nodeType: 'paragraph',
                                            data: {},
                                            content: [
                                                {
                                                nodeType: 'text',
                                                value: '',
                                                marks: [],
                                                data: {}
                                                },
                                                {
                                                nodeType: 'hyperlink',
                                                data: {
                                                    uri: 'https://ico.org.uk/for-organisations/guide-to-data-protection/guide-to-the-general-data-protection-regulation-gdpr/international-transfers-after-uk-exit'
                                                },
                                                content: [
                                                    {
                                                    nodeType: 'text',
                                                    value: 'https://ico.org.uk/for-organisations/guide-to-data-protection/guide-to-the-general-data-protection-regulation-gdpr/international-transfers-after-uk-exit',
                                                    marks: [],
                                                    data: {}
                                                    }
                                                ]
                                                },
                                                {
                                                nodeType: 'text',
                                                value: '',
                                                marks: [],
                                                data: {}
                                                }
                                            ]
                                            }
                                        ]
                                        }
                                    ]
                                    }
                                ]
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: '4. When and with who do we share your data?',
                                marks: [
                                    {
                                    type: 'bold'
                                    }
                                ],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'We only will share your data with services providers who support our operations and other parties and business partners in limited circumstances based on legal obligations and as identified in our Privacy Notices.',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: '5. How do we keep your data protected?',
                                marks: [
                                    {
                                    type: 'bold'
                                    }
                                ],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'We have technical and organizational safeguards in place to protect your personal data. However, no electronic processing can be guaranteed to be 100% secure, so we cannot promise that hackers, cybercriminals or other unauthorized third parties will not be able to defeat our security and steal or unauthorized access your personal data. Click ',
                                marks: [],
                                data: {}
                                },
                                {
                                nodeType: 'hyperlink',
                                data: {
                                    uri: 'https://www.modernatx.com/en-US/privacy-statement#united-states-privacy-statement-6-how-information-is-retained-and-secured'
                                },
                                content: [
                                    {
                                    nodeType: 'text',
                                    value: 'here',
                                    marks: [],
                                    data: {}
                                    }
                                ]
                                },
                                {
                                nodeType: 'text',
                                value: ' to learn more.',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: '6. What are your rights and how can you exercise them?',
                                marks: [
                                    {
                                    type: 'bold'
                                    }
                                ],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'Based on your location, applicable personal data protection laws provide you with certain rights regarding your personal data. You may exercise these rights by visiting our ',
                                marks: [],
                                data: {}
                                },
                                {
                                nodeType: 'hyperlink',
                                data: {
                                    uri: 'https://privacyportal.onetrust.com/webform/bd5eb8a9-9d4b-487d-be7b-36a09d769cc1/fa10399c-b928-423c-8494-5a5c6d72f95a'
                                },
                                content: [
                                    {
                                    nodeType: 'text',
                                    value: 'request web page',
                                    marks: [
                                        {
                                        type: 'bold'
                                        }
                                    ],
                                    data: {}
                                    }
                                ]
                                },
                                {
                                nodeType: 'text',
                                value: '.',
                                marks: [
                                    {
                                    type: 'bold'
                                    }
                                ],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'Please note that this Privacy Statement does not apply to information collected through third-party websites or services that you may access through third-party sites.',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'Data Controller:',
                                marks: [
                                    {
                                    type: 'italic'
                                    }
                                ],
                                data: {}
                                },
                                {
                                nodeType: 'text',
                                value: ' The controller of Personal Data collected under this Privacy Statement is ModernaTX, Inc.',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'This statement is organized into the following sections – please select your desired topic for further information.',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'Principles',
                                marks: [
                                    {
                                    type: 'bold'
                                    }
                                ],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'We will handle your Personal Data in accordance with applicable laws such as the General Data Protection Regulation (“GDPR”) in the European Union, the Act on the Protection of Personal data of Japan and the Personal data Act of South Korea. It is our goal to do the following:',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'unordered-list',
                            data: {},
                            content: [
                                {
                                nodeType: 'list-item',
                                data: {},
                                content: [
                                    {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                        nodeType: 'text',
                                        value: 'Process Personal Data lawfully, fairly and in a transparent manner.',
                                        marks: [],
                                        data: {}
                                        }
                                    ]
                                    }
                                ]
                                },
                                {
                                nodeType: 'list-item',
                                data: {},
                                content: [
                                    {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                        nodeType: 'text',
                                        value: 'Collect Personal Data for a specified, explicit and legitimate purpose, and only use it for the purposes for which it was originally collected.',
                                        marks: [],
                                        data: {}
                                        }
                                    ]
                                    }
                                ]
                                },
                                {
                                nodeType: 'list-item',
                                data: {},
                                content: [
                                    {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                        nodeType: 'text',
                                        value: 'Limit collection of Personal Data to the extent necessary in relation to the purpose for which it is processed.',
                                        marks: [],
                                        data: {}
                                        }
                                    ]
                                    }
                                ]
                                },
                                {
                                nodeType: 'list-item',
                                data: {},
                                content: [
                                    {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                        nodeType: 'text',
                                        value: 'Make reasonable efforts to ensure that your Personal Data is accurate and, where necessary, kept up to date.',
                                        marks: [],
                                        data: {}
                                        }
                                    ]
                                    }
                                ]
                                },
                                {
                                nodeType: 'list-item',
                                data: {},
                                content: [
                                    {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                        nodeType: 'text',
                                        value: 'Store Personal Data for no longer than is necessary for the purpose for which the Personal Data is processed.',
                                        marks: [],
                                        data: {}
                                        }
                                    ]
                                    }
                                ]
                                },
                                {
                                nodeType: 'list-item',
                                data: {},
                                content: [
                                    {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                        nodeType: 'text',
                                        value: 'Process Personal Data in a manner that provides adequate security and confidentiality.',
                                        marks: [],
                                        data: {}
                                        }
                                    ]
                                    }
                                ]
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'Our privacy practices are described in greater detail in the remainder of this Privacy Statement.',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'Table of Contents',
                                marks: [
                                    {
                                    type: 'bold'
                                    }
                                ],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: '1. Information We Collect\n2. How Information is Collected and Used\n3. Links to Other Websites/Services\n',
                                marks: [],
                                data: {}
                                },
                                {
                                nodeType: 'text',
                                value: '4. ',
                                marks: [],
                                data: {}
                                },
                                {
                                nodeType: 'text',
                                value: 'How We Use Personal Data\n5. How Information is Shared and Disclosed\n6. How Information is Retained and Secured\n7. Cookies and Similar Technologies\n8. Your Privacy Rights\n9. Our Children’s Policy\n10. Changes to This Privacy Statement\n11. Jurisdiction-Specific Privacy Information (',
                                marks: [],
                                data: {}
                                },
                                {
                                nodeType: 'text',
                                value: 'California, Nevada, EU/EEA, UK & Switzerland, Japan)',
                                marks: [
                                    {
                                    type: 'italic'
                                    }
                                ],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: '1. Information We Collect',
                                marks: [
                                    {
                                    type: 'bold'
                                    }
                                ],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'Depending on your interactions with us, we may collect and process your Personal Data. For example, you may choose to submit your contact information to join our mailing list, engage with us via our Contact Us features, or apply for a job opening with Moderna via the ',
                                marks: [],
                                data: {}
                                },
                                {
                                nodeType: 'hyperlink',
                                data: {
                                    uri: 'https://www.modernatx.com/careers/life-at-moderna'
                                },
                                content: [
                                    {
                                    nodeType: 'text',
                                    value: 'careers',
                                    marks: [],
                                    data: {}
                                    }
                                ]
                                },
                                {
                                nodeType: 'text',
                                value: ' section of our website. As a result, and depending on the type of Service, we may ask you to provide Personal Data, such as your:',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'unordered-list',
                            data: {},
                            content: [
                                {
                                nodeType: 'list-item',
                                data: {},
                                content: [
                                    {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                        nodeType: 'text',
                                        value: 'General identification data',
                                        marks: [
                                            {
                                            type: 'bold'
                                            }
                                        ],
                                        data: {}
                                        },
                                        {
                                        nodeType: 'text',
                                        value: ': initials, name, job title, company name, country, date of birth, age, country, ethnicity (',
                                        marks: [],
                                        data: {}
                                        },
                                        {
                                        nodeType: 'text',
                                        value: 'for cases where the Summary of Product Characteristics (SmPC) includes specific information relating to the ethnic origin',
                                        marks: [
                                            {
                                            type: 'italic'
                                            }
                                        ],
                                        data: {}
                                        },
                                        {
                                        nodeType: 'text',
                                        value: ')',
                                        marks: [],
                                        data: {}
                                        }
                                    ]
                                    }
                                ]
                                },
                                {
                                nodeType: 'list-item',
                                data: {},
                                content: [
                                    {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                        nodeType: 'text',
                                        value: 'Contact details',
                                        marks: [
                                            {
                                            type: 'bold'
                                            }
                                        ],
                                        data: {}
                                        },
                                        {
                                        nodeType: 'text',
                                        value: ': contact number, e-mail address, mailing address',
                                        marks: [],
                                        data: {}
                                        }
                                    ]
                                    }
                                ]
                                },
                                {
                                nodeType: 'list-item',
                                data: {},
                                content: [
                                    {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                        nodeType: 'text',
                                        value: 'Product use',
                                        marks: [
                                            {
                                            type: 'bold'
                                            }
                                        ],
                                        data: {}
                                        },
                                        {
                                        nodeType: 'text',
                                        value: ': data related to your use of our products, including feedback and use history',
                                        marks: [],
                                        data: {}
                                        }
                                    ]
                                    }
                                ]
                                },
                                {
                                nodeType: 'list-item',
                                data: {},
                                content: [
                                    {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                        nodeType: 'text',
                                        value: 'Professional details (for HCPs)',
                                        marks: [
                                            {
                                            type: 'bold'
                                            }
                                        ],
                                        data: {}
                                        },
                                        {
                                        nodeType: 'text',
                                        value: ': job title, institute/organization name, additional information about your job role and any other job-related information',
                                        marks: [],
                                        data: {}
                                        }
                                    ]
                                    }
                                ]
                                },
                                {
                                nodeType: 'list-item',
                                data: {},
                                content: [
                                    {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                        nodeType: 'text',
                                        value: 'Technical data',
                                        marks: [
                                            {
                                            type: 'bold'
                                            }
                                        ],
                                        data: {}
                                        },
                                        {
                                        nodeType: 'text',
                                        value: ': IP address, device identifiers, operating system, browsing history, search history, time and duration of use, interaction with content',
                                        marks: [],
                                        data: {}
                                        }
                                    ]
                                    }
                                ]
                                },
                                {
                                nodeType: 'list-item',
                                data: {},
                                content: [
                                    {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                        nodeType: 'text',
                                        value: 'Information about your job role',
                                        marks: [
                                            {
                                            type: 'bold'
                                            }
                                        ],
                                        data: {}
                                        },
                                        {
                                        nodeType: 'text',
                                        value: ' and any other job-related information, work experience, educational background',
                                        marks: [],
                                        data: {}
                                        }
                                    ]
                                    }
                                ]
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'Before providing it to us, carefully consider whether to disclose your Sensitive Personal Data. If you do provide Sensitive Personal Data to us, you consent to its use and disclosure for the purposes and in the manner described in this Privacy Statement.',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'You may visit our website without voluntarily providing any information about yourself. You are not obligated to provide any Personal Data to us, but your ability to use our website or its features, apply for an employment position or report an adverse event may be limited. When calling our call centers, you can choose to remain anonymous unless the collection of personal data is required by law or you provide us with your personal data.',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'If you provide us with Personal Data about another person or allow us to collect it, you acknowledge that you have the authority to share that information and are allowing us to use the information as described in this Privacy Statement.',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'Ordering and Payment Information for Pharmacies and Healthcare Professionals',
                                marks: [
                                    {
                                    type: 'bold'
                                    }
                                ],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'When pharmacies and healthcare professionals place orders for our products and services, we collect and use necessary information to process these transactions. This includes, but is not limited to, payment details (such as credit card numbers and billing addresses), order information, and contact details of the ordering party. This information is used solely for the purposes of fulfilling orders, processing payments, and providing customer support. We are committed to protecting this data in compliance with all relevant privacy and data protection regulations and ensuring that it is handled securely and confidentially.',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: '2. How Information is Collected and Used',
                                marks: [
                                    {
                                    type: 'bold'
                                    }
                                ],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'a. Information that you voluntarily provide',
                                marks: [
                                    {
                                    type: 'bold'
                                    }
                                ],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'We collect and use the Personal Data that you voluntarily provide to us by visiting our sites or using our services. You may use certain services without registering or identifying yourself but, if you do not register, you may not have access to all of the services or functionality of the site. If you choose to register, we may use the Personal Data you provide to confirm your registration and to respond to requests from you.',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'Upon your request, we may also use your Personal Data to send you special promotions or newsletters with information that may interest you.',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'If you are a healthcare professional or an institutional healthcare provider, you are responsible for obtaining any legally required authorization, consent or other permission from your patients prior to providing their Personal Data to Moderna. By submitting any Personal Data about a patient, you represent and warrant to Moderna that you have obtained all required permissions to do so.',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'b. Through your use of interactive services',
                                marks: [
                                    {
                                    type: 'bold'
                                    }
                                ],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'If you choose to participate in our questionnaires and surveys and other interactive services, we will collect the information, including health-related information and other Sensitive Personal Data that you share to help us better understand how Moderna products are used in coping with the diseases for which they are marketed.',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'c. When you’re interested in enrolling in a clinical trial',
                                marks: [
                                    {
                                    type: 'bold'
                                    }
                                ],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'If you submit health-related Personal Data to us to participate in a clinical trial, we may use your Personal Data to assess whether you qualify for enrollment in the trial, to contact you about potential participation in the trial, and to provide you with additional information about the trial.Once enrolled for any questions relating to your participation in a clinical trial, contact the Principal Investigator on the study and/or refer to the trail related information provided to you, e.g., the Informed Consent Form.',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'd. When you correspond with Moderna about Moderna products.',
                                marks: [
                                    {
                                    type: 'bold'
                                    }
                                ],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'If you contact Moderna or use the Services to ask questions or report problems regarding your experience in using one of our products, we may use the information you provide in submitting reports to the U.S. Food and Drug Administration, the European Medicines Agency or any other relevant supervisory authority and as otherwise required of us by law. We also may use the information to contact the prescribing physician to follow up regarding an event involving use of our product.',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'e. Through data collection tools',
                                marks: [
                                    {
                                    type: 'bold'
                                    }
                                ],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'When permitted or you have provided consent, Moderna automatically will collect information about use of the Services through data collection tools, such as web beacons and cookies. A "web beacon" is a piece of code that enables us to monitor user activity and website traffic. A "cookie" is a randomly generated unique numeric code stored in the user’s web browser settings or computer’s hard drive. A cookie typically contains the name of the domain (internet location) from which the cookie originated, the “lifetime” of the cookie (i.e., when it expires), as well as the randomly generated unique numeric code.',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'For more details, please see ',
                                marks: [],
                                data: {}
                                },
                                {
                                nodeType: 'hyperlink',
                                data: {
                                    uri: 'https://www.modernatx.com/cookie-statement'
                                },
                                content: [
                                    {
                                    nodeType: 'text',
                                    value: 'Moderna’s Cookie Statement',
                                    marks: [
                                        {
                                        type: 'italic'
                                        }
                                    ],
                                    data: {}
                                    }
                                ]
                                },
                                {
                                nodeType: 'text',
                                value: '.',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'We use the information collected through data collection tools to monitor usage patterns, store information about user preferences and to improve the Services. For example, your Personal Data may be used to create customized offers, information and services tailored to your interests and preferences. We may track your activities over time and across third-party websites, apps or other online services to display advertisements on third-party websites. If you do not want us to use your information in this way, please see “Your Privacy Choices” below.',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'We also may collect information about the location of the mobile device or tablet used to access the Services (“Location Data”). Location Data includes: (i) the location of the mobile device or tablet derived from GPS or WiFi use; (ii) the IP address of the mobile device or tablet or internet service used to access the Services; and (iii) other information made available by a user or others that indicates the current or prior location of the user, such as geotag information in photographs.',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'f. Social media connections',
                                marks: [
                                    {
                                    type: 'bold'
                                    }
                                ],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'When accessing the Services through a Facebook or other Social Media account, Moderna may (depending on applicable user privacy settings) automatically have access to information provided to or through the Social Media platform. Moderna may collect and use this information for the purposes described in this Privacy Statement or at the time the information was collected.',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'g. Social media plugins',
                                marks: [
                                    {
                                    type: 'bold'
                                    }
                                ],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'When you use services, Social Media operators can place a cookie on your computer to recognize individuals who have visited previously. If you are logged into a Social Media account while using the services, the social plugins allow that Social Media to receive information that you have accessed and used the Services. The social plugins also allow the Social Media operator to share information about your activities in or through the Services with other Social Media users. Moderna does not control any of the content from the Social Media plugins. For more information about Social Media plugins, please refer to any privacy and/or other legal notices of the respective Social Media platform.',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'h. Through third parties',
                                marks: [
                                    {
                                    type: 'bold'
                                    }
                                ],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'Third parties that assist us with our business operations also collect and use information (including Personal Data and Usage Data) and may share the collected information with us. For example, our vendors collect and share information with us to improve user experience, we may view your LinkedIn profile, or any other publicly available profile.',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'When you access any interactive service, you will be asked to affirmatively choose ("opt in") to provide the requested information. You may always choose not to provide the requested information but then you may not be able to use the Service as intended.',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: '3. Links to Other Websites/Services',
                                marks: [
                                    {
                                    type: 'bold'
                                    }
                                ],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'As a convenience to our visitors, this website may contain links to other websites that we believe may offer useful information, but that does not mean that Moderna endorses it, or the quality or accuracy of information presented on it. If you decide to visit a third-party site, you are subject to its privacy practices and not this Privacy Statement.',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: '4. How We Use Personal Data',
                                marks: [
                                    {
                                    type: 'bold'
                                    }
                                ],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'We may use Personal Data for the following purposes.',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'a. Consent',
                                marks: [
                                    {
                                    type: 'bold'
                                    }
                                ],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'We may seek, either directly or through our trusted third parties, your separate consent to process your Personal Data, for example, to:',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'unordered-list',
                            data: {},
                            content: [
                                {
                                nodeType: 'list-item',
                                data: {},
                                content: [
                                    {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                        nodeType: 'text',
                                        value: 'provide you with information you requested and/or to respond to your inquiries submitted via the website, email and/or phone,',
                                        marks: [],
                                        data: {}
                                        }
                                    ]
                                    }
                                ]
                                },
                                {
                                nodeType: 'list-item',
                                data: {},
                                content: [
                                    {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                        nodeType: 'text',
                                        value: 'facilitate certain recruitment activities such as processing employment applications,',
                                        marks: [],
                                        data: {}
                                        }
                                    ]
                                    }
                                ]
                                },
                                {
                                nodeType: 'list-item',
                                data: {},
                                content: [
                                    {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                        nodeType: 'text',
                                        value: 'analyze and enhance our communications and strategies (including by identifying when emails sent to you have been received and read),',
                                        marks: [],
                                        data: {}
                                        }
                                    ]
                                    }
                                ]
                                },
                                {
                                nodeType: 'list-item',
                                data: {},
                                content: [
                                    {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                        nodeType: 'text',
                                        value: 'tailor the content we display on our website,',
                                        marks: [],
                                        data: {}
                                        }
                                    ]
                                    }
                                ]
                                },
                                {
                                nodeType: 'list-item',
                                data: {},
                                content: [
                                    {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                        nodeType: 'text',
                                        value: 'protect against, identify, investigate and respond to fraud, illegal activity (such as incidents of hacking or misuse of our website) and claims and other liabilities,',
                                        marks: [],
                                        data: {}
                                        }
                                    ]
                                    }
                                ]
                                },
                                {
                                nodeType: 'list-item',
                                data: {},
                                content: [
                                    {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                        nodeType: 'text',
                                        value: 'communicate with you for other purposes which are evident from the circumstances or about which we inform you when we collect Personal Data from you.',
                                        marks: [],
                                        data: {}
                                        }
                                    ]
                                    }
                                ]
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'If we have sought your consent to process your Personal Data, you may subsequently withdraw it at any time by contacting us at the address listed in the “',
                                marks: [],
                                data: {}
                                },
                                {
                                nodeType: 'hyperlink',
                                data: {
                                    uri: 'https://www.modernatx.com/en-US/privacy-statement#united-states-privacy-statement-8-your-privacy-rights'
                                },
                                content: [
                                    {
                                    nodeType: 'text',
                                    value: 'Your Privacy Rights',
                                    marks: [],
                                    data: {}
                                    }
                                ]
                                },
                                {
                                nodeType: 'text',
                                value: '” section below.',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'b. Legal obligation',
                                marks: [
                                    {
                                    type: 'bold'
                                    }
                                ],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'unordered-list',
                            data: {},
                            content: [
                                {
                                nodeType: 'list-item',
                                data: {},
                                content: [
                                    {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                        nodeType: 'text',
                                        value: 'We may be required by law or regulation to collect and process certain Personal Data about you. For example, we may be required to process certain Personal Data in relation to reporting of adverse events.',
                                        marks: [],
                                        data: {}
                                        }
                                    ]
                                    }
                                ]
                                },
                                {
                                nodeType: 'list-item',
                                data: {},
                                content: [
                                    {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                        nodeType: 'text',
                                        value: 'monitor the quality, safety and efficacy of our medicinal products, which includes detecting, assessing and preventing adverse events and reporting to the relevant health authorities to meet legal and regulatory obligations,',
                                        marks: [],
                                        data: {}
                                        }
                                    ]
                                    }
                                ]
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'Adverse events refer to the unintended or undesirable events after using a medicinal product. They can be minor at times, or they can also involve serious health issues.Moderna processes your Personal Data to comply with legal obligations under applicable pharmacovigilance laws and regulations worldwide and where necessary for our legitimate interests in ensuring appropriate pharmacovigilance standards.Pharmacovigilance laws are issued for reasons of substantial public interest in public health, research as well as quality, safety, and efficacy of medicinal products.',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'c. Public interest',
                                marks: [
                                    {
                                    type: 'bold'
                                    }
                                ],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'We may also process Personal Data to carry out scientific research in the public interest.',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'd. Our legitimate interests',
                                marks: [
                                    {
                                    type: 'bold'
                                    }
                                ],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'We may process your Personal Data where it is necessary for our legitimate interest as a company, including to manage, promote and improve our business and manage our risk. For example, we may process your Personal Data to:',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'unordered-list',
                            data: {},
                            content: [
                                {
                                nodeType: 'list-item',
                                data: {},
                                content: [
                                    {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                        nodeType: 'text',
                                        value: 'facilitate our recruitment activities (such as evaluating you as a job candidate for an employment activity, and monitoring our recruitment statistics),',
                                        marks: [],
                                        data: {}
                                        }
                                    ]
                                    }
                                ]
                                },
                                {
                                nodeType: 'list-item',
                                data: {},
                                content: [
                                    {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                        nodeType: 'text',
                                        value: 'tailor the content we display on our website,',
                                        marks: [],
                                        data: {}
                                        }
                                    ]
                                    }
                                ]
                                },
                                {
                                nodeType: 'list-item',
                                data: {},
                                content: [
                                    {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                        nodeType: 'text',
                                        value: 'protect against, identify, investigate and respond to fraud, illegal activity (such as incidents of hacking or misuse of our website) and claims and other liabilities,',
                                        marks: [],
                                        data: {}
                                        }
                                    ]
                                    }
                                ]
                                },
                                {
                                nodeType: 'list-item',
                                data: {},
                                content: [
                                    {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                        nodeType: 'text',
                                        value: 'help us comply with our legal or regulatory obligations or our contractual obligations to the U.S. government as a government contractor or other countries as applicable,',
                                        marks: [],
                                        data: {}
                                        }
                                    ]
                                    }
                                ]
                                },
                                {
                                nodeType: 'list-item',
                                data: {},
                                content: [
                                    {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                        nodeType: 'text',
                                        value: 'maintain the security, safety or property of the website, and',
                                        marks: [],
                                        data: {}
                                        }
                                    ]
                                    }
                                ]
                                },
                                {
                                nodeType: 'list-item',
                                data: {},
                                content: [
                                    {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                        nodeType: 'text',
                                        value: 'communicate with you for other purposes which are evident from the circumstances or about which we inform you when we collect Personal Data from you.',
                                        marks: [],
                                        data: {}
                                        }
                                    ]
                                    }
                                ]
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: '5. How Information is Shared and Disclosed',
                                marks: [
                                    {
                                    type: 'bold'
                                    }
                                ],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'We may share and disclose information as described at the time information is collected and as described below:',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'a. Service providers',
                                marks: [
                                    {
                                    type: 'bold'
                                    }
                                ],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'We may use third parties to perform services requested or functions initiated by users. In addition, we may disclose Personal Data to identify a user in connection with communications sent through our sites or services. We may also share information, including Personal Data, with our service providers to perform the functions for which we engage them, such as data analysis, system design and maintenance, customer services and for marketing and promotions. When permitted, we also may offer users the opportunity to share information with friends and other users through the Services.',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'b. Legal requirements',
                                marks: [
                                    {
                                    type: 'bold'
                                    }
                                ],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'In certain circumstances, Moderna may release your Personal Data in response to a court order, subpoena, search warrant, regulation, binding order of a data protection agency, governmental request or other legal or regulatory process. Moderna may disclose information if we believe disclosure is necessary or appropriate to protect the rights, property, or safety of Moderna or others.',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'c. Corporate changes',
                                marks: [
                                    {
                                    type: 'bold'
                                    }
                                ],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'We may transfer information, including your Personal data, in connection with a merger, sale, acquisition, divestiture, restructuring, reorganization, dissolution, bankruptcy or other change of ownership or control by Moderna or any affiliated company (in each case, whether in whole or in part). When one of these events occurs, Moderna will use reasonable efforts to notify users before information is transferred or becomes subject to different privacy practices.',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'd. Adverse Event reporting by patients',
                                marks: [
                                    {
                                    type: 'bold'
                                    }
                                ],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'We may disclose your Personal Data to HCPs, doctors, care givers, in connection with your adverse event report based on your consent or a legal obligation.',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: '6. How Information is Retained and Secured',
                                marks: [
                                    {
                                    type: 'bold'
                                    }
                                ],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'We retain information as long as it is necessary and relevant for our operations and in line with legal obligations. We retain Personal Data to comply with applicable law, prevent fraud, resolve disputes, troubleshoot problems, assist with any investigation, and other actions permitted by law. When your Personal Data is no longer needed for Moderna’s business purposes, we dispose of it subject to applicable law.',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'In accordance with applicable laws, we employ reasonable security measures intended to help protect the security of all information submitted through the Services. The security of information transmitted through the internet cannot, however, be guaranteed. We are not responsible for any interception or interruption of any communications or for changes to or losses of data through the internet. Users of our sites and services are responsible for maintaining the security of any password, user ID or other form of authentication involved in obtaining access to password protected or secure areas. Any access to our sites or services through your user ID and password will be treated as authorized by you.',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'To help protect your Personal Data, we may suspend your use, without notice, if Moderna suspects or detects any breach of security. Unauthorized access to such areas is prohibited and may lead to criminal prosecution.',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: '7. Cookies and Similar Technologies',
                                marks: [
                                    {
                                    type: 'bold'
                                    }
                                ],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'Moderna’s websites may use cookies and similar technologies. Please click here to read ',
                                marks: [],
                                data: {}
                                },
                                {
                                nodeType: 'hyperlink',
                                data: {
                                    uri: 'https://www.modernatx.com/cookie-statement'
                                },
                                content: [
                                    {
                                    nodeType: 'text',
                                    value: 'Moderna’s Cookie Statement',
                                    marks: [
                                        {
                                        type: 'italic'
                                        }
                                    ],
                                    data: {}
                                    }
                                ]
                                },
                                {
                                nodeType: 'text',
                                value: '.',
                                marks: [
                                    {
                                    type: 'italic'
                                    }
                                ],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: '8. Your Privacy Rights',
                                marks: [
                                    {
                                    type: 'bold'
                                    }
                                ],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'Moderna respects your rights related to the processing of your personal data. Depending on the applicable Data Protection Law you may have certain additional rights (see country-specific section below) and you will always have the below rights. You may exercise them by visiting our ',
                                marks: [],
                                data: {}
                                },
                                {
                                nodeType: 'hyperlink',
                                data: {
                                    uri: 'https://privacyportal.onetrust.com/webform/bd5eb8a9-9d4b-487d-be7b-36a09d769cc1/fa10399c-b928-423c-8494-5a5c6d72f95a'
                                },
                                content: [
                                    {
                                    nodeType: 'text',
                                    value: 'request web page',
                                    marks: [],
                                    data: {}
                                    }
                                ]
                                },
                                {
                                nodeType: 'text',
                                value: '.',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'a. Correct/update personal data',
                                marks: [
                                    {
                                    type: 'bold'
                                    }
                                ],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'You may correct or update the Personal data you previously provided to Moderna.',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'b. Receive marketing communications',
                                marks: [
                                    {
                                    type: 'bold'
                                    }
                                ],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'When you register for the services, you may request to receive emails containing information about Moderna you might find useful, including promotions, announcements of new services and products. If you decide, at any time, that you no longer wish to receive these emails you may unsubscribe from our email list by using the relevant “Unsubscribe” link within the respective electronic communications channel, or by contacting us at ',
                                marks: [],
                                data: {}
                                },
                                {
                                nodeType: 'hyperlink',
                                data: {
                                    uri: 'mailto:privacy@modernatx.com'
                                },
                                content: [
                                    {
                                    nodeType: 'text',
                                    value: 'privacy@modernatx.com',
                                    marks: [],
                                    data: {}
                                    }
                                ]
                                },
                                {
                                nodeType: 'text',
                                value: '.',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'IMPORTANT NOTE: Moderna cannot comply with a consumer\'s request to amend or remove information that was provided to Moderna by a healthcare professional or a consumer regarding an adverse drug event due to legal obligations.',
                                marks: [
                                    {
                                    type: 'italic'
                                    },
                                    {
                                    type: 'bold'
                                    }
                                ],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: '9. Our Children’s Policy',
                                marks: [
                                    {
                                    type: 'bold'
                                    }
                                ],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'Our sites are not intended for use by children. If you are under the age of majority in your place of residence, you may visit our site only with the consent of or under the supervision of your parent or legal guardian.',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'If you believe Moderna may have any information from or about a child, please contact our Privacy Office at ',
                                marks: [],
                                data: {}
                                },
                                {
                                nodeType: 'hyperlink',
                                data: {
                                    uri: 'mailto:privacy@modernatx.com'
                                },
                                content: [
                                    {
                                    nodeType: 'text',
                                    value: 'privacy@modernatx.com',
                                    marks: [],
                                    data: {}
                                    }
                                ]
                                },
                                {
                                nodeType: 'text',
                                value: '.',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: '10. Changes to This Privacy Statement',
                                marks: [
                                    {
                                    type: 'bold'
                                    }
                                ],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'We may change or update this Privacy Statement from time to time by publishing a new version on this website. When we do update this Statement, we will revise the “Last Updated” date at the top of this page. Your continued use of the services after the Effective Date constitutes your acceptance of the amended Privacy Statement. The amended Privacy Statement supersedes all previous versions.',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: '11. Jurisdiction-Specific Privacy Information',
                                marks: [
                                    {
                                    type: 'bold'
                                    }
                                ],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'California',
                                marks: [
                                    {
                                    type: 'bold'
                                    }
                                ],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'Privacy Rights',
                                marks: [
                                    {
                                    type: 'bold'
                                    }
                                ],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'If you are a California resident under age 18 and are a registered user of any of our services, then you may request that we remove any of your User Contributions you publicly posted on or in our services. ',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'To request removal of your User Contribution, please visit our ',
                                marks: [],
                                data: {}
                                },
                                {
                                nodeType: 'hyperlink',
                                data: {
                                    uri: 'https://privacyportal.onetrust.com/webform/bd5eb8a9-9d4b-487d-be7b-36a09d769cc1/fa10399c-b928-423c-8494-5a5c6d72f95a'
                                },
                                content: [
                                    {
                                    nodeType: 'text',
                                    value: 'request web page',
                                    marks: [],
                                    data: {}
                                    }
                                ]
                                },
                                {
                                nodeType: 'text',
                                value: ' (You also may be able to log in to your account and delete your own User Contribution.) Moderna reserves the right to request that you provide information that will enable us to confirm that the User Contribution that you want removed was created and posted by you.',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'Moderna will make a good faith effort to delete or remove your User Contribution from public view as soon as reasonably practicable. Please note, however, that your request that we delete your User Contribution does not ensure complete or comprehensive removal of your User Contribution. Your User Contribution may remain on backup media, cached or otherwise retained by Moderna for administrative or legal purposes, or your User Contribution may remain publicly available if you or someone else has forwarded or re-posted your User Contribution on another website or service prior to its deletion. Moderna may also be required by law to not remove (or allow removal) of your User Contribution.',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'California Civil Code Section 1798.83 permits individual California residents to request certain information regarding Moderna’s disclosure of personal data to third parties for their direct marketing purposes. To make such a request, please write or send an email to the address below.',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'California Consumer Privacy Act - Notice for California Residents',
                                marks: [
                                    {
                                    type: 'italic'
                                    },
                                    {
                                    type: 'bold'
                                    }
                                ],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'If you are a California resident, this Privacy Notice supplements the information above regarding the collection, use, and disclosure of your personal data. ',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'The California Consumer Privacy Act of 2018 (CCPA) gives California consumers the right to know what personal data is collected about them, how it will be used and to whom it is disclosed. California consumers may have the right to request access to and deletion of their personal data, and the right to request that their personal data not be sold to the extent applicable under the CCPA.',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'The purpose of this notice is to describe our practices regarding the collection, use, disclosure, and sale of personal data and instructions for submitting CCPA data privacy requests. Some of the Personal Data that we collect, use, and disclose may be exempt from the CCPA because it is regulated by other federal and state laws that apply to us.',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'We collect personal data from you when you interact with us online (through our Site, our other websites, Apps and Services) or offline (such as through your health care providers, if you are a patient, with your authorization as applicable.) The personal data we may collect from you will depend on the nature of our interaction with you, but can include the following categories that we have collected in the preceding twelve (12) months:',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'embedded-asset-block',
                            data: {
                                target: {
                                metadata: {
                                    tags: [],
                                    concepts: []
                                },
                                sys: {
                                    space: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'Space',
                                        id: 'n9bebhw263o0'
                                    }
                                    },
                                    id: '1vo5ULs91JROZ8CfAyGcpI',
                                    type: 'Asset',
                                    createdAt: '2024-07-10T13:58:26.978Z',
                                    updatedAt: '2024-07-10T13:58:26.978Z',
                                    environment: {
                                    sys: {
                                        id: 'sandbox',
                                        type: 'Link',
                                        linkType: 'Environment'
                                    }
                                    },
                                    publishedVersion: 5,
                                    revision: 1,
                                    locale: 'en-US'
                                },
                                fields: {
                                    title: 'Privacy Policy - Personal Data ',
                                    description: '',
                                    file: {
                                    url: '//images.ctfassets.net/n9bebhw263o0/1vo5ULs91JROZ8CfAyGcpI/82fd7d27ec4e2e10501a96f0158fdee7/image__4_.png',
                                    details: {
                                        size: 642894,
                                        image: {
                                        width: 1174,
                                        height: 2046
                                        }
                                    },
                                    fileName: 'image (4).png',
                                    contentType: 'image/png'
                                    }
                                }
                                }
                            },
                            content: []
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'Your Rights',
                                marks: [
                                    {
                                    type: 'italic'
                                    },
                                    {
                                    type: 'bold'
                                    }
                                ],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'California residents are provided specific rights subject to certain exceptions.',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'unordered-list',
                            data: {},
                            content: [
                                {
                                nodeType: 'list-item',
                                data: {},
                                content: [
                                    {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                        nodeType: 'text',
                                        value: 'The Right to Know. ',
                                        marks: [
                                            {
                                            type: 'italic'
                                            }
                                        ],
                                        data: {}
                                        },
                                        {
                                        nodeType: 'text',
                                        value: 'You have the right to request that we disclose what personal data we collect, use, disclose, and sell. The process for exercising this right is describe below under How to Submit a Data Privacy Request.',
                                        marks: [],
                                        data: {}
                                        }
                                    ]
                                    }
                                ]
                                },
                                {
                                nodeType: 'list-item',
                                data: {},
                                content: [
                                    {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                        nodeType: 'text',
                                        value: 'The Right to Deletion. ',
                                        marks: [
                                            {
                                            type: 'italic'
                                            }
                                        ],
                                        data: {}
                                        },
                                        {
                                        nodeType: 'text',
                                        value: 'You have the right to request deletion of any personal data about you that we have collected from you. The process for exercising this right is describe below under How to Submit a Data Privacy Request',
                                        marks: [],
                                        data: {}
                                        }
                                    ]
                                    }
                                ]
                                },
                                {
                                nodeType: 'list-item',
                                data: {},
                                content: [
                                    {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                        nodeType: 'text',
                                        value: 'The Right to Opt-Out. ',
                                        marks: [
                                            {
                                            type: 'italic'
                                            }
                                        ],
                                        data: {}
                                        },
                                        {
                                        nodeType: 'text',
                                        value: 'You have the right to opt-out of the sale of your personal data.',
                                        marks: [],
                                        data: {}
                                        }
                                    ]
                                    }
                                ]
                                },
                                {
                                nodeType: 'list-item',
                                data: {},
                                content: [
                                    {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                        nodeType: 'text',
                                        value: 'The Right to Non-Discrimination. ',
                                        marks: [
                                            {
                                            type: 'italic'
                                            }
                                        ],
                                        data: {}
                                        },
                                        {
                                        nodeType: 'text',
                                        value: 'You have the right not to be discriminated against for exercising your rights.',
                                        marks: [],
                                        data: {}
                                        }
                                    ]
                                    }
                                ]
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'How to Submit a Data Privacy Request',
                                marks: [
                                    {
                                    type: 'italic'
                                    },
                                    {
                                    type: 'bold'
                                    }
                                ],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'You may exercise your Right to Know and Right to Deletion by visiting our ',
                                marks: [],
                                data: {}
                                },
                                {
                                nodeType: 'hyperlink',
                                data: {
                                    uri: 'https://privacyportal.onetrust.com/webform/bd5eb8a9-9d4b-487d-be7b-36a09d769cc1/fa10399c-b928-423c-8494-5a5c6d72f95a'
                                },
                                content: [
                                    {
                                    nodeType: 'text',
                                    value: 'request web page',
                                    marks: [],
                                    data: {}
                                    }
                                ]
                                },
                                {
                                nodeType: 'text',
                                value: ' or calling (844) 971-2551.To process your request for access or deletion, we must be able to verify your identity to a reasonable degree of certainty. We will ask you to provide your contact information and additional identifiers based on your relationship with us.You may designate an authorized agent to make a request to access, delete, or opt-out of the sale of your information on your behalf. When you use an authorized agent to submit a request for access or deletion, you must provide the authorized agent with written permission to do so, and, in certain circumstances, we may ask you to verify your own identity directly with us. We may deny a request from an authorized agent that does not submit proof that they have been authorized by you to act on your behalf.',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'unordered-list',
                            data: {},
                            content: [
                                {
                                nodeType: 'list-item',
                                data: {},
                                content: [
                                    {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                        nodeType: 'text',
                                        value: 'Right to Know:',
                                        marks: [
                                            {
                                            type: 'italic'
                                            }
                                        ],
                                        data: {}
                                        }
                                    ]
                                    },
                                    {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                        nodeType: 'text',
                                        value: 'Please note that we may not be required to provide you access to the specific pieces of information we have collected about you or delete information if we are unable to verify your identity.',
                                        marks: [],
                                        data: {}
                                        }
                                    ]
                                    }
                                ]
                                },
                                {
                                nodeType: 'list-item',
                                data: {},
                                content: [
                                    {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                        nodeType: 'text',
                                        value: 'Right to Delete:',
                                        marks: [
                                            {
                                            type: 'italic'
                                            }
                                        ],
                                        data: {}
                                        }
                                    ]
                                    },
                                    {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                        nodeType: 'text',
                                        value: 'We may not be required to delete information under certain circumstances. Specifically, the CCPA includes exemptions that provide that we do not have to delete data that, for example, is necessary to comply with legal obligations including those pertaining to the quality, safety or effectiveness of a product or activity regulated by the Food and Drug Administration (FDA), complete a transaction, detect security incidents, or for certain other internal purposes.',
                                        marks: [],
                                        data: {}
                                        }
                                    ]
                                    }
                                ]
                                },
                                {
                                nodeType: 'list-item',
                                data: {},
                                content: [
                                    {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                        nodeType: 'text',
                                        value: 'Sale or Disclosure of Personal data: ',
                                        marks: [
                                            {
                                            type: 'italic'
                                            }
                                        ],
                                        data: {}
                                        },
                                        {
                                        nodeType: 'text',
                                        value: 'The CCPA defines “sale” broadly to include sharing, transferring, disclosing or otherwise communicating personal data with a third party for monetary or other valuable consideration. We share personal data with service providers who work on our behalf and agree not to use or sell your personal data for other purposes or if you have intentionally directed us to share information with a third party. In addition, with your approval, we share certain internet tracking data, including cookies and the IP address used to access our websites.',
                                        marks: [],
                                        data: {}
                                        }
                                    ]
                                    }
                                ]
                                },
                                {
                                nodeType: 'list-item',
                                data: {},
                                content: [
                                    {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                        nodeType: 'text',
                                        value: 'Notice of Financial Incentive:',
                                        marks: [
                                            {
                                            type: 'italic'
                                            }
                                        ],
                                        data: {}
                                        }
                                    ]
                                    },
                                    {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                        nodeType: 'text',
                                        value: 'Moderna does not offer financial incentives in exchange for the collection or sale of personal data. However, we do provide discounts and incentives to individuals who use our products and services and enroll in incentive programs that we offer from time to time; enrolling in these programs requires you to provide certain of your personal data so that we may administer the programs and, in some cases, provide marketing and advertising to you. Under CCPA, this could be considered an offer of a “financial incentive” and so we provide this notice to you to describe our practice and to provide a good faith estimate of the value of your personal data that we may collect related to the programs.\n\nIn the normal course of our business, we do not assign monetary or other value to personal data, but in accordance with CCPA, we make a good faith estimate that the value of the personal data collected and used is equivalent to the value of the discount or financial incentive we provide in these programs. To make this good faith estimate, we may consider among other factors, the (i) categories of personal data collected, (ii) the discount or incentive offered, (iii) the sales or use of our products and services by those who enroll versus those who do not, and (iv) the cost and expenses we incur in offering the programs.\n\nThe incentive programs require you to opt-in to participate as set forth on the page where you can enroll or opt-in to the programs. You can opt-out either by contacting us at the information set forth below, or by following the terms and conditions provided when you are enrolling in the program. While we will not discriminate against you for exercising your rights under CCPA, if you request deletion of your personal data, we may not be able to delete such information if it is necessary to administer the incentive or discount you requested and still provide you such incentive or discount.',
                                        marks: [],
                                        data: {}
                                        }
                                    ]
                                    }
                                ]
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'Personal data Collected from Employees, Contractors, Applicants, and Health Care Providers',
                                marks: [
                                    {
                                    type: 'italic'
                                    },
                                    {
                                    type: 'bold'
                                    }
                                ],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'unordered-list',
                            data: {},
                            content: [
                                {
                                nodeType: 'list-item',
                                data: {},
                                content: [
                                    {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                        nodeType: 'text',
                                        value: 'Employees ',
                                        marks: [
                                            {
                                            type: 'italic'
                                            }
                                        ],
                                        data: {}
                                        },
                                        {
                                        nodeType: 'text',
                                        value: '– If you are an Moderna employee and would like more information about the categories of personal data we collect from you and the purposes for which the personal data will be used, please contact us at',
                                        marks: [],
                                        data: {}
                                        }
                                    ]
                                    },
                                    {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                        nodeType: 'text',
                                        value: '',
                                        marks: [],
                                        data: {}
                                        },
                                        {
                                        nodeType: 'hyperlink',
                                        data: {
                                            uri: 'mailto:privacy@modernatx.com'
                                        },
                                        content: [
                                            {
                                            nodeType: 'text',
                                            value: 'privacy@modernatx.com',
                                            marks: [],
                                            data: {}
                                            }
                                        ]
                                        },
                                        {
                                        nodeType: 'text',
                                        value: '.',
                                        marks: [],
                                        data: {}
                                        }
                                    ]
                                    }
                                ]
                                },
                                {
                                nodeType: 'list-item',
                                data: {},
                                content: [
                                    {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                        nodeType: 'text',
                                        value: 'Contractors ',
                                        marks: [
                                            {
                                            type: 'italic'
                                            }
                                        ],
                                        data: {}
                                        },
                                        {
                                        nodeType: 'text',
                                        value: '– If you are a contractor performing services for Moderna and would like information about the categories of personal data we collect from you as a contractor and the purpose for which the personal data will be used, please visit our ',
                                        marks: [],
                                        data: {}
                                        },
                                        {
                                        nodeType: 'hyperlink',
                                        data: {
                                            uri: 'https://privacyportal.onetrust.com/webform/bd5eb8a9-9d4b-487d-be7b-36a09d769cc1/fa10399c-b928-423c-8494-5a5c6d72f95a'
                                        },
                                        content: [
                                            {
                                            nodeType: 'text',
                                            value: 'request web page',
                                            marks: [],
                                            data: {}
                                            }
                                        ]
                                        },
                                        {
                                        nodeType: 'text',
                                        value: '.',
                                        marks: [],
                                        data: {}
                                        }
                                    ]
                                    }
                                ]
                                },
                                {
                                nodeType: 'list-item',
                                data: {},
                                content: [
                                    {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                        nodeType: 'text',
                                        value: 'Job Applicants',
                                        marks: [
                                            {
                                            type: 'italic'
                                            }
                                        ],
                                        data: {}
                                        },
                                        {
                                        nodeType: 'text',
                                        value: ' – If you are applying for a position with Moderna and would like information about the categories of personal data Moderna collects from you as a job applicant and the purposes for which the personal data, please view our Privacy Statement',
                                        marks: [],
                                        data: {}
                                        }
                                    ]
                                    }
                                ]
                                },
                                {
                                nodeType: 'list-item',
                                data: {},
                                content: [
                                    {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                        nodeType: 'text',
                                        value: 'Health Care Providers – ',
                                        marks: [
                                            {
                                            type: 'italic'
                                            }
                                        ],
                                        data: {}
                                        },
                                        {
                                        nodeType: 'text',
                                        value: 'If you are a health care provider with whom we have a contractual arrangement and would like information about the categories of personal data we collect from you and the purposes for which the personal data will be used, please visit our ',
                                        marks: [],
                                        data: {}
                                        },
                                        {
                                        nodeType: 'hyperlink',
                                        data: {
                                            uri: 'https://privacyportal.onetrust.com/webform/bd5eb8a9-9d4b-487d-be7b-36a09d769cc1/fa10399c-b928-423c-8494-5a5c6d72f95a'
                                        },
                                        content: [
                                            {
                                            nodeType: 'text',
                                            value: 'request web page',
                                            marks: [],
                                            data: {}
                                            }
                                        ]
                                        },
                                        {
                                        nodeType: 'text',
                                        value: '.',
                                        marks: [],
                                        data: {}
                                        }
                                    ]
                                    }
                                ]
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'Children’s Online Privacy Protection Act (COPPA)',
                                marks: [
                                    {
                                    type: 'italic'
                                    },
                                    {
                                    type: 'bold'
                                    }
                                ],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'Consistent (COPPA), if we learn that a child under age 13 has provided Personal Data to or through the site without first receiving his or her parent’s verified consent, we will use that information only to respond directly to that child (or his or her parent or legal guardian) to inform the child that he or she cannot use the services and subsequently we will dispose of such Personal Data in accordance with this Privacy Statement.California residents who are unable to review or access this CCPA Notice due to a disability may contact us to request access this CCPA Notice in an alternative format. Please call 1-844- 971-2551 or email us at ',
                                marks: [],
                                data: {}
                                },
                                {
                                nodeType: 'hyperlink',
                                data: {
                                    uri: 'mailto:privacy@modernatx.com'
                                },
                                content: [
                                    {
                                    nodeType: 'text',
                                    value: 'privacy@modernatx.com',
                                    marks: [],
                                    data: {}
                                    }
                                ]
                                },
                                {
                                nodeType: 'text',
                                value: '.',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'Nevada',
                                marks: [
                                    {
                                    type: 'bold'
                                    }
                                ],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'Nevada Residents As Covered by Nevada Privacy Law\nModerna does not sell Covered Information as defined under Nevada law. If you would like to make a further inquiry regarding the selling of your Covered Information, as defined under Nevada law, visit our ',
                                marks: [],
                                data: {}
                                },
                                {
                                nodeType: 'hyperlink',
                                data: {
                                    uri: 'https://privacyportal.onetrust.com/webform/bd5eb8a9-9d4b-487d-be7b-36a09d769cc1/fa10399c-b928-423c-8494-5a5c6d72f95a'
                                },
                                content: [
                                    {
                                    nodeType: 'text',
                                    value: 'request web page',
                                    marks: [],
                                    data: {}
                                    }
                                ]
                                },
                                {
                                nodeType: 'text',
                                value: '.',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'EU/EEA, UK & Switzerland',
                                marks: [
                                    {
                                    type: 'bold'
                                    }
                                ],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'Moderna’s processing of your personal data is based on any one of the following legal grounds: (A) legitimate business purposes, (B) where you have provided consent, (C) as necessary to comply with Moderna’s legal and regulatory obligations and (D) as necessary to perform a contract under which you have been engaged.',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'embedded-asset-block',
                            data: {
                                target: {
                                metadata: {
                                    tags: [],
                                    concepts: []
                                },
                                sys: {
                                    space: {
                                    sys: {
                                        type: 'Link',
                                        linkType: 'Space',
                                        id: 'n9bebhw263o0'
                                    }
                                    },
                                    id: '3dlAOZ38IdeTNBy7LRHGVL',
                                    type: 'Asset',
                                    createdAt: '2024-07-10T13:57:28.572Z',
                                    updatedAt: '2024-07-10T13:57:28.572Z',
                                    environment: {
                                    sys: {
                                        id: 'sandbox',
                                        type: 'Link',
                                        linkType: 'Environment'
                                    }
                                    },
                                    publishedVersion: 5,
                                    revision: 1,
                                    locale: 'en-US'
                                },
                                fields: {
                                    title: 'Privacy Policy EU/EEA, UK & Switzerland ',
                                    description: '',
                                    file: {
                                    url: '//images.ctfassets.net/n9bebhw263o0/3dlAOZ38IdeTNBy7LRHGVL/2f4cfe08aaffd2eb88fe7e161d058c7e/image__3_.png',
                                    details: {
                                        size: 154682,
                                        image: {
                                        width: 480,
                                        height: 379
                                        }
                                    },
                                    fileName: 'image (3).png',
                                    contentType: 'image/png'
                                    }
                                }
                                }
                            },
                            content: []
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'How can you access, correct or delete the personal data about you that we process? You have a right to request to access, correct/update or delete your personal data (including your health information). You may make such a request at any time, by visiting our ',
                                marks: [],
                                data: {}
                                },
                                {
                                nodeType: 'hyperlink',
                                data: {
                                    uri: 'https://privacyportal.onetrust.com/webform/bd5eb8a9-9d4b-487d-be7b-36a09d769cc1/fa10399c-b928-423c-8494-5a5c6d72f95a'
                                },
                                content: [
                                    {
                                    nodeType: 'text',
                                    value: 'request web page',
                                    marks: [],
                                    data: {}
                                    }
                                ]
                                },
                                {
                                nodeType: 'text',
                                value: '. We will provide you with access to the information we hold about you, correct/update, and or delete that information that was provided to us by a Healthcare Professional or a consumer regarding an adverse drug event.',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'It is not technologically possible to remove from our servers each and every record of your information. The need to back-up our systems to protect information from inadvertent loss means that a copy of information about you (including your health-related interests) may exist in a non-erasable form that will be difficult or impossible for us to locate.',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'Nevertheless, when permitted by law, Moderna will delete your personal data (including health information) stored in the databases Moderna actively uses for research and daily business activities or stored in other readily searchable media. In addition, we will use reasonable efforts not to disclose any personal data stored in a non-erasable format after receiving your request for removal, except as required by law.',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'How can you exercise the right to data portability? According to the right to data portability, you have the right to request that your personal data provided to Moderna be delivered to you in a structured, commonly used and machine-readable format, subject to certain conditions and can be requested by visiting our ',
                                marks: [],
                                data: {}
                                },
                                {
                                nodeType: 'hyperlink',
                                data: {
                                    uri: 'https://privacyportal.onetrust.com/webform/bd5eb8a9-9d4b-487d-be7b-36a09d769cc1/fa10399c-b928-423c-8494-5a5c6d72f95a'
                                },
                                content: [
                                    {
                                    nodeType: 'text',
                                    value: 'request web page',
                                    marks: [],
                                    data: {}
                                    }
                                ]
                                },
                                {
                                nodeType: 'text',
                                value: '.',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'Make a Privacy Complaint with the ICO (UK). If you feel Moderna’s processing your personal data violates any applicable law, rule or regulation, you have the right to lodge a complaint with the Information Commissioner’s Office (ICO) at: ',
                                marks: [],
                                data: {}
                                },
                                {
                                nodeType: 'hyperlink',
                                data: {
                                    uri: 'https://ico.org.uk/make-a-complaint/'
                                },
                                content: [
                                    {
                                    nodeType: 'text',
                                    value: 'https://ico.org.uk/make-a-complaint/',
                                    marks: [],
                                    data: {}
                                    }
                                ]
                                },
                                {
                                nodeType: 'text',
                                value: '.',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'Make a Privacy Complaint with the Federal Data Protection Commissioner of Switzerland. If you feel Moderna’s processing your personal data violates any applicable law, rule or regulation, you have the right to lodge a complaint with the Federal Data Protection Commissioner at: ',
                                marks: [],
                                data: {}
                                },
                                {
                                nodeType: 'hyperlink',
                                data: {
                                    uri: 'https://www.edoeb.admin.ch/edoeb/en/home.html'
                                },
                                content: [
                                    {
                                    nodeType: 'text',
                                    value: 'https://www.edoeb.admin.ch/edoeb/en/home.html',
                                    marks: [],
                                    data: {}
                                    }
                                ]
                                },
                                {
                                nodeType: 'text',
                                value: '.',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'How We Manage Disclosure of Transfers of Value',
                                marks: [
                                    {
                                    type: 'italic'
                                    },
                                    {
                                    type: 'bold'
                                    }
                                ],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'Moderna collects data about the transfers of value that you have received from us so that we can comply with our obligations under the IPHA Code, specifically that companies must document and publicly disclose annually certain transfers of value made directly or indirectly to health professionals and other relevant decision makers located in Europe.',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'Moderna recognizes the legitimate public interest in better understanding the financial relationships that healthcare professionals have with the pharmaceutical industry for the purposes of transparency and trust in the pharmaceutical industry.',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'The law requires us to inform you of the legal basis for collecting and processing your personal data where Moderna is the data controller. Where Moderna processes data relating to transfers of value made to you, Moderna relies on the legal basis of legitimate interests to process that data. Moderna’s compliance with the IPHA Code and these further objectives cannot be met without processing personal data about you and the transfers of value that you have received from us. We have carried out a Legitimate Interests Assessment and consider that this processing is necessary, proportionate and without unjustified harm to you.',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'If you do not agree to the disclosure of data relating to transfers of value made to you by Moderna, you can raise an objection via ',
                                marks: [],
                                data: {}
                                },
                                {
                                nodeType: 'hyperlink',
                                data: {
                                    uri: 'mailto:privacy@modernatx.com'
                                },
                                content: [
                                    {
                                    nodeType: 'text',
                                    value: 'privacy@modernatx.com',
                                    marks: [],
                                    data: {}
                                    }
                                ]
                                },
                                {
                                nodeType: 'text',
                                value: '.',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'Japan',
                                marks: [
                                    {
                                    type: 'bold'
                                    }
                                ],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'In accordance with the Act on Protection of Personal Information of Japan (APPI) and other applicable laws and regulations, Moderna will disclose the personal data that Moderna holds about you according to the applicable procedures. In addition, if you inform Moderna that your personal data is inaccurate, Moderna will review and correct, add or delete the data as required in accordance with applicable laws, regulations and procedures.',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'Requests may be filed by visiting our ',
                                marks: [],
                                data: {}
                                },
                                {
                                nodeType: 'hyperlink',
                                data: {
                                    uri: 'https://privacyportal.onetrust.com/webform/bd5eb8a9-9d4b-487d-be7b-36a09d769cc1/fa10399c-b928-423c-8494-5a5c6d72f95a'
                                },
                                content: [
                                    {
                                    nodeType: 'text',
                                    value: 'request web page',
                                    marks: [],
                                    data: {}
                                    }
                                ]
                                },
                                {
                                nodeType: 'text',
                                value: '; please note that this may require a fee.',
                                marks: [],
                                data: {}
                                }
                            ]
                            }
                        ]
                        },
                        backToTopButtonLabel: 'Back To Top',
                        printButtonLabel: 'Print',
                        country: {
                        metadata: {
                            tags: [],
                            concepts: []
                        },
                        sys: {
                            space: {
                            sys: {
                                type: 'Link',
                                linkType: 'Space',
                                id: 'n9bebhw263o0'
                            }
                            },
                            id: '7sht7920U6vs3CLH2CUyaa',
                            type: 'Entry',
                            createdAt: '2023-05-18T03:23:50.744Z',
                            updatedAt: '2023-05-24T22:55:23.250Z',
                            environment: {
                            sys: {
                                id: 'sandbox',
                                type: 'Link',
                                linkType: 'Environment'
                            }
                            },
                            publishedVersion: 6,
                            revision: 2,
                            contentType: {
                            sys: {
                                type: 'Link',
                                linkType: 'ContentType',
                                id: 'country'
                            }
                            },
                            locale: 'en-US'
                        },
                        fields: {
                            name: 'United States',
                            isocode: 'US',
                            flag: {
                            metadata: {
                                tags: [],
                                concepts: []
                            },
                            sys: {
                                space: {
                                sys: {
                                    type: 'Link',
                                    linkType: 'Space',
                                    id: 'n9bebhw263o0'
                                }
                                },
                                id: '3aYCbZJiL8aoEKRdhjOXyy',
                                type: 'Asset',
                                createdAt: '2023-05-24T22:54:50.939Z',
                                updatedAt: '2023-05-24T22:54:50.939Z',
                                environment: {
                                sys: {
                                    id: 'sandbox',
                                    type: 'Link',
                                    linkType: 'Environment'
                                }
                                },
                                publishedVersion: 5,
                                revision: 1,
                                locale: 'en-US'
                            },
                            fields: {
                                title: 'usa flag',
                                description: 'USA Flag',
                                file: {
                                url: '//images.ctfassets.net/n9bebhw263o0/3aYCbZJiL8aoEKRdhjOXyy/f69a6f932a690dc632e7742c328c276d/usa_flag.svg',
                                details: {
                                    size: 2487,
                                    image: {
                                    width: 36,
                                    height: 26
                                    }
                                },
                                fileName: 'usa_flag.svg',
                                contentType: 'image/svg+xml'
                                }
                            }
                            },
                            locales: [
                            'en-US'
                            ]
                        }
                        }
                    }
                    },
                    {
                    metadata: {
                        tags: [],
                        concepts: []
                    },
                    sys: {
                        space: {
                        sys: {
                            type: 'Link',
                            linkType: 'Space',
                            id: 'n9bebhw263o0'
                        }
                        },
                        id: '5obyb6hoYaRjLduvLrF9BT',
                        type: 'Entry',
                        createdAt: '2023-05-24T19:10:31.031Z',
                        updatedAt: '2023-07-11T18:20:48.597Z',
                        environment: {
                        sys: {
                            id: 'sandbox',
                            type: 'Link',
                            linkType: 'Environment'
                        }
                        },
                        publishedVersion: 245,
                        revision: 62,
                        contentType: {
                        sys: {
                            type: 'Link',
                            linkType: 'ContentType',
                            id: 'richTextContentComponent'
                        }
                        },
                        locale: 'en-US'
                    },
                    fields: {
                        title: 'Privacy Policy Rich Text Content Component - DE',
                        effectiveDateLabel: 'Effective',
                        effectiveDate: '2023-01-07',
                        disclaimerMessage: 'Please read these terms carefully before accessing or using this website',
                        content: {
                        nodeType: 'document',
                        data: {},
                        content: [
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: '',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'This website is owned and operated by Moderna, Inc. (“Moderna”, “we”, “our” or “us”). The materials on our website (the “website” or the “Site”) are provided by Moderna as a service to our customers and the public and may be used for informational purposes only.\n',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'Moderna respects the privacy of visitors to our website and recognizes the importance of taking steps to protect the privacy of any information we collect through our website. This Privacy Policy describes the types of Personal Information (as defined below) that we collect about visitors to the Site, how we use the Personal Information, and with whom we may share it. This Privacy Policy also describes (1) the measures we take to protect the personal\ninformation we collect and (2) your rights and privileges regarding our collection, use, and disclosure of your personal information.\n',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'Exclusions.',
                                marks: [
                                    {
                                    type: 'bold'
                                    },
                                    {
                                    type: 'italic'
                                    }
                                ],
                                data: {}
                                },
                                {
                                nodeType: 'text',
                                value: ' This policy only treats personal information collected through this website. It does not describe how we may collect or use personal information collected oline, and it does not address or govern the privacy practices of other websites (including those we link to) that may have policies of their own. Users of our website must be aware of this when they leave our website, and we encourage them to read the privacy statements of each website they visit that collects personal information. Information you provide to us unsolicited may be considered non-confidential, and Moderna may reproduce, use, disclose, and share such unsolicited information with others without permission, compensation, restriction, or aribution.\n',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'By accessing our website, you agree to the terms of this Privacy Policy and the terms of the Agreement. ',
                                marks: [],
                                data: {}
                                },
                                {
                                nodeType: 'text',
                                value: 'If you do not agree to these terms, you are not authorized to use our website.',
                                marks: [
                                    {
                                    type: 'bold'
                                    }
                                ],
                                data: {}
                                },
                                {
                                nodeType: 'text',
                                value: '\n\n',
                                marks: [],
                                data: {}
                                },
                                {
                                nodeType: 'text',
                                value: '\n',
                                marks: [
                                    {
                                    type: 'bold'
                                    }
                                ],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'heading-3',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'Introduction',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: '“',
                                marks: [],
                                data: {}
                                },
                                {
                                nodeType: 'text',
                                value: 'Personal Information',
                                marks: [
                                    {
                                    type: 'bold'
                                    },
                                    {
                                    type: 'italic'
                                    }
                                ],
                                data: {}
                                },
                                {
                                nodeType: 'text',
                                value: '” is information that can be used to identify or contact you, such as: Your contact information, including your name, address, email address, country, and phone number, any other information that may appear on your resume if you apply for a job with Moderna through our website, and where required by applicable law, any information about your use of our website or device that may be collected automatically; including the use of\ncookies, web beacons and other tracking technologies.\n',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'We will handle your Personal Data in accordance with applicable law and in line with the following principles:\n',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'unordered-list',
                            data: {},
                            content: [
                                {
                                nodeType: 'list-item',
                                data: {},
                                content: [
                                    {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                        nodeType: 'text',
                                        value: 'We will treat your personal data in accordance with applicable law and in accordance with the following principles:',
                                        marks: [],
                                        data: {}
                                        }
                                    ]
                                    }
                                ]
                                },
                                {
                                nodeType: 'list-item',
                                data: {},
                                content: [
                                    {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                        nodeType: 'text',
                                        value: 'We process personal data lawfully, fairly and transparently.',
                                        marks: [],
                                        data: {}
                                        }
                                    ]
                                    }
                                ]
                                },
                                {
                                nodeType: 'list-item',
                                data: {},
                                content: [
                                    {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                        nodeType: 'text',
                                        value: 'We collect personal information only for a specific, explicit and legitimate purpose and use personal information only for the purposes for which it was originally collected.',
                                        marks: [],
                                        data: {}
                                        }
                                    ]
                                    }
                                ]
                                },
                                {
                                nodeType: 'list-item',
                                data: {},
                                content: [
                                    {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                        nodeType: 'text',
                                        value: 'We limit the collection of personal data to what is necessary for the purpose for which it is processed.',
                                        marks: [],
                                        data: {}
                                        }
                                    ]
                                    }
                                ]
                                },
                                {
                                nodeType: 'list-item',
                                data: {},
                                content: [
                                    {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                        nodeType: 'text',
                                        value: 'We will use reasonable eorts to ensure that your personal information is accurate and, where appropriate, kept up to date.',
                                        marks: [],
                                        data: {}
                                        }
                                    ]
                                    }
                                ]
                                },
                                {
                                nodeType: 'list-item',
                                data: {},
                                content: [
                                    {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                        nodeType: 'text',
                                        value: 'We do not store personal data for longer than is necessary for the purpose for which the personal data is processed.',
                                        marks: [],
                                        data: {}
                                        }
                                    ]
                                    }
                                ]
                                },
                                {
                                nodeType: 'list-item',
                                data: {},
                                content: [
                                    {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                        nodeType: 'text',
                                        value: 'Personal data will only be processed in a manner that ensures appropriate security of the personal data.\n\n',
                                        marks: [],
                                        data: {}
                                        }
                                    ]
                                    }
                                ]
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'Our privacy practices are described in more detail below in this Privacy Policy.\n\n',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'heading-3',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'Information We Collect',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'You can visit our website without explicitly providing information about yourself. If you choose to submit your information through the “Sign Up for our Mailing List” feature or the “',
                                marks: [],
                                data: {}
                                },
                                {
                                nodeType: 'hyperlink',
                                data: {
                                    uri: 'https://dev.modernadirect.com/en-DE/contact-us'
                                },
                                content: [
                                    {
                                    nodeType: 'text',
                                    value: 'Contact Us',
                                    marks: [],
                                    data: {}
                                    }
                                ]
                                },
                                {
                                nodeType: 'text',
                                value: '” feature on our website, or if you apply for a job posting at Moderna through the “',
                                marks: [],
                                data: {}
                                },
                                {
                                nodeType: 'hyperlink',
                                data: {
                                    uri: 'https://www.modernatx.com/careers/life-at-moderna'
                                },
                                content: [
                                    {
                                    nodeType: 'text',
                                    value: 'Careers',
                                    marks: [],
                                    data: {}
                                    }
                                ]
                                },
                                {
                                nodeType: 'text',
                                value: '” section of our website, we may ask you to provide personal information, such as your name, address, telephone number and email address, job title, company name, Your\ncountry, information about your job and other job-related information. You are not required to provide any personal information to Moderna, but your ability to use our website or its features and your ability to apply for a job may be limited if you do not.',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: '',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'Personal data',
                                marks: [
                                    {
                                    type: 'bold'
                                    }
                                ],
                                data: {}
                                },
                                {
                                nodeType: 'text',
                                value: ' about the use of the website collected through cookies or other automated means. When you use our website, we may automatically collect information about your use of the website, including through the use of cookies, web beacons and other tracking technologies (“Automatically Collected Information”). Automatically collected information may include device information such as IP address, device identifiers and operating systems,\nas well as usage information such as time and duration of use, interaction with content, information stored in cookies or similar technologies. In accordance with EU Regulation 2016/679 on data protection (the “GDPR”), automated information is considered personal data and we treat such automated information as personal data in accordance with this Privacy Policy.\n',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: '“Cookies”',
                                marks: [
                                    {
                                    type: 'bold'
                                    }
                                ],
                                data: {}
                                },
                                {
                                nodeType: 'text',
                                value: ' are small files that the website places on your hard drive for identification purposes. These files are used for registration on the website and to\ncustomize your next visit to our website. For example, cookies store your preferred language and display. Cookies cannot read data from your hard drive.\n\nWe use the following cookies on our website:',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'unordered-list',
                            data: {},
                            content: [
                                {
                                nodeType: 'list-item',
                                data: {},
                                content: [
                                    {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                        nodeType: 'text',
                                        value: 'Strictly necessary cookies',
                                        marks: [
                                            {
                                            type: 'bold'
                                            }
                                        ],
                                        data: {}
                                        },
                                        {
                                        nodeType: 'text',
                                        value: '. These are cookies that are necessary for the operation of our website. These include, for example, cookies that enable you to log in to your applicant account. ',
                                        marks: [],
                                        data: {}
                                        }
                                    ]
                                    }
                                ]
                                },
                                {
                                nodeType: 'list-item',
                                data: {},
                                content: [
                                    {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                        nodeType: 'text',
                                        value: 'Functionality cookies',
                                        marks: [
                                            {
                                            type: 'bold'
                                            }
                                        ],
                                        data: {}
                                        },
                                        {
                                        nodeType: 'text',
                                        value: '. s. These are used to recognize you when you return to our website and to embed features of third-party services. This allows us to personalize our content for you, store your preferences (e.g., Your choice of language) and useful third-party services on our website.',
                                        marks: [],
                                        data: {}
                                        }
                                    ]
                                    }
                                ]
                                },
                                {
                                nodeType: 'list-item',
                                data: {},
                                content: [
                                    {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                        nodeType: 'text',
                                        value: 'Analytics cookies',
                                        marks: [
                                            {
                                            type: 'bold'
                                            }
                                        ],
                                        data: {}
                                        },
                                        {
                                        nodeType: 'text',
                                        value: '. We use the Google Analytics platform to collect certain analytical information that helps us to beer understand the activities on our website and to improve our services and the quality of our website. This information includes the IP address, page views, referring websites or advertisements, operating system and browser, and time spent on our website. We receive this data in an aggregated form. We use this information\nto understand how visitors interact with our website, to measure the eectiveness of our advertising on third-party websites, and to improve our visitors’ experience.\n',
                                        marks: [],
                                        data: {}
                                        }
                                    ]
                                    }
                                ]
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'You can refuse or accept cookies from this website at any time by activating the cookie seings in your browser. The “Help” menu of most Internet browsers contains information on how to disable cookies, or you can visit ',
                                marks: [],
                                data: {}
                                },
                                {
                                nodeType: 'hyperlink',
                                data: {
                                    uri: 'https://www.aboutcookies.org/how-to-control-cookies/'
                                },
                                content: [
                                    {
                                    nodeType: 'text',
                                    value: 'https://www.aboutcookies.org/how-to-control-cookies',
                                    marks: [],
                                    data: {}
                                    }
                                ]
                                },
                                {
                                nodeType: 'text',
                                value: '/. If you do not accept cookies, some features on our website may not work fully, and you may not be able to access certain information on this website. By continuing to use the website without changing the seings, you agree to the use of cookies.',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'Personal data from third-party sources. We may, to the extent permied by law, obtain information about you from publicly and commercially available sources, which we may combine with other information we receive from or about you. For example, if you apply for a job at Moderna through our website, we may view your LinkedIn profile.\nAggregated data. We may aggregate and/or de-identify any personal information we collect so that the information no longer identifies a specific individual. We may use, disclose and otherwise process such information without restriction for our own legitimate business purposes – including historical and statistical analysis and business planning.\n',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'Aggregated Data',
                                marks: [
                                    {
                                    type: 'italic'
                                    }
                                ],
                                data: {}
                                },
                                {
                                nodeType: 'text',
                                value: '. We may aggregate and/or de-identify any Personal Data that we collect, such that the information no longer identifies any specific individual. We may use, disclose and otherwise process such information for our own legitimate business purposes – including historical and statistical analysis and business planning – without restriction.\n',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'heading-3',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'How We Use Personal Data',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'We may use Personal Data for the following purposes.',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'heading-5',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'Our legitimate interests',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'We may process your personal data where it is necessary for our legitimate interest as a business, including administering, promoting and improving our business and risk management. For example, we may process your personal data in order to:',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'unordered-list',
                            data: {},
                            content: [
                                {
                                nodeType: 'list-item',
                                data: {},
                                content: [
                                    {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                        nodeType: 'text',
                                        value: 'provide you with the information you have requested and/or to respond to your requests submied via the Website, email and/or telephone,',
                                        marks: [],
                                        data: {}
                                        }
                                    ]
                                    }
                                ]
                                },
                                {
                                nodeType: 'list-item',
                                data: {},
                                content: [
                                    {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                        nodeType: 'text',
                                        value: 'facilitate our recruitment activities (e.g., processing job applications, evaluating you as a candidate for a job and monitoring our recruitment statistics),',
                                        marks: [],
                                        data: {}
                                        }
                                    ]
                                    }
                                ]
                                },
                                {
                                nodeType: 'list-item',
                                data: {},
                                content: [
                                    {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                        nodeType: 'text',
                                        value: 'analyse and improve our communications and strategies (including by determining when e-mails sent to you have been received and read);',
                                        marks: [],
                                        data: {}
                                        }
                                    ]
                                    }
                                ]
                                },
                                {
                                nodeType: 'list-item',
                                data: {},
                                content: [
                                    {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                        nodeType: 'text',
                                        value: 'adapt the content we display on our website,',
                                        marks: [],
                                        data: {}
                                        }
                                    ]
                                    }
                                ]
                                },
                                {
                                nodeType: 'list-item',
                                data: {},
                                content: [
                                    {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                        nodeType: 'text',
                                        value: 'protect against, identify, investigate, and respond to fraud, illegal activities (such as incidents of hacking or misuse of our website), claims, and other recourse;',
                                        marks: [],
                                        data: {}
                                        }
                                    ]
                                    }
                                ]
                                },
                                {
                                nodeType: 'list-item',
                                data: {},
                                content: [
                                    {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                        nodeType: 'text',
                                        value: 'maintain the privacy, security, or property of the Site; and',
                                        marks: [],
                                        data: {}
                                        }
                                    ]
                                    }
                                ]
                                },
                                {
                                nodeType: 'list-item',
                                data: {},
                                content: [
                                    {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                        nodeType: 'text',
                                        value: 'communicate with you for any other purpose arising from the circumstances or of which we inform you when we collect personal information from you.\n',
                                        marks: [],
                                        data: {}
                                        }
                                    ]
                                    }
                                ]
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: '',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'heading-5',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'Legal Obligation',
                                marks: [
                                    {
                                    type: 'bold'
                                    }
                                ],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'unordered-list',
                            data: {},
                            content: [
                                {
                                nodeType: 'list-item',
                                data: {},
                                content: [
                                    {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                        nodeType: 'text',
                                        value: 'We may be required by law to collect and process certain personal data about you. For example, it may be necessary for us to process your personal data in order to comply with our contractual obligations to the U.S. Government as a contractor for the government.\n',
                                        marks: [],
                                        data: {}
                                        }
                                    ]
                                    }
                                ]
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: '',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'heading-5',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'Your consent',
                                marks: [
                                    {
                                    type: 'bold'
                                    }
                                ],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'unordered-list',
                            data: {},
                            content: [
                                {
                                nodeType: 'list-item',
                                data: {},
                                content: [
                                    {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                        nodeType: 'text',
                                        value: 'We may also, either directly or through our trusted third parties, obtain your separate consent to process your personal data, for example, if you choose to receive Moderna news and updates from us, or for the use of non-essential cookies.',
                                        marks: [],
                                        data: {}
                                        }
                                    ]
                                    }
                                ]
                                },
                                {
                                nodeType: 'list-item',
                                data: {},
                                content: [
                                    {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                        nodeType: 'text',
                                        value: 'If we have obtained your consent to process your personal data, you may subsequently withdraw it at any time by contacting us at the address set out in the “Your Privacy Rights” section below.\n',
                                        marks: [],
                                        data: {}
                                        }
                                    ]
                                    }
                                ]
                                }
                            ]
                            },
                            {
                            nodeType: 'heading-3',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'Disclosure of personal data\n\n',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'We will not sell, share, or otherwise distribute your personal information to third parties except as provided in this Privacy Policy.\n\nAliates and Service Providers. We may share your personal information with other Moderna aliates worldwide who agree to treat it in accordance with this Privacy Policy. We may also share personal data with service providers acting for us or on our behalf for further processing, such as to assess the usefulness of this website, for data management, technical support or to analyse recruitment data. These service providers have contractually agreed to\nuse the personal data only for the purpose(s) for which the data was originally collected or may otherwise be lawfully processed, not to sell your personal data to other third parties and not to disclose it to other third parties, unless required by law, permied by us or specified in this Privacy Policy.\n',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: '\nOther parties in connection with a corporate transaction. We may also transfer personal information we have collected from you to a third party as part of\na corporate transaction, such as a merger, acquisition, reorganization, joint venture, financing, or sale of our assets.\n',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: '\nOther parties as required by applicable law or as necessary to protect Moderna. We may share personal information with third parties to comply with\nlegal and regulatory requirements, or to protect against fraud, illegal activity (e.g., in response to incidents of hacking or misuse of our website), and\nclaims and other recourse.\n\n\n',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'heading-3',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'International Data Transfers',
                                marks: [
                                    {
                                    type: 'bold'
                                    }
                                ],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'When we share personal information with third parties, such data transfers may involve the transfer of personal information to other countries. These countries may not have the same data protection laws as the country from which the personal data originally originated.\n\n',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'heading-3',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'EEA area residents only',
                                marks: [
                                    {
                                    type: 'bold'
                                    }
                                ],
                                data: {}
                                },
                                {
                                nodeType: 'text',
                                value: '\n',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: '\nModerna in the U.S. acts as a data controller and processes your personal data by determining the purposes and means of processing in accordance with the GDPR. Please note that your personal data will be stored on Aquia’s servers, including inside and outside the European Union. Before we transfer your personal data outside the EEA, we will take steps to ensure that such data receives the same level of protection as under applicable data protection laws within the EEA. For data transfers outside the EEA, we use applicable safeguards where necessary, including standard contractual clauses approved by the European Commission. A copy of these arrangements can be obtained by contacting us at the email address below.\n\n\n',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'heading-3',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'Your Privacy Rights',
                                marks: [
                                    {
                                    type: 'bold'
                                    }
                                ],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'As a data subject, you may have certain rights under applicable law. For example, you have the right to object to the processing of your personal data or\nto request a restriction of processing and the right to request access to the personal data we hold about you, as well as its correction, deletion and\nportability, subject to certain exceptions required by law. If you would like more information about our use of your personal data, or if you wish to exercise\nyour rights, please contact us at:',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: '\nModerna, Inc. 200 Technology Square, Cambridge, MA 02139 USA',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: '',
                                marks: [],
                                data: {}
                                },
                                {
                                nodeType: 'hyperlink',
                                data: {
                                    uri: 'mailto:Privacy@modernatx.com'
                                },
                                content: [
                                    {
                                    nodeType: 'text',
                                    value: 'Privacy@modernatx.com',
                                    marks: [],
                                    data: {}
                                    }
                                ]
                                },
                                {
                                nodeType: 'text',
                                value: '',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'EU residents:',
                                marks: [
                                    {
                                    type: 'bold'
                                    }
                                ],
                                data: {}
                                },
                                {
                                nodeType: 'text',
                                value: ' ',
                                marks: [],
                                data: {}
                                },
                                {
                                nodeType: 'hyperlink',
                                data: {
                                    uri: 'EUprivacy@modernatx.com'
                                },
                                content: [
                                    {
                                    nodeType: 'text',
                                    value: 'EUprivacy@modernatx.com',
                                    marks: [],
                                    data: {}
                                    }
                                ]
                                },
                                {
                                nodeType: 'text',
                                value: '\n\n',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'We will endeavor to provide requested information and make requested changes to the extent required and permied by applicable data protection laws and other laws and regulations. In any case, we will do our best to respond to you as soon as possible and inform you of the outcome of your request.\n\n',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'You can lodge a complaint with the competent supervisory authority if you believe that our processing of your personal data violates applicable law.',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'Contact information for all EU supervisory authorities can be found here.\n\n\n',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'heading-3',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'Information',
                                marks: [
                                    {
                                    type: 'bold'
                                    }
                                ],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'Moderna employs commercially reasonable administrative, technical, personnel, and physical security measures to protect the personal information in our possession from loss, the, and unauthorized use, disclosure, or alteration. Of course, despite these measures, we cannot guarantee perfect security of the networks, servers and databases operated by us or on our behalf. In particular, e-mails sent to or from the website may not be secure.',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: '',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'Therefore, you should be particularly careful about what information you send to us by e-mail. Please keep this in mind when you provide us with personal\ndata via the website.\n\n\n\n\n',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'heading-3',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'Data Storage',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'Your personal data will only be retained by Moderna for as long as is necessary to fulfil the purpose(s) for which it was collected, depending on the purpose(s) for which the personal data was collected, the nature of the personal data, any contractual relationship governing the retention of the personal data and our legal or regulatory obligations. We will then destroy or anonymize your personal data in accordance with applicable law.\n\n\n\n',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'heading-3',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'Email Communications',
                                marks: [
                                    {
                                    type: 'bold'
                                    }
                                ],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'In the event that we contact you, including by email, we will provide you with a method by which you can opt in or out of receiving further communications to the extent required by law. For example, you may choose to receive email updates on developments related to Moderna’s products and/or services, or on health-related specific topics (e.g., email updates on Moderna’s methylmalonic acid anemia (MMA)) by filling out the appropriate\nelectronic form “Sign up for our mailing list” on our website. If, at a later date, you decide that you no longer wish to receive such e-mail communications from us, you may unsubscribe from such a contact list by using the appropriate “unsubscribe” link within the relevant electronic communication channel or by sending us an e-mail titled “Unsubscribe from E-mail Updates” to ',
                                marks: [],
                                data: {}
                                },
                                {
                                nodeType: 'hyperlink',
                                data: {
                                    uri: 'mailto:privacy@modernatx.com'
                                },
                                content: [
                                    {
                                    nodeType: 'text',
                                    value: 'privacy@modernatx.com',
                                    marks: [],
                                    data: {}
                                    }
                                ]
                                },
                                {
                                nodeType: 'text',
                                value: ' or ',
                                marks: [],
                                data: {}
                                },
                                {
                                nodeType: 'hyperlink',
                                data: {
                                    uri: 'mailto:EUprivacy@modernatx.com'
                                },
                                content: [
                                    {
                                    nodeType: 'text',
                                    value: 'EUprivacy@modernatx.com',
                                    marks: [],
                                    data: {}
                                    }
                                ]
                                },
                                {
                                nodeType: 'text',
                                value: '.\n\n',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'heading-3',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'Our policy on dealing with children\n',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'We are commied to protecting children’s privacy. The content and services of this website are not intended for or directed at children under the age of 18. Visitors under the age of 18 or children under the age of 18 should not submit any personal information to Moderna through the Site.',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: '\nIf we become aware that a user of our website is under the age of 18 and has voluntarily provided personal information and/or health-related personal information, or that a healthcare professional has voluntarily provided personal information about a patient identified as under the age of 18 without the given or authorized consent of that child’s legal guardian, we will promptly endeavor to delete such personal information upon notice or request.\n\n\n',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'heading-3',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'CalOPPA Do-Not-Track Notice',
                                marks: [
                                    {
                                    type: 'bold'
                                    }
                                ],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'We do not track our website users over time and across third-party websites and therefore do not respond to Do Not Track (DNT) signals. Moderna does not authorize third parties to collect personal information directly from our users on our website, such as through the use of third-party advertising.\n\n\n\n',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'heading-3',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'Links to Third Party Websites\n\n',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'As a convenience to our visitors, this website may contain links to other websites that we believe provide useful information. These links may contain links to websites that may provide services to us. Please note that Moderna is not responsible for the privacy practices of these other websites and cannot guarantee the privacy standards of these other websites. Users of our website must be aware of this when they leave our website, and we encourage them to read the privacy statements of each website they visit that collects personal information. This Privacy Policy applies solely to information collected by our website and does not apply to linked websites that do not originate from Moderna.\n\n',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'heading-3',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'Notification of the Privacy Policy\n\n',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'Updates: If we change our privacy policy, we will post those changes on our website. If we make any changes to this Privacy Policy, we will update the date at the top of this Privacy Policy.\n\n\n\n',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'heading-3',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'For Additional Information',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'If you have any questions about this Privacy Policy or concerns about the practices of this website or your dealings with this website, or any privacyrelated maers generally, please email us at ',
                                marks: [],
                                data: {}
                                },
                                {
                                nodeType: 'hyperlink',
                                data: {
                                    uri: 'mailto:privacy@modernatx.com'
                                },
                                content: [
                                    {
                                    nodeType: 'text',
                                    value: 'privacy@modernatx.com',
                                    marks: [],
                                    data: {}
                                    }
                                ]
                                },
                                {
                                nodeType: 'text',
                                value: ' or contact us in writing at:',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'Moderna, Inc.',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'Aention: Legal Department 200 Technology Square,',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'Cambridge, MA 02139 USA\n',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'For EU/EEA residents',
                                marks: [
                                    {
                                    type: 'bold'
                                    }
                                ],
                                data: {}
                                },
                                {
                                nodeType: 'text',
                                value: ':\nPlease email us at ',
                                marks: [],
                                data: {}
                                },
                                {
                                nodeType: 'hyperlink',
                                data: {
                                    uri: 'mainto:contact@dpr.eu.com'
                                },
                                content: [
                                    {
                                    nodeType: 'text',
                                    value: 'contact@dpr.eu.com',
                                    marks: [],
                                    data: {}
                                    }
                                ]
                                },
                                {
                                nodeType: 'text',
                                value: '.',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'You can also contact us in writing at:',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'DPR Group Oce 29, Clion House Fitzwilliam Street Lower Dublin, Ireland\n',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: '\nFor all other questions or concerns, regardless of where you live, please contact us in writing at:\n',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'Moderna, Inc.',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'Aention: Corporate Communications200 Technology Square,',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'Cambridge,',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'MA 02139',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'USA\n\n',
                                marks: [],
                                data: {}
                                }
                            ]
                            }
                        ]
                        },
                        backToTopButtonLabel: 'Back To Top',
                        printButtonLabel: 'Print',
                        country: {
                        metadata: {
                            tags: [],
                            concepts: []
                        },
                        sys: {
                            space: {
                            sys: {
                                type: 'Link',
                                linkType: 'Space',
                                id: 'n9bebhw263o0'
                            }
                            },
                            id: '7DX7badGk41XRSy4znPNFI',
                            type: 'Entry',
                            createdAt: '2023-05-18T03:24:01.186Z',
                            updatedAt: '2023-05-24T23:04:52.125Z',
                            environment: {
                            sys: {
                                id: 'sandbox',
                                type: 'Link',
                                linkType: 'Environment'
                            }
                            },
                            publishedVersion: 5,
                            revision: 2,
                            contentType: {
                            sys: {
                                type: 'Link',
                                linkType: 'ContentType',
                                id: 'country'
                            }
                            },
                            locale: 'en-US'
                        },
                        fields: {
                            name: 'Germany',
                            isocode: 'DE',
                            flag: {
                            metadata: {
                                tags: [],
                                concepts: []
                            },
                            sys: {
                                space: {
                                sys: {
                                    type: 'Link',
                                    linkType: 'Space',
                                    id: 'n9bebhw263o0'
                                }
                                },
                                id: '1PJ5nPASFqJbHZkqrkOloj',
                                type: 'Asset',
                                createdAt: '2023-05-24T23:04:44.544Z',
                                updatedAt: '2023-05-24T23:04:44.544Z',
                                environment: {
                                sys: {
                                    id: 'sandbox',
                                    type: 'Link',
                                    linkType: 'Environment'
                                }
                                },
                                publishedVersion: 5,
                                revision: 1,
                                locale: 'en-US'
                            },
                            fields: {
                                title: 'Germany Flag',
                                description: 'Germany Flag',
                                file: {
                                url: '//images.ctfassets.net/n9bebhw263o0/1PJ5nPASFqJbHZkqrkOloj/586177dc5c2d17ea76a41a972053c188/de_flag.svg',
                                details: {
                                    size: 1305,
                                    image: {
                                    width: 36,
                                    height: 26
                                    }
                                },
                                fileName: 'de_flag.svg',
                                contentType: 'image/svg+xml'
                                }
                            }
                            },
                            locales: [
                            'en-DE'
                            ]
                        }
                        }
                    }
                    }
                ]
                }
            }
            }
        }
        }
    },
    {
        metadata: {
        tags: [],
        concepts: []
        },
        sys: {
        space: {
            sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'n9bebhw263o0'
            }
        },
        id: 'xveEzShRy3WE9HKcTBoSJ',
        type: 'Entry',
        createdAt: '2022-12-14T23:14:35.661Z',
        updatedAt: '2022-12-14T23:14:35.661Z',
        environment: {
            sys: {
            id: 'sandbox',
            type: 'Link',
            linkType: 'Environment'
            }
        },
        publishedVersion: 4,
        revision: 1,
        contentType: {
            sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'internalLink'
            }
        },
        locale: 'en-US'
        },
        fields: {
        title: 'Terms of Use Internal Link',
        label: 'Terms of Use',
        pageReference: {
            metadata: {
            tags: [],
            concepts: []
            },
            sys: {
            space: {
                sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'n9bebhw263o0'
                }
            },
            id: '6e8bR8NoNNipQ8XOsEQOLG',
            type: 'Entry',
            createdAt: '2022-12-14T23:05:15.872Z',
            updatedAt: '2022-12-14T23:05:15.872Z',
            environment: {
                sys: {
                id: 'sandbox',
                type: 'Link',
                linkType: 'Environment'
                }
            },
            publishedVersion: 11,
            revision: 1,
            contentType: {
                sys: {
                type: 'Link',
                linkType: 'ContentType',
                id: 'page'
                }
            },
            locale: 'en-US'
            },
            fields: {
            name: 'Terms of Use Content Page',
            title: 'Terms of Use',
            slug: 'terms-of-use',
            seo: {
                metadata: {
                tags: [],
                concepts: []
                },
                sys: {
                space: {
                    sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'n9bebhw263o0'
                    }
                },
                id: 'CPQIi2xudRdKj2B2xGLVK',
                type: 'Entry',
                createdAt: '2022-12-14T23:05:15.913Z',
                updatedAt: '2022-12-14T23:05:15.913Z',
                environment: {
                    sys: {
                    id: 'sandbox',
                    type: 'Link',
                    linkType: 'Environment'
                    }
                },
                publishedVersion: 6,
                revision: 1,
                contentType: {
                    sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'seo'
                    }
                },
                locale: 'en-US'
                },
                fields: {
                name: 'Terms of Use Content Page - Compose: SEO'
                }
            },
            content: {
                metadata: {
                tags: [],
                concepts: []
                },
                sys: {
                space: {
                    sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'n9bebhw263o0'
                    }
                },
                id: 'xg1DALHgYX18j87zlOP1C',
                type: 'Entry',
                createdAt: '2022-12-14T23:05:15.990Z',
                updatedAt: '2023-06-21T19:19:34.422Z',
                environment: {
                    sys: {
                    id: 'sandbox',
                    type: 'Link',
                    linkType: 'Environment'
                    }
                },
                publishedVersion: 16,
                revision: 5,
                contentType: {
                    sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'richTextContentPageTemplate'
                    }
                },
                locale: 'en-US'
                },
                fields: {
                name: 'Terms of Use Content Page - Rich Text Content Page Template',
                modules: [
                    {
                    metadata: {
                        tags: [],
                        concepts: []
                    },
                    sys: {
                        space: {
                        sys: {
                            type: 'Link',
                            linkType: 'Space',
                            id: 'n9bebhw263o0'
                        }
                        },
                        id: '4sgrY0r9g7t6f13PeJHKpN',
                        type: 'Entry',
                        createdAt: '2022-12-14T23:06:15.428Z',
                        updatedAt: '2023-06-16T18:23:00.168Z',
                        environment: {
                        sys: {
                            id: 'sandbox',
                            type: 'Link',
                            linkType: 'Environment'
                        }
                        },
                        publishedVersion: 16,
                        revision: 2,
                        contentType: {
                        sys: {
                            type: 'Link',
                            linkType: 'ContentType',
                            id: 'bannerComponent'
                        }
                        },
                        locale: 'en-US'
                    },
                    fields: {
                        title: 'Terms of Use Banner Component',
                        headline: 'Moderna\'s Terms and Conditions of Use',
                        backgroundImage: {
                        metadata: {
                            tags: [],
                            concepts: []
                        },
                        sys: {
                            space: {
                            sys: {
                                type: 'Link',
                                linkType: 'Space',
                                id: 'n9bebhw263o0'
                            }
                            },
                            id: '5zfGJA7or5WGcLdYi4Qde',
                            type: 'Asset',
                            createdAt: '2022-10-28T18:53:29.208Z',
                            updatedAt: '2022-10-28T18:53:29.208Z',
                            environment: {
                            sys: {
                                id: 'sandbox',
                                type: 'Link',
                                linkType: 'Environment'
                            }
                            },
                            publishedVersion: 6,
                            revision: 1,
                            locale: 'en-US'
                        },
                        fields: {
                            title: 'Banner BG Strand Top',
                            description: '',
                            file: {
                            url: '//images.ctfassets.net/n9bebhw263o0/5zfGJA7or5WGcLdYi4Qde/08c261eaf574cefa50f8fe8609ff531d/Banner_BG_Strand_Top_.png',
                            details: {
                                size: 47693,
                                image: {
                                width: 1920,
                                height: 511
                                }
                            },
                            fileName: 'Banner BG Strand Top .png',
                            contentType: 'image/png'
                            }
                        }
                        },
                        country: {
                        metadata: {
                            tags: [],
                            concepts: []
                        },
                        sys: {
                            space: {
                            sys: {
                                type: 'Link',
                                linkType: 'Space',
                                id: 'n9bebhw263o0'
                            }
                            },
                            id: '7sht7920U6vs3CLH2CUyaa',
                            type: 'Entry',
                            createdAt: '2023-05-18T03:23:50.744Z',
                            updatedAt: '2023-05-24T22:55:23.250Z',
                            environment: {
                            sys: {
                                id: 'sandbox',
                                type: 'Link',
                                linkType: 'Environment'
                            }
                            },
                            publishedVersion: 6,
                            revision: 2,
                            contentType: {
                            sys: {
                                type: 'Link',
                                linkType: 'ContentType',
                                id: 'country'
                            }
                            },
                            locale: 'en-US'
                        },
                        fields: {
                            name: 'United States',
                            isocode: 'US',
                            flag: {
                            metadata: {
                                tags: [],
                                concepts: []
                            },
                            sys: {
                                space: {
                                sys: {
                                    type: 'Link',
                                    linkType: 'Space',
                                    id: 'n9bebhw263o0'
                                }
                                },
                                id: '3aYCbZJiL8aoEKRdhjOXyy',
                                type: 'Asset',
                                createdAt: '2023-05-24T22:54:50.939Z',
                                updatedAt: '2023-05-24T22:54:50.939Z',
                                environment: {
                                sys: {
                                    id: 'sandbox',
                                    type: 'Link',
                                    linkType: 'Environment'
                                }
                                },
                                publishedVersion: 5,
                                revision: 1,
                                locale: 'en-US'
                            },
                            fields: {
                                title: 'usa flag',
                                description: 'USA Flag',
                                file: {
                                url: '//images.ctfassets.net/n9bebhw263o0/3aYCbZJiL8aoEKRdhjOXyy/f69a6f932a690dc632e7742c328c276d/usa_flag.svg',
                                details: {
                                    size: 2487,
                                    image: {
                                    width: 36,
                                    height: 26
                                    }
                                },
                                fileName: 'usa_flag.svg',
                                contentType: 'image/svg+xml'
                                }
                            }
                            },
                            locales: [
                            'en-US'
                            ]
                        }
                        }
                    }
                    },
                    {
                    metadata: {
                        tags: [],
                        concepts: []
                    },
                    sys: {
                        space: {
                        sys: {
                            type: 'Link',
                            linkType: 'Space',
                            id: 'n9bebhw263o0'
                        }
                        },
                        id: '2HSANBDxIPFfpe40wRrEzX',
                        type: 'Entry',
                        createdAt: '2023-06-16T18:24:56.749Z',
                        updatedAt: '2023-06-16T18:24:56.749Z',
                        environment: {
                        sys: {
                            id: 'sandbox',
                            type: 'Link',
                            linkType: 'Environment'
                        }
                        },
                        publishedVersion: 3,
                        revision: 1,
                        contentType: {
                        sys: {
                            type: 'Link',
                            linkType: 'ContentType',
                            id: 'bannerComponent'
                        }
                        },
                        locale: 'en-US'
                    },
                    fields: {
                        title: 'Terms of Use Banner Component - DE',
                        headline: 'Moderna\'s Terms and Conditions of Use',
                        backgroundImage: {
                        metadata: {
                            tags: [],
                            concepts: []
                        },
                        sys: {
                            space: {
                            sys: {
                                type: 'Link',
                                linkType: 'Space',
                                id: 'n9bebhw263o0'
                            }
                            },
                            id: '5zfGJA7or5WGcLdYi4Qde',
                            type: 'Asset',
                            createdAt: '2022-10-28T18:53:29.208Z',
                            updatedAt: '2022-10-28T18:53:29.208Z',
                            environment: {
                            sys: {
                                id: 'sandbox',
                                type: 'Link',
                                linkType: 'Environment'
                            }
                            },
                            publishedVersion: 6,
                            revision: 1,
                            locale: 'en-US'
                        },
                        fields: {
                            title: 'Banner BG Strand Top',
                            description: '',
                            file: {
                            url: '//images.ctfassets.net/n9bebhw263o0/5zfGJA7or5WGcLdYi4Qde/08c261eaf574cefa50f8fe8609ff531d/Banner_BG_Strand_Top_.png',
                            details: {
                                size: 47693,
                                image: {
                                width: 1920,
                                height: 511
                                }
                            },
                            fileName: 'Banner BG Strand Top .png',
                            contentType: 'image/png'
                            }
                        }
                        },
                        country: {
                        metadata: {
                            tags: [],
                            concepts: []
                        },
                        sys: {
                            space: {
                            sys: {
                                type: 'Link',
                                linkType: 'Space',
                                id: 'n9bebhw263o0'
                            }
                            },
                            id: '7DX7badGk41XRSy4znPNFI',
                            type: 'Entry',
                            createdAt: '2023-05-18T03:24:01.186Z',
                            updatedAt: '2023-05-24T23:04:52.125Z',
                            environment: {
                            sys: {
                                id: 'sandbox',
                                type: 'Link',
                                linkType: 'Environment'
                            }
                            },
                            publishedVersion: 5,
                            revision: 2,
                            contentType: {
                            sys: {
                                type: 'Link',
                                linkType: 'ContentType',
                                id: 'country'
                            }
                            },
                            locale: 'en-US'
                        },
                        fields: {
                            name: 'Germany',
                            isocode: 'DE',
                            flag: {
                            metadata: {
                                tags: [],
                                concepts: []
                            },
                            sys: {
                                space: {
                                sys: {
                                    type: 'Link',
                                    linkType: 'Space',
                                    id: 'n9bebhw263o0'
                                }
                                },
                                id: '1PJ5nPASFqJbHZkqrkOloj',
                                type: 'Asset',
                                createdAt: '2023-05-24T23:04:44.544Z',
                                updatedAt: '2023-05-24T23:04:44.544Z',
                                environment: {
                                sys: {
                                    id: 'sandbox',
                                    type: 'Link',
                                    linkType: 'Environment'
                                }
                                },
                                publishedVersion: 5,
                                revision: 1,
                                locale: 'en-US'
                            },
                            fields: {
                                title: 'Germany Flag',
                                description: 'Germany Flag',
                                file: {
                                url: '//images.ctfassets.net/n9bebhw263o0/1PJ5nPASFqJbHZkqrkOloj/586177dc5c2d17ea76a41a972053c188/de_flag.svg',
                                details: {
                                    size: 1305,
                                    image: {
                                    width: 36,
                                    height: 26
                                    }
                                },
                                fileName: 'de_flag.svg',
                                contentType: 'image/svg+xml'
                                }
                            }
                            },
                            locales: [
                            'en-DE'
                            ]
                        }
                        }
                    }
                    },
                    {
                    metadata: {
                        tags: [],
                        concepts: []
                    },
                    sys: {
                        space: {
                        sys: {
                            type: 'Link',
                            linkType: 'Space',
                            id: 'n9bebhw263o0'
                        }
                        },
                        id: '1AUKNUIiL6YEaYxpX7t22T',
                        type: 'Entry',
                        createdAt: '2022-12-14T19:48:58.589Z',
                        updatedAt: '2023-06-20T16:09:09.109Z',
                        environment: {
                        sys: {
                            id: 'sandbox',
                            type: 'Link',
                            linkType: 'Environment'
                        }
                        },
                        publishedVersion: 70,
                        revision: 8,
                        contentType: {
                        sys: {
                            type: 'Link',
                            linkType: 'ContentType',
                            id: 'richTextContentComponent'
                        }
                        },
                        locale: 'en-US'
                    },
                    fields: {
                        title: 'Terms of Use Rich Text Component - US',
                        effectiveDateLabel: 'Effective',
                        effectiveDate: '2018-11-09',
                        disclaimerMessage: 'Please read these terms carefully before accessing or using this website',
                        content: {
                        data: {},
                        content: [
                            {
                            data: {},
                            content: [
                                {
                                data: {},
                                marks: [],
                                value: 'Information about Us',
                                nodeType: 'text'
                                }
                            ],
                            nodeType: 'heading-3'
                            },
                            {
                            data: {},
                            content: [
                                {
                                data: {},
                                marks: [],
                                value: 'These Website Terms and Conditions of Use (“Terms”) describe the terms and conditions applicable to your use the website operated by (“Moderna”, “we”, “our” and “us”) and located at ',
                                nodeType: 'text'
                                },
                                {
                                data: {
                                    uri: 'https://www.modernatx.com'
                                },
                                content: [
                                    {
                                    data: {},
                                    marks: [],
                                    value: 'www.modernatx.com',
                                    nodeType: 'text'
                                    }
                                ],
                                nodeType: 'hyperlink'
                                },
                                {
                                data: {},
                                marks: [],
                                value: ' (the “Website”). We are a Delaware corporation and have our registered oGce at 200 Technology Square, Cambridge, MA 02139. All use of or linking to any content on the Website is subject to the terms and conditions contained in these\r\nTerms. By accessing or using the Website, you acknowledge that you have read, understood and agreed to these Terms and acknowledge that any prior agreements regarding the use of the Website between you and Moderna are superseded and of no force or eFect. If you do not agree to the Terms, do not access or use the Website. By using the Website, you represent that you are at least 18 years old.\n\r\nYou understand and agree that we may change these Terms at any time without prior notice. You may read a current, eFective copy of these Terms at any time by selecting the “Terms and Conditions of Use” link on the Website. Moderna may revise these terms at any time without prior notice. Any use of the Website aKer such date shall constitute your acceptance of such revised terms and conditions. If any change to these Terms is not acceptable to you, your sole remedy is to cease accessing, browsing and otherwise using the Website.\n\r\nYour access to and use of the Website is also subject to Moderna’s Privacy Policy located at ',
                                nodeType: 'text'
                                },
                                {
                                data: {
                                    uri: 'https://www.modernatx.com/privacy-statement'
                                },
                                content: [
                                    {
                                    data: {},
                                    marks: [],
                                    value: 'www.modernatx.com/privacy-statement',
                                    nodeType: 'text'
                                    }
                                ],
                                nodeType: 'hyperlink'
                                },
                                {
                                data: {},
                                marks: [],
                                value: ', the terms and conditions of which are hereby incorporated herein by reference.',
                                nodeType: 'text'
                                }
                            ],
                            nodeType: 'paragraph'
                            },
                            {
                            data: {},
                            content: [
                                {
                                data: {},
                                marks: [],
                                value: 'Use of Information',
                                nodeType: 'text'
                                }
                            ],
                            nodeType: 'heading-3'
                            },
                            {
                            data: {},
                            content: [
                                {
                                data: {},
                                marks: [],
                                value: 'You may freely browse, access, download or use information from the Website, including any text, images, audio, video and software ("',
                                nodeType: 'text'
                                },
                                {
                                data: {},
                                marks: [
                                    {
                                    type: 'italic'
                                    }
                                ],
                                value: 'Information',
                                nodeType: 'text'
                                },
                                {
                                data: {},
                                marks: [],
                                value: '") for your own temporary, non-commercial use. You have no rights in or to the Information, and you will not use, copy or display the Information, except as permitted under these Terms. No other use is permitted without our prior written consent. We may own the Information, or portions of the Information may be made available to us through arrangements that we have with third-parties. The Information is protected by United States and foreign intellectual property laws. Unauthorized use of the Information may result in violation of copyright, trademark, and other laws. You may not sell, transfer, assign, license, sublicense, or modify the Information or reproduce, display, publicly perform, make a derivative version of, distribute, transmit, reuse, repost, or otherwise use the Information in any way for any public or commercial purpose without our written permission. You may not use the Website or the Information from the Website (a) in any way that breaches any applicable local, national or international law or regulation; (b) in any way that is unlawful or fraudulent, or that has any unlawful or fraudulent purpose or effect; (c) to transmit, or procure the sending of, any unsolicited or unauthorized advertising or promotional material or any other form of similar solicitation (spam); or (d) to make unauthorized attempts to access any of our systems or third party networks. The use or posting of any of the Information on any other website or in a networked computer environment for any purpose is expressly prohibited. If you violate any part of these Terms, your right to access and/or use the Information and Site shall automatically terminate and you shall immediately destroy any copies you have made of the Information. We reserve the right to withdraw, amend or revise the Website without notice. We will not be liable if for any reason our Website is unavailable at any time or for any period. Nothing on this Website will be deemed to constitute an invitation to invest or otherwise deal in shares or other securities in Moderna.\n',
                                nodeType: 'text'
                                }
                            ],
                            nodeType: 'paragraph'
                            },
                            {
                            data: {},
                            content: [
                                {
                                data: {},
                                marks: [],
                                value: 'Copyright and Trademarks',
                                nodeType: 'text'
                                }
                            ],
                            nodeType: 'heading-3'
                            },
                            {
                            data: {},
                            content: [
                                {
                                data: {},
                                marks: [],
                                value: 'You must retain and reproduce each and every copyright notice or other proprietary rights notice contained in the original Information on any copy you make of the Information or in any Information you download. The intellectual property rights in the Website and in the Information are owned by Moderna, our affiliates or our external partners. You should assume that everything you see or read on the Website is copyrighted unless otherwise noted and may not be used without our written permission except as provided in these Terms or in the text on the Website. No links to the Website may be included in any other website without our prior written permission. With the exception of the foregoing limited authorization, no license to or right in the Information, or any copyright of Moderna or of any other party is granted or conferred to you.',
                                nodeType: 'text'
                                }
                            ],
                            nodeType: 'paragraph'
                            },
                            {
                            data: {},
                            content: [
                                {
                                data: {},
                                marks: [],
                                value: 'The trademarks, service marks, and logos of Moderna (the “',
                                nodeType: 'text'
                                },
                                {
                                data: {},
                                marks: [
                                    {
                                    type: 'italic'
                                    }
                                ],
                                value: 'Moderna Trademarks',
                                nodeType: 'text'
                                },
                                {
                                data: {},
                                marks: [],
                                value: '”) used and displayed on the Website are registered and unregistered trademarks or service marks of Moderna or its subsidiaries or affiliates. Other company, product, and service names located on the Website may be trademarks or service marks owned by third-parties (the “',
                                nodeType: 'text'
                                },
                                {
                                data: {},
                                marks: [
                                    {
                                    type: 'italic'
                                    }
                                ],
                                value: 'Third-Party Trademarks',
                                nodeType: 'text'
                                },
                                {
                                data: {},
                                marks: [],
                                value: '”, and, collectively with the Moderna Trademarks, the “',
                                nodeType: 'text'
                                },
                                {
                                data: {},
                                marks: [
                                    {
                                    type: 'italic'
                                    }
                                ],
                                value: 'Trademarks',
                                nodeType: 'text'
                                },
                                {
                                data: {},
                                marks: [],
                                value: '”). Nothing on the Website or in these Terms should be construed as granting, by implication, estoppel, or otherwise, any license or right, express or implied, under any Trademark displayed on the Website without the prior written consent of Moderna specific for each and every instance. The Trademarks may not be used to disparage Moderna or any third party, Moderna’s or a third-party’s products or services, or in any manner (using commercially reasonable judgment) that may damage any goodwill in the Trademarks. Links to the Website from other sites should be text-only and use of any Trademarks as part of a link to or from any website is prohibited without Moderna’s prior written consent. All goodwill generated from the use of any Moderna Trademark shall inure to Moderna’s benefit.',
                                nodeType: 'text'
                                }
                            ],
                            nodeType: 'paragraph'
                            },
                            {
                            data: {},
                            content: [
                                {
                                data: {},
                                marks: [],
                                value: 'Certain elements of the Website are protected by trade dress, trademark, unfair competition, and other U.S., state, federal, and international laws and may not be copied or imitated in whole or in part, by any means, including but not limited to, the use of framing or mirrors. None of the Information may be retransmitted without the express written consent from Moderna for each and every instance.',
                                nodeType: 'text'
                                }
                            ],
                            nodeType: 'paragraph'
                            },
                            {
                            data: {},
                            content: [
                                {
                                data: {},
                                marks: [],
                                value: 'Medical Advice',
                                nodeType: 'text'
                                }
                            ],
                            nodeType: 'heading-3'
                            },
                            {
                            data: {},
                            content: [
                                {
                                data: {},
                                marks: [],
                                value: 'The content on the Website is intended to be a general information resource in regard to the subject matter covered. Moderna does not directly or indirectly practice medicine, render medical advice, or dispense medical services via the Website, and nothing contained in the Website is intended to be instruction for medical diagnosis or treatment. Any information provided should not be considered complete, nor should it be relied on to suggest a basis for diagnosis or course of treatment for a particular individual. Information received from the Website should not be relied upon for personal, medical, legal, technical, or financial decisions. It should not be used in place of a visit, call, consultation or the advice of your physician or other qualified healthcare provider. Should you have any healthcare related questions, please consult with your physician or other qualified healthcare provider promptly.',
                                nodeType: 'text'
                                }
                            ],
                            nodeType: 'paragraph'
                            },
                            {
                            data: {},
                            content: [
                                {
                                data: {},
                                marks: [],
                                value: 'Links',
                                nodeType: 'text'
                                }
                            ],
                            nodeType: 'heading-3'
                            },
                            {
                            data: {},
                            content: [
                                {
                                data: {},
                                marks: [],
                                value: 'This Website may contain links to websites operated by other parties (“',
                                nodeType: 'text'
                                },
                                {
                                data: {},
                                marks: [
                                    {
                                    type: 'italic'
                                    }
                                ],
                                value: 'External Sites',
                                nodeType: 'text'
                                },
                                {
                                data: {},
                                marks: [],
                                value: '”). The External Sites are not under the control of Moderna, and Moderna is not responsible for the content available on any External Sites. Such links do not imply Moderna’s referral or endorsement of material on External Sites or of any other entity, item or service, and Moderna disclaims all liability with regard to your access to External Sites. We are not responsible for the content of any linked External Sites and do not make any representations regarding the content or accuracy of any materials on such External Sites. You should take precautions when downloading files from all websites to protect your computer from viruses and other destructive programs. Moderna provides links to External Sites as a convenience to users, and access to any External Sites linked to this Website is at your own risk.',
                                nodeType: 'text'
                                }
                            ],
                            nodeType: 'paragraph'
                            },
                            {
                            data: {},
                            content: [
                                {
                                data: {},
                                marks: [],
                                value: 'Forward-Looking Statements',
                                nodeType: 'text'
                                }
                            ],
                            nodeType: 'heading-3'
                            },
                            {
                            data: {},
                            content: [
                                {
                                data: {},
                                marks: [],
                                value: 'The Website contains express or implied forward-looking statements within the meaning of the Private Securities Litigation Reform Act of 1995, as amended, Section 27A of the Securities Act of 1933, as amended, and Section 21E of the Securities Exchange Act of 1934, that are based on beliefs and assumptions and on information currently available to Moderna’s management. These statements relate to, among other things, Moderna’s expectations regarding plans, objectives, strategies, future operating or financial performance, business plans and prospects, and expectations regarding clinical trials, development timelines, discussions with regulatory authorities, development programs, development candidates and investigational medicines under development by Moderna and by Moderna’s strategic collaborators. In some cases, forward-looking statements can be identified by terminology such as “may,” “should,” “expects,” “intends,” “plans,” “anticipates,” “believes,” “estimates,” “predicts,” “potential,” “continue,” or the negative of these terms or other comparable terminology, although not all forward-looking statements contain these words. Such statements are based on Moderna’s management’s current expectations and are subject to certain factors, risks and uncertainties that may cause actual results to differ materially from those referred to or implied in such statements. The information presented on the Website is believed to be current as of the date of its original publication. The forward-looking statements on this Website are neither promises nor guarantees, and you should not place undue reliance on these forward-looking statements because they involve known and unknown risks, uncertainties and other factors, many of which are beyond Moderna’s control and which could cause actual results to differ materially from those expressed or implied by these forward-looking statements. Moderna does not intend to update any forward-looking statements appearing on the Website in the event of changing circumstances or otherwise, and such statements are current only as of the date they are made.',
                                nodeType: 'text'
                                }
                            ],
                            nodeType: 'paragraph'
                            },
                            {
                            data: {},
                            content: [
                                {
                                data: {},
                                marks: [],
                                value: 'Please note that while Moderna’s filings with the United States Securities and Exchange Commission are available on or through Internet links contained on the Website, no information contained on or available through the Website is incorporated by reference into or considered to be part of such filings.',
                                nodeType: 'text'
                                }
                            ],
                            nodeType: 'paragraph'
                            },
                            {
                            data: {},
                            content: [
                                {
                                data: {},
                                marks: [],
                                value: 'Updates',
                                nodeType: 'text'
                                }
                            ],
                            nodeType: 'heading-3'
                            },
                            {
                            data: {},
                            content: [
                                {
                                data: {},
                                marks: [],
                                value: 'Moderna may make changes, corrections and/or improvements to the Information, and to the products and programs described in such Information, at any time without notice. Although we attempt to periodically update the Website, the Information, materials and services provided on or through the Website may occasionally be inaccurate, incomplete or out of date and are provided on an “AS IS” and “AS AVAILABLE” basis. Moderna does not have a duty to update information contained in the Website, and Moderna will not be liable for any failure to update such information. We make no representation as to the completeness, accuracy or currency of any information on the Website, and we undertake no obligation to update or revise the information contained on the Website, whether as a result of new information, future events or circumstances or otherwise. It is your responsibility to verify any information contained in the Website before relying upon it.',
                                nodeType: 'text'
                                }
                            ],
                            nodeType: 'paragraph'
                            },
                            {
                            data: {},
                            content: [
                                {
                                data: {},
                                marks: [],
                                value: 'Disclaimer of Warranties',
                                nodeType: 'text'
                                }
                            ],
                            nodeType: 'heading-3'
                            },
                            {
                            data: {},
                            content: [
                                {
                                data: {},
                                marks: [],
                                value: 'MODERNA, ITS SUBSIDIARIES AND OTHER AFFILIATES AND THEIR RESPECTIVE OFFICERS, DIRECTORS, EMPLOYEES, AGENTS, SUPPLIERS, STRATEGIC COLLABORATORS, AND LICENSORS (COLLECTIVELY, THE “',
                                nodeType: 'text'
                                },
                                {
                                data: {},
                                marks: [
                                    {
                                    type: 'italic'
                                    }
                                ],
                                value: 'MODERNA PARTIES',
                                nodeType: 'text'
                                },
                                {
                                data: {},
                                marks: [],
                                value: '“) MAKE NO WARRANTIES OR REPRESENTATIONS AND DO NOT GIVE ANY UNDERTAKINGS, EITHER EXPRESS OR IMPLIED, ABOUT THE WEBSITE OR THE INFORMATION (INCLUDING, WITHOUT LIMITATION, THE TIMELINESS, CURRENCY, ACCURACY, COMPLETENESS OR FITNESS FOR ANY PARTICULAR PURPOSE OF THE INFORMATION OR THAT THE RESULTS WHICH MAY BE OBTAINED FORM THE USE OF THE WEBSITE WILL BE ERROR FREE OR RELIABLE.)',
                                nodeType: 'text'
                                }
                            ],
                            nodeType: 'paragraph'
                            },
                            {
                            data: {},
                            content: [
                                {
                                data: {},
                                marks: [],
                                value: 'Limitation of Liability',
                                nodeType: 'text'
                                }
                            ],
                            nodeType: 'heading-3'
                            },
                            {
                            data: {},
                            content: [
                                {
                                data: {},
                                marks: [],
                                value: 'THE MODERNA PARTIES WILL NOT BE LIABLE FOR ANY DIRECT, INCIDENTAL, CONSEQUENTIAL, INDIRECT, SPECIAL OR PUNITIVE DAMAGES ARISING OUT OF ACCESS TO, USE OF OR INABILITY TO USE THIS WEBSITE, OR ANY ERRORS OR OMISSIONS IN THE INFORMATION INCLUDING, WITHOUT LIMITATION ANY LIABILITY FOR (I) LOSS OF INCOME OR REVENUE, (II) LOSS OF BUSINESS OR BUSINESS INTERRUPTION, (III) LOSS OF PROFITS OR CONTRACTS, (IV) LOSS OF ANTICIPATED SAVINGS, (V) LOSS OF DATA, (VI) LOSS OF GOODWILL, (VII) WASTED MANAGEMENT OR OFFICE TIME; AND (VIII) FOR ANY OTHER LOSS OR DAMAGE OF ANY KIND, HOWEVER ARISING AND WHETHER CAUSED BY TORT (INCLUDING NEGLIGENCE), BREACH OF CONTRACT OR OTHERWISE, EVEN IF FORESEEABLE. ADDITIONALLY, THE MODERNA PARTIES SHALL NOT BE SUBJECT TO LIABILITY FOR THE TRUTH, ACCURACY OR COMPLETENESS OF THE INFORMATION, FOR ERRORS, MISTAKES OR OMISSIONS THEREIN OR FOR ANY DELAYS OR INTERRUPTIONS OF THE DATA OR INFORMATION STREAM FROM WHATEVER CAUSE. YOU USE THE WEBSITE AND THE INFORMATION AT YOUR OWN RISK.',
                                nodeType: 'text'
                                }
                            ],
                            nodeType: 'paragraph'
                            },
                            {
                            data: {},
                            content: [
                                {
                                data: {},
                                marks: [],
                                value: 'THE MODERNA PARTIES DO NOT WARRANT THAT THE WEBSITE WILL OPERATE ERROR FREE OR THAT THE WEBSITE, ITS SERVER, OR THE INFORMATION ARE FREE OF COMPUTER VIRUSES OR SIMILAR CONTAMINATION OR DESTRUCTIVE FEATURES. IF YOUR USE OF THE WEBSITE OR THE INFORMATION RESULTS IN THE NEED FOR SERVICING OR REPLACING EQUIPMENT OR DATA, NO MODERNA PARTY SHALL BE RESPONSIBLE FOR THOSE COSTS.',
                                nodeType: 'text'
                                }
                            ],
                            nodeType: 'paragraph'
                            },
                            {
                            data: {},
                            content: [
                                {
                                data: {},
                                marks: [],
                                value: 'THE WEBSITE AND INFORMATION ARE PROVIDED ON AN “AS IS” AND “AS AVAILABLE” BASIS WITHOUT ANY WARRANTIES OF ANY KIND. THE MODERNA PARTIES DISCLAIM ALL WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE WARRANTIES OF TITLE, MERCHANTABILITY, NON-INFRINGEMENT OF THIRD PARTIES RIGHTS, AND FITNESS FOR PARTICULAR PURPOSE.',
                                nodeType: 'text'
                                }
                            ],
                            nodeType: 'paragraph'
                            },
                            {
                            data: {},
                            content: [
                                {
                                data: {},
                                marks: [],
                                value: 'Some jurisdictions do not allow the disclaimer or exclusion of certain warranties or the limitation or exclusion of liability for incidental or consequential damages. Accordingly, some of the above exclusions or limitations may not apply to you or be enforceable with respect to you. We also do not assume any responsibility, and will not be liable, for any damages to, or viruses that may infect, your computer equipment or other property on account of your access to, or use of, the Information. Moderna reserves the right to discontinue the Website at any time without notice and without liability.',
                                nodeType: 'text'
                                }
                            ],
                            nodeType: 'paragraph'
                            },
                            {
                            data: {},
                            content: [
                                {
                                data: {},
                                marks: [],
                                value: 'Information You Supply to Us',
                                nodeType: 'text'
                                }
                            ],
                            nodeType: 'heading-3'
                            },
                            {
                            data: {},
                            content: [
                                {
                                data: {},
                                marks: [],
                                value: 'Any communication or material you transmit to us by electronic mail or otherwise, including any data, questions, comments, suggestions or the like is, and will be treated as, non-confidential and nonproprietary, and Moderna shall have no obligation of any kind with respect to such information. Anything you transmit or post becomes the property of Moderna and may be used by Moderna and any of its subsidiaries, affiliates, strategic collaborators and third-party service providers for any purpose, including, but not limited to, reproduction, disclosure, transmission, publication, broadcast and posting. Moderna and its subsidiaries, affiliates, strategic collaborators and third-party service providers are free to use, without compensation to you, any ideas, concepts, know-how, or techniques contained in any communication you send to the Website for any purpose whatsoever including, but not limited to, researching, developing, manufacturing and marketing products using or incorporating such information. Any information submitted or provided by you to the Website might be publicly accessible. Important and private information should be protected by you. Moderna is not liable for protection of privacy of email or other information transferred through the Internet or any other network that you may use.',
                                nodeType: 'text'
                                }
                            ],
                            nodeType: 'paragraph'
                            },
                            {
                            data: {},
                            content: [
                                {
                                data: {},
                                marks: [],
                                value: 'Worldwide Products',
                                nodeType: 'text'
                                }
                            ],
                            nodeType: 'heading-3'
                            },
                            {
                            data: {},
                            content: [
                                {
                                data: {},
                                marks: [],
                                value: 'The Website may contain information on our current or potential future worldwide products and services, not all of which are available in every location. A reference to a product or service on the Website does not imply that such product or service is or will be available in your location. The products referred to on this website may be subject to different regulatory requirements depending on the country of use. Consequently, visitors may be notified that certain sections of the Website are intended only for certain kinds of expert users or only for audiences in certain countries. You should not construe anything on the Website as a promotion or advertisement for any product or for the use of any product that is not authorized by the laws and regulations of your country of residence.',
                                nodeType: 'text'
                                }
                            ],
                            nodeType: 'paragraph'
                            },
                            {
                            data: {},
                            content: [
                                {
                                data: {},
                                marks: [],
                                value: 'Applicable Law',
                                nodeType: 'text'
                                }
                            ],
                            nodeType: 'heading-3'
                            },
                            {
                            data: {},
                            content: [
                                {
                                data: {},
                                marks: [],
                                value: 'You are solely responsible for ensuring compliance with the laws of your specific jurisdiction. The Website can be accessed from every U.S. state, as well as from other countries around the world. Each of those places has laws that may differ from those of Massachusetts, where Moderna is located. By accessing the Website, you and Moderna agree that the laws of The Commonwealth of Massachusetts, without regard to its conflicts of laws principles, will apply to all disputes based on, arising out of, or relating to your use of the Website or any information it contains. With respect to such disputes, you and Moderna also agree and hereby submit to the exclusive personal jurisdiction and venue of any court located in Boston, Massachusetts.',
                                nodeType: 'text'
                                }
                            ],
                            nodeType: 'paragraph'
                            },
                            {
                            data: {},
                            content: [
                                {
                                data: {},
                                marks: [],
                                value: 'You will comply with any applicable export restrictions under any applicable export control laws and not to export or re-export any of the Information to countries or persons prohibited under such export control laws. If you are in a country where such export is prohibited or are a person or entity for which such export is prohibited, you may not download any Information. You are solely responsible for compliance with the laws of your specific jurisdiction regarding the import, export, or re-export of the Information.',
                                nodeType: 'text'
                                }
                            ],
                            nodeType: 'paragraph'
                            },
                            {
                            data: {},
                            content: [
                                {
                                data: {},
                                marks: [],
                                value: 'The Information is provided with “RESTRICTED RIGHTS.” Use, duplication, or disclosure by the U.S. Government is subject to the restrictions contained in 48 CFR 52.227-19 and 48 CFR 252.227-7013 et seq. or its successor. Use of the Website or Information by the U.S. Government constitutes acknowledgement of our proprietary rights in the Website and Information.',
                                nodeType: 'text'
                                }
                            ],
                            nodeType: 'paragraph'
                            },
                            {
                            data: {},
                            content: [
                                {
                                data: {},
                                marks: [],
                                value: 'If any provision of these Terms is found to be unlawful, invalid or unenforceable by any court having competent jurisdiction, the invalidity or unenforceability of such provision shall not affect the validity of the remaining provisions of these Terms, which shall remain in full force and effect. Failure of Moderna to act on or enforce any provision of these Terms shall not be construed as a waiver of that provision or any other provision in these Terms. No waiver shall be effective against Moderna unless made in writing, and no such waiver shall be construed as a waiver in any other or subsequent instance. Except as expressly agreed by Moderna and you in writing, these Terms constitute the entire agreement between you and Moderna with respect to the subject matter and supersedes all previous or contemporaneous agreements, whether written or oral, between the parties with respect to the subject matter. The section headings are provided merely for convenience and shall not be given any legal import. Moderna may assign its ownership, control, or other rights to any party at any time without notice to you.',
                                nodeType: 'text'
                                }
                            ],
                            nodeType: 'paragraph'
                            },
                            {
                            data: {},
                            content: [
                                {
                                data: {},
                                marks: [],
                                value: 'These terms will inure to the benefit of our successors, assigns, licensees, and sublicensees.',
                                nodeType: 'text'
                                }
                            ],
                            nodeType: 'paragraph'
                            }
                        ],
                        nodeType: 'document'
                        },
                        backToTopButtonLabel: 'Back To Top',
                        printButtonLabel: 'Print',
                        country: {
                        metadata: {
                            tags: [],
                            concepts: []
                        },
                        sys: {
                            space: {
                            sys: {
                                type: 'Link',
                                linkType: 'Space',
                                id: 'n9bebhw263o0'
                            }
                            },
                            id: '7sht7920U6vs3CLH2CUyaa',
                            type: 'Entry',
                            createdAt: '2023-05-18T03:23:50.744Z',
                            updatedAt: '2023-05-24T22:55:23.250Z',
                            environment: {
                            sys: {
                                id: 'sandbox',
                                type: 'Link',
                                linkType: 'Environment'
                            }
                            },
                            publishedVersion: 6,
                            revision: 2,
                            contentType: {
                            sys: {
                                type: 'Link',
                                linkType: 'ContentType',
                                id: 'country'
                            }
                            },
                            locale: 'en-US'
                        },
                        fields: {
                            name: 'United States',
                            isocode: 'US',
                            flag: {
                            metadata: {
                                tags: [],
                                concepts: []
                            },
                            sys: {
                                space: {
                                sys: {
                                    type: 'Link',
                                    linkType: 'Space',
                                    id: 'n9bebhw263o0'
                                }
                                },
                                id: '3aYCbZJiL8aoEKRdhjOXyy',
                                type: 'Asset',
                                createdAt: '2023-05-24T22:54:50.939Z',
                                updatedAt: '2023-05-24T22:54:50.939Z',
                                environment: {
                                sys: {
                                    id: 'sandbox',
                                    type: 'Link',
                                    linkType: 'Environment'
                                }
                                },
                                publishedVersion: 5,
                                revision: 1,
                                locale: 'en-US'
                            },
                            fields: {
                                title: 'usa flag',
                                description: 'USA Flag',
                                file: {
                                url: '//images.ctfassets.net/n9bebhw263o0/3aYCbZJiL8aoEKRdhjOXyy/f69a6f932a690dc632e7742c328c276d/usa_flag.svg',
                                details: {
                                    size: 2487,
                                    image: {
                                    width: 36,
                                    height: 26
                                    }
                                },
                                fileName: 'usa_flag.svg',
                                contentType: 'image/svg+xml'
                                }
                            }
                            },
                            locales: [
                            'en-US'
                            ]
                        }
                        }
                    }
                    },
                    {
                    metadata: {
                        tags: [],
                        concepts: []
                    },
                    sys: {
                        space: {
                        sys: {
                            type: 'Link',
                            linkType: 'Space',
                            id: 'n9bebhw263o0'
                        }
                        },
                        id: '7rSkinNLdOrCD7IDSdKH7b',
                        type: 'Entry',
                        createdAt: '2023-05-24T19:21:51.275Z',
                        updatedAt: '2023-06-16T17:43:18.090Z',
                        environment: {
                        sys: {
                            id: 'sandbox',
                            type: 'Link',
                            linkType: 'Environment'
                        }
                        },
                        publishedVersion: 186,
                        revision: 29,
                        contentType: {
                        sys: {
                            type: 'Link',
                            linkType: 'ContentType',
                            id: 'richTextContentComponent'
                        }
                        },
                        locale: 'en-US'
                    },
                    fields: {
                        title: 'Terms of Use Rich Text Component - DE',
                        effectiveDateLabel: 'Effective',
                        effectiveDate: '2023-01-07',
                        disclaimerMessage: 'Please read these terms carefully before accessing or using this website',
                        content: {
                        nodeType: 'document',
                        data: {},
                        content: [
                            {
                            nodeType: 'heading-3',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'Information about Us',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'These Website Terms and Conditions (“Terms”) describe the terms and conditions that apply to your use of the website operated by (“Moderna”, “we”, “our” and “us”). We are a corporation incorporated under the laws of the State of Delaware (Delaware Corporation) and have our registered oce at 200 Technology Square, Cambridge, MA 02139, USA. Any use of or linking to any content on the Site is subject to the terms and conditions contained in these\nTerms. By accessing or using the Site, you acknowledge that you have read, understood, and agreed to these Terms, and acknowledge that any prior\nagreements regarding the use of the Site between you and Moderna are superseded and have no eect. If you do not agree to the Terms, you may not\naccess or use the Site. By using the Website, you represent that you are at least 18 years old.\n',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'You understand and agree that we may change these Terms at any time without notice. You can read a current, valid copy of these Terms at any time by\nclicking on the “Terms and Conditions” link on the Website. Moderna may revise these Terms at any time without notice. Any use of the Site aer such\ndate shall be deemed acceptance of these revised Terms and Conditions. If any modification of these Terms is unacceptable to you, your sole remedy is\nto cease accessing, browsing and other use of the Site.\n',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'Your access to and use of the Site is also subject to Moderna’s Privacy Policy, which can be found at hps://www.modernatx.com/de-de/privacystatement, the terms of which are incorporated by this reference into this Statement.\n',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'heading-3',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: '\n',
                                marks: [],
                                data: {}
                                },
                                {
                                nodeType: 'text',
                                value: 'Copyright and Trademarks',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'You may freely browse, access, download or use the information on the Site, including all text, images, audio and video files, and soware (“Information”) for your own temporary, non-commercial use. You have no rights to the information, and you will not use, copy or display the information except as permied in these terms. Any other use is not permied without our prior wrien permission. We may own the information, or portions of the information may be made available to us through agreements we have entered into with third parties. The information is protected by U.S. and foreign intellectual property laws. Unauthorized use of the information may result in a violation of copyright, trademark and other laws. You may not sell, transfer, assign, license, sublicense, or modify the Information, or reproduce, display, publicly perform, create a derivative version of, distribute, transmit, reuse, repost, or otherwise exploit the Information for any public or commercial purpose without our wrien permission. You may not use the Site or the Site’s information (a) in any manner that violates any applicable local, national, or international law or regulation; (b) use in any way that is unlawful, fraudulent or serves any unlawful or fraudulent purpose or eect; (c) transmit or cause to be sent unsolicited or unauthorized advertising or promotional materials or other forms of similar solicitation (spam); or (d) make unauthorized aempts to access any of our third-party systems or networks. It is expressly prohibited to use or publish the information on any other website or in a networked computer environment for any purpose. If you breach any part of these Terms, your right to access and/or use the Information and the Website will automatically cease and you will immediately destroy any copies you have made of the Information.\n',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'We reserve the right to withdraw, modify or revise the website without prior notice. We will not be liable if, for any reason, our website is unavailable at any time or for any period. Nothing on this website constitutes a solicitation to invest in or otherwise deal in any Moderna stock or other securities.\n\n',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'heading-3',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'Use of Information',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: '\nYou must retain and reproduce all copyright notices or other proprietary rights notices contained in the original information on any copy you make of the information and in any information you download. The copyrights in the Site and Information are owned by Moderna, our aliates, or our third-party partners. You should assume that everything you see or read on the Website is copyrighted, unless otherwise stated, and may not be used without our wrien permission, except as provided in these Terms or in the text on the Website. No links to this website may be included in other websites without our prior wrien permission. Except for the foregoing limited authorization, no license or right to the Information or any copyright of Moderna or any other party is granted or transferred to you.\n',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'Moderna’s trademarks, service marks, and logos (the “Moderna Marks”) used and displayed on the Site are registered and unregistered trademarks or service marks of Moderna or its subsidiaries or aliates. Other company, product and service names on the Site may be trademarks or service marks owned by third parties (the “Third Party Marks” and, together with the Moderna Marks, the “Marks”). Nothing contained on the Site or in these Terms shall be construed as granting, by implication, estoppel, or otherwise, any license or right, express or implied, under any trademark displayed on the Site, without Moderna’s prior wrien permission specifically for each individual case. The Trademarks may not be used to disparage Moderna, a third party, Moderna’s or any third party’s products or services, or in any manner (using a commercially reasonable judgment) that could damage the market value of\nthe Trademarks. Links to the website from other websites should be text only, and the use of trademarks as part of a link to or from a website is prohibited without the prior wrien permission of Moderna. All of the brand equity that comes from using a Moderna brand benefits Moderna.\n',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'Certain elements of the Site are protected by utility models, trademarks, unfair competition laws, and other U.S., state, and international laws, and may not\nbe copied or imitated, in whole or in part, including, but not limited to, the use of framing and mirrors. None of the information may be disclosed without\nthe express wrien permission of Moderna for each individual case\n\n',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'heading-3',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'Medical Advice\n',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'The content of the website is intended as a general source of information regarding the topics covered. Moderna does not directly or indirectly engage in any medical activity, does not provide medical advice, or provide medical services through the Site, and nothing contained on the Site is intended to be a guide to any medical diagnosis or treatment. The information provided should not be considered complete, nor should it be used as a basis for a diagnosis or course of treatment for a particular person. The information obtained from the website should not be used to make personal, medical, legal, technical or financial decisions. These should not be used in lieu of a visit, call, consultation, or advice from your physician or other qualified healthcare provider. If you have any questions about your health, please contact your physician or other qualified healthcare provider immediately.\n\n',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'heading-3',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'Links',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'This Site may contain links to websites operated by other parties (“External Sites”). The external websites are not under the control of Moderna, and Moderna is not responsible for the content available on external websites. Such links do not imply that Moderna endorses or endorses the material on the External Sites or any other entity, item or service, and Moderna disclaims any and all liability with respect to your access to External Sites. We are not\nresponsible for the content of linked external sites and make no representations regarding the content or accuracy of any materials on such external sites. You should take precautions when downloading files from all websites to protect your computer from viruses and other destructive programs. Moderna provides links to external websites as a convenience to users, and access to external websites linked to this website is at the user’s own risk\n',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'heading-3',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: '\n\nForward Looking Statements\n',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'The Site contains express or implied forward-looking statements within the meaning of the Private Securities Litigation Reform Act of 1995, as amended, Section 27A of the Securities Act of 1933, as amended, and Section 21E of the Securities Exchange Act of 1934, which are based on beliefs and assumptions and information currently available to Moderna’s management. These statements relate to, among other things, Moderna’s expectations\nregarding plans, objectives, strategies, future operating or financial results, business plans and prospects, and expectations with respect to clinical trials, development timelines, discussions with regulatory authorities, development programs, development candidates and investigational drugs being developed by Moderna and Moderna’s strategic collaborative partners. In some cases, forward-looking statements can be identified by words such as\n“may”, “should”, “expect”, “intend”, “plan”, “anticipate”, “believe”, “estimate”, “predict”,\n“potential”, “continue” or the negation of these terms or other comparable terms, even if not all forward-looking statements contain these words. Such statements are based on the current expectations of Moderna’s management and are subject to certain factors, risks and uncertainties that could cause actual results to dier materially from those expressed or implied by such statements. The information presented on the website is assumed to be up-to-date at the time of its original publication. The forward-looking statements on this website are neither promises nor warranties, and you should not place undue reliance on these forward-looking statements because they involve known and unknown risks, uncertainties and other factors, many of which are beyond Moderna’s control, which could cause actual results to dier materially from those expressed or implied by such forward-looking statements Results dier. Moderna does not intend to update the forwardlooking statements appearing on the Site as circumstances change or otherwise, and such statements are current only as of the date they are made. ',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'Please note that while Moderna’s filings with the U.S. Securities and Exchange Commission are available on the Site or through Internet links on the Site, no information contained on or available through the Site will be incorporated by reference into or considered part of such materials.\n\n',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'heading-3',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'Updates',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: '\nModerna may, at any time and without notice, make changes, corrections and/or improvements to the information and to the products and programs described in such information. Although we aempt to update the Website regularly, the information, materials and services provided on or through the Website may occasionally be inaccurate, incomplete or out of date and are provided on an “AS IS” and “AVAILABLE” basis. Moderna is under no obligation to update the information contained on the Site, and Moderna shall not be liable for any failure to update such information. We do not warrant the completeness, accuracy or timeliness of the information on the Site, and we make no commitment to update or revise the information contained on the Site, whether as a result of new information, future events or circumstances, or otherwise. It is your responsibility to review all information contained on\nthe website before relying on it.\n\n',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'heading-3',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'Exclusion of Warranties',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: '\nMODERNA, ITS SUBSIDIARIES AND OTHER AFFILIATES AND THEIR RESPECTIVE OFFICERS, DIRECTORS, EMPLOYEES, AGENTS, SUPPLIERS, STRATEGIC COLLABORATORS AND LICENSORS (COLLECTIVELY, THE “MODERNA PARTIES”) MAKE NO WARRANTIES OR REPRESENTATIONS AND MAKE NO WARRANTIES WITH RESPECT TO THE SITE OR THE INFORMATION (INCLUDING, BUT NOT LIMITED TO, TIMELINESS, ACCURACY, COMPLETENESS, OR\nSUITABILITY FOR THE SITE). A SPECIFIC PURPOSE OF THE INFORMATION OR THAT THE RESULTS THAT MAY BE OBTAINED FROM THE USE OF THE WEBSITE ARE ERROR-FREE OR RELIABLE.)',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: '',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'heading-3',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'Limitation of Liability',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: '\nMODERNA’S PARTIES SHALL NOT BE LIABLE FOR ANY DIRECT, INCIDENTAL, CONSEQUENTIAL, INDIRECT, SPECIAL, OR PUNITIVE DAMAGES ARISING OUT\nOF ACCESS TO, USE, OR INABILITY TO USE THIS SITE, OR FROM ANY ERRORS OR OMISSIONS IN THE INFORMATION, INCLUDING WITHOUT LIMITATION ANY LIABILITY FOR (I) LOSS OF REVENUE OR INCOME, (II) LOSS OF BUSINESS OR BUSINESS INTERRUPTION, (III) LOSS OF PROFITS OR ORDERS, (IV) LOSS OF ANTICIPATED SAVINGS, (V) LOSS OF DATA, (VI) LOSS OF MARKET VALUE, (VII) WASTED MANAGEMENT OR OFFICE TIME; AND (VIII) FOR ANY\nOTHER LOSS OR DAMAGE OF ANY KIND, REGARDLESS OF THE CONDITIONS OF ITS OCCURRENCE AND WHETHER CAUSED BY TORT (INCLUDING NEGLIGENCE), BREACH OF CONTRACT OR OTHERWISE, EVEN IF FORESEEABLE. IN ADDITION, THE MODERNA PARTIES ASSUME NO LIABILITY FOR THE TRUTH, ACCURACY OR COMPLETENESS OF THE INFORMATION, FOR ANY ERRORS, MISTAKES OR OMISSIONS THEREIN, OR FOR ANY DELAYS OR INTERRUPTIONS IN THE FLOW OF DATA OR INFORMATION, FOR ANY REASON. YOU USE THE WEBSITE AND THE INFORMATION AT YOUR OWN RISK. THE MODERNA PARTIES DO NOT WARRANT THAT THE SITE WILL OPERATE ERROR-FREE OR THAT THE SITE, ITS SERVER, OR INFORMATION ARE FREE OF COMPUTER VIRUSES OR SIMILAR CONTAMINATION OR DESTRUCTIVE FEATURES. IF YOUR USE OF THE SITE OR INFORMATION RESULTS IN THE\nNEED FOR MAINTENANCE OR REPLACEMENT OF EQUIPMENT OR DATA, NO MODERNA PARTY IS RESPONSIBLE FOR SUCH COSTS. THE WEBSITE AND THE INFORMATION ARE PROVIDED ON AN “AS IS” AND “AS AVAILABLE” BASIS WITHOUT ANY WARRANTIES OF ANY KIND. THE MODERNA PARTIES DISCLAIM ALL WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE WARRANTIES OF TITLE, MERCHANTABILITY, NONINFRINGEMENT OF THIRD PARTY RIGHTS, AND FITNESS FOR A PARTICULAR PURPOSE.\n\n',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'Some jurisdictions do not allow the exclusion of certain warranties or the limitation or exclusion of liability for incidental or consequential damages. Accordingly, some of the above exclusions or limitations may not apply to you or be enforceable with respect to you. We also assume no responsibility and will not be liable for any damage or viruses that infect your computer equipment or other property as a result of your access to or use of the\ninformation. Moderna reserves the right to discontinue the Site at any time without notice and without liability\n\n',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'heading-3',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'Information You Provide to Us\n',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'Any communication or material you transmit to us by email or otherwise, including any data, questions, comments, suggestions, or the like, is and will be treated as non-confidential and non-proprietary, and Moderna has no obligations whatsoever with respect to such information. Everything you transmit or post becomes the property of Moderna and may be used by Moderna and its subsidiaries, aliates, strategic collaborators, and third-party service\nproviders for any purpose, including, but not limited to, reproduction, disclosure, transmission, publication, broadcasting, and posting. Moderna and its subsidiaries, aliates, strategic collaborators, and third-party service providers are authorized to use any ideas, concepts, know-how, or techniques contained in the communications you send to the Site, without compensation, for any purpose whatsoever, including, but not limited to, researching,\ndeveloping, manufacturing, and marketing products that use or contain such information. Any information you submit or provide to the Site may be publicly available. Important and private information should be protected by you. Moderna is not responsible for protecting the privacy of any email or other information transmied over the Internet or any other network you use.',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: '',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'heading-3',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'Worldwide Products\n',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'The Site may contain information about our current or potential future worldwide products and services, not all of which are available in every location. A reference to a product or service on the Site does not imply that such product or service is or will be available in your location. The products referenced on this website may be subject to dierent regulatory requirements depending on the country in which they are used. Consequently, visitors may be advised that certain areas of the site are intended only for certain types of professionals or only for an audience in certain countries. You should not construe anything on the Site as promoting or advertising any product or for the use of any product that is not authorized by the laws and regulations of your country of residence.\n\n',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'heading-3',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: '\nApplicable Law\n',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'You are solely responsible for ensuring compliance with the laws of your specific jurisdiction. The website can be accessed from any US state and also from other countries around the world. Each of these places has laws that may dier from those of the U.S. state of Massachuses, where Moderna is based. By accessing the Site, you and Moderna agree that the laws of the Commonwealth of Massachuses, without regard to principles of conflict of\nlaws, shall apply to any dispute arising out of, arising out of, or relating to the use of the Site or the information contained therein. With respect to such disputes, you and Moderna also consent and hereby submit to the exclusive personal jurisdiction and venue of any court located in Boston, Massachuses, USA.',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: '\nYou agree to comply with all applicable export restrictions under all applicable export control laws and not to export or re-export any of the information to any country or to any person prohibited under such export control laws. If you are located in a country where such export is prohibited, or if you are a person or entity for whom such export is prohibited, you may not download any information. You are solely responsible for complying with the laws of your specific jurisdiction with respect to the import, export or re-export of the information.\n',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'The information is provided with “RESTRICTED RIGHTS”. Use, duplication, or disclosure by the U.S. Government is subject to the restrictions contained in 48 CFR 52.227-19 and 48 CFR 252.227-7013 et seq. or their successors. Use of the Site or Information by the U.S. Government constitutes acknowledgment of our ownership rights in the Site and Information.\nIf any provision of these Terms is found by a court of competent jurisdiction to be unlawful, invalid or unenforceable, the invalidity or unenforceability of such provision shall not aect the validity of the remaining provisions of these Terms, which shall remain in full force and eect. Moderna’s failure to comply with or enforce any provision of these Terms shall not be construed as a waiver of such provision or any other provision of these Terms. A waiver\nshall be eective against Moderna only if it is made in writing, and such waiver shall not be construed as a waiver in any other or subsequent instance. Except as expressly agreed in writing between Moderna and you, these Terms constitute the entire agreement between you and Moderna with respect to the subject maer and supersede all prior or contemporaneous agreements, whether wrien or oral, between the parties with respect to the subject maer. The section headings are for convenience only and have no legal significance. Moderna may assign its ownership, control or other rights to any party at any time without notice to you.',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: '\nThese Terms shall inure to the benefit of our successors, assigns, licensees and sublicensees.',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: '',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: '\n\n\n\n\n',
                                marks: [],
                                data: {}
                                }
                            ]
                            }
                        ]
                        },
                        backToTopButtonLabel: 'Back To Top',
                        printButtonLabel: 'Print',
                        country: {
                        metadata: {
                            tags: [],
                            concepts: []
                        },
                        sys: {
                            space: {
                            sys: {
                                type: 'Link',
                                linkType: 'Space',
                                id: 'n9bebhw263o0'
                            }
                            },
                            id: '7DX7badGk41XRSy4znPNFI',
                            type: 'Entry',
                            createdAt: '2023-05-18T03:24:01.186Z',
                            updatedAt: '2023-05-24T23:04:52.125Z',
                            environment: {
                            sys: {
                                id: 'sandbox',
                                type: 'Link',
                                linkType: 'Environment'
                            }
                            },
                            publishedVersion: 5,
                            revision: 2,
                            contentType: {
                            sys: {
                                type: 'Link',
                                linkType: 'ContentType',
                                id: 'country'
                            }
                            },
                            locale: 'en-US'
                        },
                        fields: {
                            name: 'Germany',
                            isocode: 'DE',
                            flag: {
                            metadata: {
                                tags: [],
                                concepts: []
                            },
                            sys: {
                                space: {
                                sys: {
                                    type: 'Link',
                                    linkType: 'Space',
                                    id: 'n9bebhw263o0'
                                }
                                },
                                id: '1PJ5nPASFqJbHZkqrkOloj',
                                type: 'Asset',
                                createdAt: '2023-05-24T23:04:44.544Z',
                                updatedAt: '2023-05-24T23:04:44.544Z',
                                environment: {
                                sys: {
                                    id: 'sandbox',
                                    type: 'Link',
                                    linkType: 'Environment'
                                }
                                },
                                publishedVersion: 5,
                                revision: 1,
                                locale: 'en-US'
                            },
                            fields: {
                                title: 'Germany Flag',
                                description: 'Germany Flag',
                                file: {
                                url: '//images.ctfassets.net/n9bebhw263o0/1PJ5nPASFqJbHZkqrkOloj/586177dc5c2d17ea76a41a972053c188/de_flag.svg',
                                details: {
                                    size: 1305,
                                    image: {
                                    width: 36,
                                    height: 26
                                    }
                                },
                                fileName: 'de_flag.svg',
                                contentType: 'image/svg+xml'
                                }
                            }
                            },
                            locales: [
                            'en-DE'
                            ]
                        }
                        }
                    }
                    }
                ]
                }
            }
            }
        }
        }
    },
    {
        metadata: {
        tags: [],
        concepts: []
        },
        sys: {
        space: {
            sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'n9bebhw263o0'
            }
        },
        id: '44uly5vTmjFxuRaiIdQwyZ',
        type: 'Entry',
        createdAt: '2022-12-14T23:15:14.671Z',
        updatedAt: '2022-12-23T17:27:47.054Z',
        environment: {
            sys: {
            id: 'sandbox',
            type: 'Link',
            linkType: 'Environment'
            }
        },
        publishedVersion: 8,
        revision: 2,
        contentType: {
            sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'internalLink'
            }
        },
        locale: 'en-US'
        },
        fields: {
        title: 'Return Goods Policy Internal Link',
        label: 'Vaccine Product Return Policy',
        pageReference: {
            metadata: {
            tags: [],
            concepts: []
            },
            sys: {
            space: {
                sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'n9bebhw263o0'
                }
            },
            id: '6nT2JOBfWhTcZ1Pwxzp5rn',
            type: 'Entry',
            createdAt: '2022-12-14T23:01:59.558Z',
            updatedAt: '2022-12-14T23:01:59.558Z',
            environment: {
                sys: {
                id: 'sandbox',
                type: 'Link',
                linkType: 'Environment'
                }
            },
            publishedVersion: 18,
            revision: 1,
            contentType: {
                sys: {
                type: 'Link',
                linkType: 'ContentType',
                id: 'page'
                }
            },
            locale: 'en-US'
            },
            fields: {
            name: 'Return Goods Policy Content Page',
            title: 'Return Goods Policy',
            slug: 'return-goods-policy',
            seo: {
                metadata: {
                tags: [],
                concepts: []
                },
                sys: {
                space: {
                    sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'n9bebhw263o0'
                    }
                },
                id: '5gMYYleewpKSWJ4q6TvZUj',
                type: 'Entry',
                createdAt: '2022-12-14T23:01:59.639Z',
                updatedAt: '2022-12-14T23:01:59.639Z',
                environment: {
                    sys: {
                    id: 'sandbox',
                    type: 'Link',
                    linkType: 'Environment'
                    }
                },
                publishedVersion: 11,
                revision: 1,
                contentType: {
                    sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'seo'
                    }
                },
                locale: 'en-US'
                },
                fields: {
                name: 'Return Goods Policy Content Page - Compose: SEO'
                }
            },
            content: {
                metadata: {
                tags: [],
                concepts: []
                },
                sys: {
                space: {
                    sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'n9bebhw263o0'
                    }
                },
                id: '4gWDVRE6oKE0h0dqd37xcu',
                type: 'Entry',
                createdAt: '2022-12-14T23:01:59.660Z',
                updatedAt: '2023-06-20T16:21:22.755Z',
                environment: {
                    sys: {
                    id: 'sandbox',
                    type: 'Link',
                    linkType: 'Environment'
                    }
                },
                publishedVersion: 21,
                revision: 5,
                contentType: {
                    sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'richTextContentPageTemplate'
                    }
                },
                locale: 'en-US'
                },
                fields: {
                name: 'Return Goods Policy Content Page - Rich Text Content Page Template',
                modules: [
                    {
                    metadata: {
                        tags: [],
                        concepts: []
                    },
                    sys: {
                        space: {
                        sys: {
                            type: 'Link',
                            linkType: 'Space',
                            id: 'n9bebhw263o0'
                        }
                        },
                        id: '4yWyEpVfxgjAmUcWCWMXBe',
                        type: 'Entry',
                        createdAt: '2022-12-14T23:04:20.745Z',
                        updatedAt: '2023-06-16T18:23:22.281Z',
                        environment: {
                        sys: {
                            id: 'sandbox',
                            type: 'Link',
                            linkType: 'Environment'
                        }
                        },
                        publishedVersion: 20,
                        revision: 2,
                        contentType: {
                        sys: {
                            type: 'Link',
                            linkType: 'ContentType',
                            id: 'bannerComponent'
                        }
                        },
                        locale: 'en-US'
                    },
                    fields: {
                        title: 'Return Goods Policy Banner Component',
                        headline: 'Moderna Vaccine Product Return Policy',
                        backgroundImage: {
                        metadata: {
                            tags: [],
                            concepts: []
                        },
                        sys: {
                            space: {
                            sys: {
                                type: 'Link',
                                linkType: 'Space',
                                id: 'n9bebhw263o0'
                            }
                            },
                            id: '5zfGJA7or5WGcLdYi4Qde',
                            type: 'Asset',
                            createdAt: '2022-10-28T18:53:29.208Z',
                            updatedAt: '2022-10-28T18:53:29.208Z',
                            environment: {
                            sys: {
                                id: 'sandbox',
                                type: 'Link',
                                linkType: 'Environment'
                            }
                            },
                            publishedVersion: 6,
                            revision: 1,
                            locale: 'en-US'
                        },
                        fields: {
                            title: 'Banner BG Strand Top',
                            description: '',
                            file: {
                            url: '//images.ctfassets.net/n9bebhw263o0/5zfGJA7or5WGcLdYi4Qde/08c261eaf574cefa50f8fe8609ff531d/Banner_BG_Strand_Top_.png',
                            details: {
                                size: 47693,
                                image: {
                                width: 1920,
                                height: 511
                                }
                            },
                            fileName: 'Banner BG Strand Top .png',
                            contentType: 'image/png'
                            }
                        }
                        },
                        country: {
                        metadata: {
                            tags: [],
                            concepts: []
                        },
                        sys: {
                            space: {
                            sys: {
                                type: 'Link',
                                linkType: 'Space',
                                id: 'n9bebhw263o0'
                            }
                            },
                            id: '7sht7920U6vs3CLH2CUyaa',
                            type: 'Entry',
                            createdAt: '2023-05-18T03:23:50.744Z',
                            updatedAt: '2023-05-24T22:55:23.250Z',
                            environment: {
                            sys: {
                                id: 'sandbox',
                                type: 'Link',
                                linkType: 'Environment'
                            }
                            },
                            publishedVersion: 6,
                            revision: 2,
                            contentType: {
                            sys: {
                                type: 'Link',
                                linkType: 'ContentType',
                                id: 'country'
                            }
                            },
                            locale: 'en-US'
                        },
                        fields: {
                            name: 'United States',
                            isocode: 'US',
                            flag: {
                            metadata: {
                                tags: [],
                                concepts: []
                            },
                            sys: {
                                space: {
                                sys: {
                                    type: 'Link',
                                    linkType: 'Space',
                                    id: 'n9bebhw263o0'
                                }
                                },
                                id: '3aYCbZJiL8aoEKRdhjOXyy',
                                type: 'Asset',
                                createdAt: '2023-05-24T22:54:50.939Z',
                                updatedAt: '2023-05-24T22:54:50.939Z',
                                environment: {
                                sys: {
                                    id: 'sandbox',
                                    type: 'Link',
                                    linkType: 'Environment'
                                }
                                },
                                publishedVersion: 5,
                                revision: 1,
                                locale: 'en-US'
                            },
                            fields: {
                                title: 'usa flag',
                                description: 'USA Flag',
                                file: {
                                url: '//images.ctfassets.net/n9bebhw263o0/3aYCbZJiL8aoEKRdhjOXyy/f69a6f932a690dc632e7742c328c276d/usa_flag.svg',
                                details: {
                                    size: 2487,
                                    image: {
                                    width: 36,
                                    height: 26
                                    }
                                },
                                fileName: 'usa_flag.svg',
                                contentType: 'image/svg+xml'
                                }
                            }
                            },
                            locales: [
                            'en-US'
                            ]
                        }
                        }
                    }
                    },
                    {
                    metadata: {
                        tags: [],
                        concepts: []
                    },
                    sys: {
                        space: {
                        sys: {
                            type: 'Link',
                            linkType: 'Space',
                            id: 'n9bebhw263o0'
                        }
                        },
                        id: '3LzpM6ba6wGXMlxYkj0OfE',
                        type: 'Entry',
                        createdAt: '2023-06-16T18:28:28.772Z',
                        updatedAt: '2023-06-16T18:28:39.366Z',
                        environment: {
                        sys: {
                            id: 'sandbox',
                            type: 'Link',
                            linkType: 'Environment'
                        }
                        },
                        publishedVersion: 5,
                        revision: 2,
                        contentType: {
                        sys: {
                            type: 'Link',
                            linkType: 'ContentType',
                            id: 'bannerComponent'
                        }
                        },
                        locale: 'en-US'
                    },
                    fields: {
                        title: 'Return Goods Policy Banner Component - DE',
                        headline: 'Moderna Vaccine Product Return Policy',
                        backgroundImage: {
                        metadata: {
                            tags: [],
                            concepts: []
                        },
                        sys: {
                            space: {
                            sys: {
                                type: 'Link',
                                linkType: 'Space',
                                id: 'n9bebhw263o0'
                            }
                            },
                            id: '5zfGJA7or5WGcLdYi4Qde',
                            type: 'Asset',
                            createdAt: '2022-10-28T18:53:29.208Z',
                            updatedAt: '2022-10-28T18:53:29.208Z',
                            environment: {
                            sys: {
                                id: 'sandbox',
                                type: 'Link',
                                linkType: 'Environment'
                            }
                            },
                            publishedVersion: 6,
                            revision: 1,
                            locale: 'en-US'
                        },
                        fields: {
                            title: 'Banner BG Strand Top',
                            description: '',
                            file: {
                            url: '//images.ctfassets.net/n9bebhw263o0/5zfGJA7or5WGcLdYi4Qde/08c261eaf574cefa50f8fe8609ff531d/Banner_BG_Strand_Top_.png',
                            details: {
                                size: 47693,
                                image: {
                                width: 1920,
                                height: 511
                                }
                            },
                            fileName: 'Banner BG Strand Top .png',
                            contentType: 'image/png'
                            }
                        }
                        },
                        country: {
                        metadata: {
                            tags: [],
                            concepts: []
                        },
                        sys: {
                            space: {
                            sys: {
                                type: 'Link',
                                linkType: 'Space',
                                id: 'n9bebhw263o0'
                            }
                            },
                            id: '7DX7badGk41XRSy4znPNFI',
                            type: 'Entry',
                            createdAt: '2023-05-18T03:24:01.186Z',
                            updatedAt: '2023-05-24T23:04:52.125Z',
                            environment: {
                            sys: {
                                id: 'sandbox',
                                type: 'Link',
                                linkType: 'Environment'
                            }
                            },
                            publishedVersion: 5,
                            revision: 2,
                            contentType: {
                            sys: {
                                type: 'Link',
                                linkType: 'ContentType',
                                id: 'country'
                            }
                            },
                            locale: 'en-US'
                        },
                        fields: {
                            name: 'Germany',
                            isocode: 'DE',
                            flag: {
                            metadata: {
                                tags: [],
                                concepts: []
                            },
                            sys: {
                                space: {
                                sys: {
                                    type: 'Link',
                                    linkType: 'Space',
                                    id: 'n9bebhw263o0'
                                }
                                },
                                id: '1PJ5nPASFqJbHZkqrkOloj',
                                type: 'Asset',
                                createdAt: '2023-05-24T23:04:44.544Z',
                                updatedAt: '2023-05-24T23:04:44.544Z',
                                environment: {
                                sys: {
                                    id: 'sandbox',
                                    type: 'Link',
                                    linkType: 'Environment'
                                }
                                },
                                publishedVersion: 5,
                                revision: 1,
                                locale: 'en-US'
                            },
                            fields: {
                                title: 'Germany Flag',
                                description: 'Germany Flag',
                                file: {
                                url: '//images.ctfassets.net/n9bebhw263o0/1PJ5nPASFqJbHZkqrkOloj/586177dc5c2d17ea76a41a972053c188/de_flag.svg',
                                details: {
                                    size: 1305,
                                    image: {
                                    width: 36,
                                    height: 26
                                    }
                                },
                                fileName: 'de_flag.svg',
                                contentType: 'image/svg+xml'
                                }
                            }
                            },
                            locales: [
                            'en-DE'
                            ]
                        }
                        }
                    }
                    },
                    {
                    metadata: {
                        tags: [],
                        concepts: []
                    },
                    sys: {
                        space: {
                        sys: {
                            type: 'Link',
                            linkType: 'Space',
                            id: 'n9bebhw263o0'
                        }
                        },
                        id: '5KqsjWl1JAA7AvePDZzaq5',
                        type: 'Entry',
                        createdAt: '2022-12-14T23:00:13.065Z',
                        updatedAt: '2024-07-19T13:17:52.682Z',
                        environment: {
                        sys: {
                            id: 'sandbox',
                            type: 'Link',
                            linkType: 'Environment'
                        }
                        },
                        publishedVersion: 166,
                        revision: 14,
                        contentType: {
                        sys: {
                            type: 'Link',
                            linkType: 'ContentType',
                            id: 'richTextContentComponent'
                        }
                        },
                        locale: 'en-US'
                    },
                    fields: {
                        title: 'Return Goods Rich Text Component - US',
                        effectiveDateLabel: 'Effective',
                        effectiveDate: '2024-07-01',
                        content: {
                        nodeType: 'document',
                        data: {},
                        content: [
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'Returned Goods Policy and Procedures',
                                marks: [
                                    {
                                    type: 'bold'
                                    }
                                ],
                                data: {}
                                },
                                {
                                nodeType: 'text',
                                value: ' \nModerna US,\u202fInc. ',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'This Return Goods Policy controls what Moderna products are eligible for return and sets forth procedures for return of those eligible products. This Policy may be amended by Moderna at any time in its sole discretion. Moderna will only accept returns subject to this Policy from parties that purchased product directly from Moderna or indirectly through an authorized distributor of record (ADR). The policy detailed below is for customers that have purchased directly from Moderna. For customers who purchased from an ADR, the Return Policy of the ADR should be followed for Seasonal and Non-Seasonal Returns. If your ADR’s policy instructs you to return directly to Moderna please follow the instructions in this policy.',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'Returnable Items:',
                                marks: [
                                    {
                                    type: 'bold'
                                    },
                                    {
                                    type: 'underline'
                                    }
                                ],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'unordered-list',
                            data: {},
                            content: [
                                {
                                nodeType: 'list-item',
                                data: {},
                                content: [
                                    {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                        nodeType: 'text',
                                        value: 'Products received by customer as damaged or received in error – Products received damaged or in error may be returned for full credit when reported within three (3) business days of receipt of product subject to the terms herein. Products should remain in the original carton for inspection, and products must be returned in accordance with all Return Authorization (RA) instructions. Please contact 1-866-MODERNA (663-3762) or email a request to ',
                                        marks: [],
                                        data: {}
                                        },
                                        {
                                        nodeType: 'hyperlink',
                                        data: {
                                            uri: 'mailto:Commercialops@modernatx.com'
                                        },
                                        content: [
                                            {
                                            nodeType: 'text',
                                            value: 'Commercialops@modernatx.com',
                                            marks: [],
                                            data: {}
                                            }
                                        ]
                                        },
                                        {
                                        nodeType: 'text',
                                        value: ' within three (3) business days to report product damaged or received in error.',
                                        marks: [],
                                        data: {}
                                        }
                                    ]
                                    }
                                ]
                                },
                                {
                                nodeType: 'list-item',
                                data: {},
                                content: [
                                    {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                        nodeType: 'text',
                                        value: 'Seasonal Product Returns.',
                                        marks: [],
                                        data: {}
                                        }
                                    ]
                                    },
                                    {
                                    nodeType: 'unordered-list',
                                    data: {},
                                    content: [
                                        {
                                        nodeType: 'list-item',
                                        data: {},
                                        content: [
                                            {
                                            nodeType: 'paragraph',
                                            data: {},
                                            content: [
                                                {
                                                nodeType: 'text',
                                                value: '“Seasonal Products” are defined as Products that are generally reformulated each season or each year to address new or changing virus/disease strains. Each reformulation generally requires approval from FDA and issuance of new NDC numbers. Seasonal Products remain eligible for sale until a new formulation is approved or as per direction and availability from Moderna.',
                                                marks: [],
                                                data: {}
                                                }
                                            ]
                                            }
                                        ]
                                        },
                                        {
                                        nodeType: 'list-item',
                                        data: {},
                                        content: [
                                            {
                                            nodeType: 'paragraph',
                                            data: {},
                                            content: [
                                                {
                                                nodeType: 'text',
                                                value: 'At the end of each season, a percentage of the total volume of Seasonal Product (currently, Covid-19 vaccine) purchased directly from Moderna may be returned for credit. The specific percentage will be defined in the customer contract. Returns in excess of the allowable total, within a single season, will be destroyed and only Federal Excise Tax (FET) will be credited where applicable.',
                                                marks: [],
                                                data: {}
                                                }
                                            ]
                                            }
                                        ]
                                        },
                                        {
                                        nodeType: 'list-item',
                                        data: {},
                                        content: [
                                            {
                                            nodeType: 'paragraph',
                                            data: {},
                                            content: [
                                                {
                                                nodeType: 'text',
                                                value: 'Return requests for seasonal returns of Moderna Seasonal Product must be received by Inmar during the Seasonal Returns Window. The Seasonal Returns Window will be communicated by Moderna, in its discretion, prior to its opening.',
                                                marks: [],
                                                data: {}
                                                }
                                            ]
                                            }
                                        ]
                                        }
                                    ]
                                    }
                                ]
                                },
                                {
                                nodeType: 'list-item',
                                data: {},
                                content: [
                                    {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                        nodeType: 'text',
                                        value: 'Other Expired Products',
                                        marks: [
                                            {
                                            type: 'bold'
                                            }
                                        ],
                                        data: {}
                                        },
                                        {
                                        nodeType: 'text',
                                        value: ' that are not Seasonal Products as determined by Moderna may be returned within two months of expiry and up to 12 months after expiry.',
                                        marks: [],
                                        data: {}
                                        }
                                    ]
                                    }
                                ]
                                },
                                {
                                nodeType: 'list-item',
                                data: {},
                                content: [
                                    {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                        nodeType: 'text',
                                        value: 'Returns for partial cartons are accepted.',
                                        marks: [],
                                        data: {}
                                        }
                                    ]
                                    }
                                ]
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'Products Ineligible for Returns:',
                                marks: [
                                    {
                                    type: 'bold'
                                    },
                                    {
                                    type: 'underline'
                                    }
                                ],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'All products, other than those listed above, shall be deemed ineligible for returned goods credit. Ineligible products cannot be returned to the customer and will be destroyed with no credit issued. Products that are ineligible for returned goods credit include, without limitation:',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'unordered-list',
                            data: {},
                            content: [
                                {
                                nodeType: 'list-item',
                                data: {},
                                content: [
                                    {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                        nodeType: 'text',
                                        value: 'Seasonal Product received after the defined seasonal return window closes.',
                                        marks: [],
                                        data: {}
                                        }
                                    ]
                                    }
                                ]
                                },
                                {
                                nodeType: 'list-item',
                                data: {},
                                content: [
                                    {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                        nodeType: 'text',
                                        value: 'Seasonal Product that exceeds the returns allowance/percentage specified in the customer contract.',
                                        marks: [],
                                        data: {}
                                        }
                                    ]
                                    }
                                ]
                                },
                                {
                                nodeType: 'list-item',
                                data: {},
                                content: [
                                    {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                        nodeType: 'text',
                                        value: 'Non-Seasonal Product returned prior to 2 months prior to expiry and more than 12 months after expiry.',
                                        marks: [],
                                        data: {}
                                        }
                                    ]
                                    }
                                ]
                                },
                                {
                                nodeType: 'list-item',
                                data: {},
                                content: [
                                    {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                        nodeType: 'text',
                                        value: 'Product obtained under EUA distribution from the United States Government.',
                                        marks: [],
                                        data: {}
                                        }
                                    ]
                                    }
                                ]
                                },
                                {
                                nodeType: 'list-item',
                                data: {},
                                content: [
                                    {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                        nodeType: 'text',
                                        value: 'Product returned without a Return Authorization (RA) as further explained below.',
                                        marks: [],
                                        data: {}
                                        }
                                    ]
                                    }
                                ]
                                },
                                {
                                nodeType: 'list-item',
                                data: {},
                                content: [
                                    {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                        nodeType: 'text',
                                        value: 'Product for which original proof of purchase cannot be verified.',
                                        marks: [],
                                        data: {}
                                        }
                                    ]
                                    }
                                ]
                                },
                                {
                                nodeType: 'list-item',
                                data: {},
                                content: [
                                    {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                        nodeType: 'text',
                                        value: 'Product returned with illegible or missing lot numbers, or expiration dates. No credit will be issued if the lot number or expiration date is missing, covered and/or unreadable on original container.',
                                        marks: [],
                                        data: {}
                                        }
                                    ]
                                    }
                                ]
                                },
                                {
                                nodeType: 'list-item',
                                data: {},
                                content: [
                                    {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                        nodeType: 'text',
                                        value: 'Repackaged product.',
                                        marks: [],
                                        data: {}
                                        }
                                    ]
                                    }
                                ]
                                },
                                {
                                nodeType: 'list-item',
                                data: {},
                                content: [
                                    {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                        nodeType: 'text',
                                        value: 'Product with an opened seal.',
                                        marks: [],
                                        data: {}
                                        }
                                    ]
                                    }
                                ]
                                },
                                {
                                nodeType: 'list-item',
                                data: {},
                                content: [
                                    {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                        nodeType: 'text',
                                        value: 'Product obtained at no cost and/or labeled as professional samples, clinical trial use, patient assistance program use or similar special labels.',
                                        marks: [],
                                        data: {}
                                        }
                                    ]
                                    }
                                ]
                                },
                                {
                                nodeType: 'list-item',
                                data: {},
                                content: [
                                    {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                        nodeType: 'text',
                                        value: 'Product sold on a non-returnable basis.',
                                        marks: [],
                                        data: {}
                                        }
                                    ]
                                    }
                                ]
                                },
                                {
                                nodeType: 'list-item',
                                data: {},
                                content: [
                                    {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                        nodeType: 'text',
                                        value: 'Product obtained illegally or re-imported from outside the United States.',
                                        marks: [],
                                        data: {}
                                        }
                                    ]
                                    }
                                ]
                                },
                                {
                                nodeType: 'list-item',
                                data: {},
                                content: [
                                    {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                        nodeType: 'text',
                                        value: 'Product that has been adulterated, misbranded, or counterfeit, as determined by Moderna at its sole reasonable discretion.',
                                        marks: [],
                                        data: {}
                                        }
                                    ]
                                    }
                                ]
                                },
                                {
                                nodeType: 'list-item',
                                data: {},
                                content: [
                                    {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                        nodeType: 'text',
                                        value: 'Distressed merchandise obtained through bankruptcy or sacrifice sale, going out-of- business sale, or other merchandise classified as “distressed merchandise.”',
                                        marks: [],
                                        data: {}
                                        }
                                    ]
                                    }
                                ]
                                },
                                {
                                nodeType: 'list-item',
                                data: {},
                                content: [
                                    {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                        nodeType: 'text',
                                        value: 'Product damaged due to the negligence of the purchaser and/or customer.',
                                        marks: [],
                                        data: {}
                                        }
                                    ]
                                    }
                                ]
                                },
                                {
                                nodeType: 'list-item',
                                data: {},
                                content: [
                                    {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                        nodeType: 'text',
                                        value: 'Product that has not been properly stored according to guidelines provided by Moderna.',
                                        marks: [],
                                        data: {}
                                        }
                                    ]
                                    }
                                ]
                                },
                                {
                                nodeType: 'list-item',
                                data: {},
                                content: [
                                    {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                        nodeType: 'text',
                                        value: 'Product damaged by fire, water, or other acts of God.',
                                        marks: [],
                                        data: {}
                                        }
                                    ]
                                    }
                                ]
                                },
                                {
                                nodeType: 'list-item',
                                data: {},
                                content: [
                                    {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                        nodeType: 'text',
                                        value: 'Product returned by any indirect customer.',
                                        marks: [],
                                        data: {}
                                        }
                                    ]
                                    }
                                ]
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'Procedure for Non-Seasonal or Other Product Returns',
                                marks: [
                                    {
                                    type: 'bold'
                                    },
                                    {
                                    type: 'underline'
                                    }
                                ],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'Product returns require a RA issued through Moderna’s Customer Service department via phone number or email listed below. RAs expire thirty (30) calendar days from date issued.',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'Via phone:',
                                marks: [
                                    {
                                    type: 'bold'
                                    }
                                ],
                                data: {}
                                },
                                {
                                nodeType: 'text',
                                value: ' 1-866-Moderna (663-3762)',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'Via email:',
                                marks: [
                                    {
                                    type: 'bold'
                                    }
                                ],
                                data: {}
                                },
                                {
                                nodeType: 'text',
                                value: ' ',
                                marks: [],
                                data: {}
                                },
                                {
                                nodeType: 'hyperlink',
                                data: {
                                    uri: 'mailto:Commercialops@modernatx.com'
                                },
                                content: [
                                    {
                                    nodeType: 'text',
                                    value: 'Commercialops@modernatx.com',
                                    marks: [],
                                    data: {}
                                    }
                                ]
                                },
                                {
                                nodeType: 'text',
                                value: '',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'unordered-list',
                            data: {},
                            content: [
                                {
                                nodeType: 'list-item',
                                data: {},
                                content: [
                                    {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                        nodeType: 'text',
                                        value: 'Customers who place orders directly with Moderna must submit an itemized list of products being returned, with the following information included for each product:',
                                        marks: [],
                                        data: {}
                                        }
                                    ]
                                    },
                                    {
                                    nodeType: 'unordered-list',
                                    data: {},
                                    content: [
                                        {
                                        nodeType: 'list-item',
                                        data: {},
                                        content: [
                                            {
                                            nodeType: 'paragraph',
                                            data: {},
                                            content: [
                                                {
                                                nodeType: 'text',
                                                value: 'Debit Memo number, product name, product quantity, unit price, serial number, GTIN, lot number, NDC number, expiration date, billing address, shipping address, contact name and phone/email, and RA number.',
                                                marks: [],
                                                data: {}
                                                }
                                            ]
                                            }
                                        ]
                                        }
                                    ]
                                    }
                                ]
                                },
                                {
                                nodeType: 'list-item',
                                data: {},
                                content: [
                                    {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                        nodeType: 'text',
                                        value: 'Indirect requests for return (i.e., requests from a hospital and/or pharmacy) are not covered by this policy and instead must route through their ADR.',
                                        marks: [],
                                        data: {}
                                        }
                                    ]
                                    }
                                ]
                                },
                                {
                                nodeType: 'list-item',
                                data: {},
                                content: [
                                    {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                        nodeType: 'text',
                                        value: 'Ship returnable products, along with a copy of the Moderna RA and Debit Memo to:',
                                        marks: [],
                                        data: {}
                                        }
                                    ]
                                    }
                                ]
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'Shipping and Returned Goods Address:',
                                marks: [
                                    {
                                    type: 'bold'
                                    }
                                ],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'Inmar Rx Solutions\n3845 Grand Lakes Way\nSuite 125\nGrand Prairie, TX 75050',
                                marks: [
                                    {
                                    type: 'bold'
                                    }
                                ],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'unordered-list',
                            data: {},
                            content: [
                                {
                                nodeType: 'list-item',
                                data: {},
                                content: [
                                    {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                        nodeType: 'text',
                                        value: 'It is the shipper’s responsibility to securely package all returned products to prevent breakage during transit.',
                                        marks: [],
                                        data: {}
                                        }
                                    ]
                                    }
                                ]
                                },
                                {
                                nodeType: 'list-item',
                                data: {},
                                content: [
                                    {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                        nodeType: 'text',
                                        value: 'Product must be returned with shipping label and insurance unless such return is due to Moderna’s error (such as damaged product, mis-delivery, or discontinued/recalled product).',
                                        marks: [],
                                        data: {}
                                        }
                                    ]
                                    }
                                ]
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'Return Procedure for Eligible Returns:',
                                marks: [
                                    {
                                    type: 'bold'
                                    },
                                    {
                                    type: 'underline'
                                    }
                                ],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'unordered-list',
                            data: {},
                            content: [
                                {
                                nodeType: 'list-item',
                                data: {},
                                content: [
                                    {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                        nodeType: 'text',
                                        value: 'Expired product returns require a RA issued through Inmar. To request a RA from Inmar, please use one of the three options below. ',
                                        marks: [],
                                        data: {}
                                        }
                                    ]
                                    },
                                    {
                                    nodeType: 'unordered-list',
                                    data: {},
                                    content: [
                                        {
                                        nodeType: 'list-item',
                                        data: {},
                                        content: [
                                            {
                                            nodeType: 'paragraph',
                                            data: {},
                                            content: [
                                                {
                                                nodeType: 'text',
                                                value: 'Access the Inmar website at ',
                                                marks: [],
                                                data: {}
                                                },
                                                {
                                                nodeType: 'hyperlink',
                                                data: {
                                                    uri: 'https://hrm.reskureturns.com/landing'
                                                },
                                                content: [
                                                    {
                                                    nodeType: 'text',
                                                    value: 'https://hrm.reskureturns.com/landing',
                                                    marks: [],
                                                    data: {}
                                                    }
                                                ]
                                                },
                                                {
                                                nodeType: 'text',
                                                value: ' and upload a PDF copy of your debit memo or Returns Request form',
                                                marks: [],
                                                data: {}
                                                }
                                            ]
                                            }
                                        ]
                                        },
                                        {
                                        nodeType: 'list-item',
                                        data: {},
                                        content: [
                                            {
                                            nodeType: 'paragraph',
                                            data: {},
                                            content: [
                                                {
                                                nodeType: 'text',
                                                value: 'E-mail document to ',
                                                marks: [],
                                                data: {}
                                                },
                                                {
                                                nodeType: 'hyperlink',
                                                data: {
                                                    uri: 'mailto:rarequest@inmar.com'
                                                },
                                                content: [
                                                    {
                                                    nodeType: 'text',
                                                    value: 'rarequest@inmar.com',
                                                    marks: [],
                                                    data: {}
                                                    }
                                                ]
                                                },
                                                {
                                                nodeType: 'text',
                                                value: '',
                                                marks: [],
                                                data: {}
                                                }
                                            ]
                                            }
                                        ]
                                        },
                                        {
                                        nodeType: 'list-item',
                                        data: {},
                                        content: [
                                            {
                                            nodeType: 'paragraph',
                                            data: {},
                                            content: [
                                                {
                                                nodeType: 'text',
                                                value: 'Fax document to Inmar at 817-868-5343.',
                                                marks: [],
                                                data: {}
                                                }
                                            ]
                                            }
                                        ]
                                        }
                                    ]
                                    }
                                ]
                                },
                                {
                                nodeType: 'list-item',
                                data: {},
                                content: [
                                    {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                        nodeType: 'text',
                                        value: 'Customers must submit an itemized list of products being returned, with the following information included for each product, as shown on the invoice:',
                                        marks: [],
                                        data: {}
                                        }
                                    ]
                                    },
                                    {
                                    nodeType: 'unordered-list',
                                    data: {},
                                    content: [
                                        {
                                        nodeType: 'list-item',
                                        data: {},
                                        content: [
                                            {
                                            nodeType: 'paragraph',
                                            data: {},
                                            content: [
                                                {
                                                nodeType: 'text',
                                                value: 'Customer DEA and/or HIN# used to create account',
                                                marks: [],
                                                data: {}
                                                }
                                            ]
                                            }
                                        ]
                                        },
                                        {
                                        nodeType: 'list-item',
                                        data: {},
                                        content: [
                                            {
                                            nodeType: 'paragraph',
                                            data: {},
                                            content: [
                                                {
                                                nodeType: 'text',
                                                value: 'Customer Name',
                                                marks: [],
                                                data: {}
                                                }
                                            ]
                                            }
                                        ]
                                        },
                                        {
                                        nodeType: 'list-item',
                                        data: {},
                                        content: [
                                            {
                                            nodeType: 'paragraph',
                                            data: {},
                                            content: [
                                                {
                                                nodeType: 'text',
                                                value: 'Customer Shipping address as shown on invoice',
                                                marks: [],
                                                data: {}
                                                }
                                            ]
                                            }
                                        ]
                                        },
                                        {
                                        nodeType: 'list-item',
                                        data: {},
                                        content: [
                                            {
                                            nodeType: 'paragraph',
                                            data: {},
                                            content: [
                                                {
                                                nodeType: 'text',
                                                value: 'Source of Purchase (ADR name or Moderna)',
                                                marks: [],
                                                data: {}
                                                }
                                            ]
                                            }
                                        ]
                                        },
                                        {
                                        nodeType: 'list-item',
                                        data: {},
                                        content: [
                                            {
                                            nodeType: 'paragraph',
                                            data: {},
                                            content: [
                                                {
                                                nodeType: 'text',
                                                value: 'Product name, NDC number(s), lot number(s), expiration date(s)',
                                                marks: [],
                                                data: {}
                                                }
                                            ]
                                            }
                                        ]
                                        },
                                        {
                                        nodeType: 'list-item',
                                        data: {},
                                        content: [
                                            {
                                            nodeType: 'paragraph',
                                            data: {},
                                            content: [
                                                {
                                                nodeType: 'text',
                                                value: 'Product quantity',
                                                marks: [],
                                                data: {}
                                                }
                                            ]
                                            }
                                        ]
                                        },
                                        {
                                        nodeType: 'list-item',
                                        data: {},
                                        content: [
                                            {
                                            nodeType: 'paragraph',
                                            data: {},
                                            content: [
                                                {
                                                nodeType: 'text',
                                                value: 'Sale Unit price (Invoiced price)',
                                                marks: [],
                                                data: {}
                                                }
                                            ]
                                            }
                                        ]
                                        },
                                        {
                                        nodeType: 'list-item',
                                        data: {},
                                        content: [
                                            {
                                            nodeType: 'paragraph',
                                            data: {},
                                            content: [
                                                {
                                                nodeType: 'text',
                                                value: 'Contact name and phone/email',
                                                marks: [],
                                                data: {}
                                                }
                                            ]
                                            }
                                        ]
                                        },
                                        {
                                        nodeType: 'list-item',
                                        data: {},
                                        content: [
                                            {
                                            nodeType: 'paragraph',
                                            data: {},
                                            content: [
                                                {
                                                nodeType: 'text',
                                                value: 'Inmar will provide a box label to print when submitting your return request.',
                                                marks: [],
                                                data: {}
                                                }
                                            ]
                                            }
                                        ]
                                        }
                                    ]
                                    }
                                ]
                                },
                                {
                                nodeType: 'list-item',
                                data: {},
                                content: [
                                    {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                        nodeType: 'text',
                                        value: 'If you have any questions, please contact Inmar Pharmaceutical Services at 1-800-967-5952 option 3. Mon. – Fri. 7am – 5pm CT',
                                        marks: [],
                                        data: {}
                                        }
                                    ]
                                    }
                                ]
                                },
                                {
                                nodeType: 'list-item',
                                data: {},
                                content: [
                                    {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                        nodeType: 'text',
                                        value: 'Include the completed RA box label with your return.',
                                        marks: [],
                                        data: {}
                                        }
                                    ]
                                    }
                                ]
                                },
                                {
                                nodeType: 'list-item',
                                data: {},
                                content: [
                                    {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                        nodeType: 'text',
                                        value: 'Send returns to:',
                                        marks: [],
                                        data: {}
                                        }
                                    ]
                                    }
                                ]
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'Inmar Rx Solutions\n3845 Grand Lakes Way\nSuite 125\nGrand Prairie, TX 75050',
                                marks: [
                                    {
                                    type: 'bold'
                                    }
                                ],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'unordered-list',
                            data: {},
                            content: [
                                {
                                nodeType: 'list-item',
                                data: {},
                                content: [
                                    {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                        nodeType: 'text',
                                        value: 'It is shipper’s responsibility to securely package all returned products to prevent breakage during transit.',
                                        marks: [],
                                        data: {}
                                        }
                                    ]
                                    }
                                ]
                                },
                                {
                                nodeType: 'list-item',
                                data: {},
                                content: [
                                    {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                        nodeType: 'text',
                                        value: 'If multiple RAs are being returned within a single delivery to Inmar Pharmaceutical Services, ensure returned product with the associated RAs are distinctly separated (with appropriate labeling if needed) within the delivery. Failure to do so may result in inaccurate accounting of the return or a delay to the crediting process.',
                                        marks: [],
                                        data: {}
                                        }
                                    ]
                                    }
                                ]
                                },
                                {
                                nodeType: 'list-item',
                                data: {},
                                content: [
                                    {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                        nodeType: 'text',
                                        value: 'Returned products do not require cold chain shipping.',
                                        marks: [],
                                        data: {}
                                        }
                                    ]
                                    }
                                ]
                                },
                                {
                                nodeType: 'list-item',
                                data: {},
                                content: [
                                    {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                        nodeType: 'text',
                                        value: 'Transportation charges, including prepaid freight and insurance, are the responsibility of the customer. No fees of any kind will be approved for credit. Moderna is not responsible for return shipments lost in transit.',
                                        marks: [],
                                        data: {}
                                        }
                                    ]
                                    }
                                ]
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'Additional Terms for Return Credit:',
                                marks: [
                                    {
                                    type: 'bold'
                                    },
                                    {
                                    type: 'underline'
                                    }
                                ],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'unordered-list',
                            data: {},
                            content: [
                                {
                                nodeType: 'list-item',
                                data: {},
                                content: [
                                    {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                        nodeType: 'text',
                                        value: 'Product must be in original retail trade packaging. Repackaged items will not be accepted for return or credited.',
                                        marks: [],
                                        data: {}
                                        }
                                    ]
                                    }
                                ]
                                },
                                {
                                nodeType: 'list-item',
                                data: {},
                                content: [
                                    {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                        nodeType: 'text',
                                        value: 'Credit for eligible and approved returns will be determined by Moderna. Such credit will be issued in credit memo form and will be applied to Customer’s current account balance.',
                                        marks: [],
                                        data: {}
                                        }
                                    ]
                                    }
                                ]
                                },
                                {
                                nodeType: 'list-item',
                                data: {},
                                content: [
                                    {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                        nodeType: 'text',
                                        value: 'Moderna reserves the right, prior to credit being issued, to verify the original proof of purchase to determine that product being returned was shipped from Moderna to Customer.',
                                        marks: [],
                                        data: {}
                                        }
                                    ]
                                    }
                                ]
                                },
                                {
                                nodeType: 'list-item',
                                data: {},
                                content: [
                                    {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                        nodeType: 'text',
                                        value: 'Credit for erroneous or damaged product will be issued upon receipt and processing of return of product. No deduction can be taken prior to that time.',
                                        marks: [],
                                        data: {}
                                        }
                                    ]
                                    }
                                ]
                                },
                                {
                                nodeType: 'list-item',
                                data: {},
                                content: [
                                    {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                        nodeType: 'text',
                                        value: 'Credit for Seasonal Returns will be issued at the end of each season. Credit will be limited to a contractually defined percentage of total vaccine product purchased directly from Moderna plus any applicable federal excise tax credit. Credit will be issued upon completion of the vaccine season and upon processing of returns. No deduction can be taken prior to that time.',
                                        marks: [],
                                        data: {}
                                        }
                                    ]
                                    }
                                ]
                                },
                                {
                                nodeType: 'list-item',
                                data: {},
                                content: [
                                    {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                        nodeType: 'text',
                                        value: 'Returned goods may not be exchanged for replacement merchandise.',
                                        marks: [],
                                        data: {}
                                        }
                                    ]
                                    }
                                ]
                                },
                                {
                                nodeType: 'list-item',
                                data: {},
                                content: [
                                    {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                        nodeType: 'text',
                                        value: 'All returned product becomes the property of Moderna. All items returned without an RA, or not in compliance with this Policy, may be accepted but with no credit issued.',
                                        marks: [],
                                        data: {}
                                        }
                                    ]
                                    }
                                ]
                                },
                                {
                                nodeType: 'list-item',
                                data: {},
                                content: [
                                    {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                        nodeType: 'text',
                                        value: 'Returns from third-party processors acting on behalf of customers may be accepted provided that the customer receives approval from Moderna, and the third-party processor complies with all aspects of this Returned Goods Policy. Moderna is not responsible for fees incurred by third-party processor.',
                                        marks: [],
                                        data: {}
                                        }
                                    ]
                                    }
                                ]
                                },
                                {
                                nodeType: 'list-item',
                                data: {},
                                content: [
                                    {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                        nodeType: 'text',
                                        value: 'All products returned are subject to final review and evaluation by Moderna.',
                                        marks: [],
                                        data: {}
                                        }
                                    ]
                                    }
                                ]
                                },
                                {
                                nodeType: 'list-item',
                                data: {},
                                content: [
                                    {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                        {
                                        nodeType: 'text',
                                        value: 'Any questions regarding Moderna’s Returned Goods Policy can be addressed by Moderna’s Customer Care Team at 1-866-Moderna (663-3762).',
                                        marks: [],
                                        data: {}
                                        }
                                    ]
                                    }
                                ]
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'Reservation of Rights',
                                marks: [
                                    {
                                    type: 'bold'
                                    }
                                ],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'Moderna reserves the right to modify and make exceptions to this policy and to its implementation at any time, without notice, for any reason, including due to business necessity or changes in applicable laws and regulations.',
                                marks: [],
                                data: {}
                                }
                            ]
                            }
                        ]
                        },
                        backToTopButtonLabel: 'Back To Top',
                        printButtonLabel: 'Print',
                        country: {
                        metadata: {
                            tags: [],
                            concepts: []
                        },
                        sys: {
                            space: {
                            sys: {
                                type: 'Link',
                                linkType: 'Space',
                                id: 'n9bebhw263o0'
                            }
                            },
                            id: '7sht7920U6vs3CLH2CUyaa',
                            type: 'Entry',
                            createdAt: '2023-05-18T03:23:50.744Z',
                            updatedAt: '2023-05-24T22:55:23.250Z',
                            environment: {
                            sys: {
                                id: 'sandbox',
                                type: 'Link',
                                linkType: 'Environment'
                            }
                            },
                            publishedVersion: 6,
                            revision: 2,
                            contentType: {
                            sys: {
                                type: 'Link',
                                linkType: 'ContentType',
                                id: 'country'
                            }
                            },
                            locale: 'en-US'
                        },
                        fields: {
                            name: 'United States',
                            isocode: 'US',
                            flag: {
                            metadata: {
                                tags: [],
                                concepts: []
                            },
                            sys: {
                                space: {
                                sys: {
                                    type: 'Link',
                                    linkType: 'Space',
                                    id: 'n9bebhw263o0'
                                }
                                },
                                id: '3aYCbZJiL8aoEKRdhjOXyy',
                                type: 'Asset',
                                createdAt: '2023-05-24T22:54:50.939Z',
                                updatedAt: '2023-05-24T22:54:50.939Z',
                                environment: {
                                sys: {
                                    id: 'sandbox',
                                    type: 'Link',
                                    linkType: 'Environment'
                                }
                                },
                                publishedVersion: 5,
                                revision: 1,
                                locale: 'en-US'
                            },
                            fields: {
                                title: 'usa flag',
                                description: 'USA Flag',
                                file: {
                                url: '//images.ctfassets.net/n9bebhw263o0/3aYCbZJiL8aoEKRdhjOXyy/f69a6f932a690dc632e7742c328c276d/usa_flag.svg',
                                details: {
                                    size: 2487,
                                    image: {
                                    width: 36,
                                    height: 26
                                    }
                                },
                                fileName: 'usa_flag.svg',
                                contentType: 'image/svg+xml'
                                }
                            }
                            },
                            locales: [
                            'en-US'
                            ]
                        }
                        }
                    }
                    },
                    {
                    metadata: {
                        tags: [],
                        concepts: []
                    },
                    sys: {
                        space: {
                        sys: {
                            type: 'Link',
                            linkType: 'Space',
                            id: 'n9bebhw263o0'
                        }
                        },
                        id: '5FFA0liz6Apt9Uz8LsSWzy',
                        type: 'Entry',
                        createdAt: '2023-05-24T19:13:43.878Z',
                        updatedAt: '2023-06-16T20:38:06.226Z',
                        environment: {
                        sys: {
                            id: 'sandbox',
                            type: 'Link',
                            linkType: 'Environment'
                        }
                        },
                        publishedVersion: 18,
                        revision: 6,
                        contentType: {
                        sys: {
                            type: 'Link',
                            linkType: 'ContentType',
                            id: 'richTextContentComponent'
                        }
                        },
                        locale: 'en-US'
                    },
                    fields: {
                        title: 'Return Goods Rich Text Component - DE',
                        effectiveDateLabel: 'Effective',
                        effectiveDate: '2023-01-07',
                        content: {
                        nodeType: 'document',
                        data: {},
                        content: [
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: 'Our Return Policy',
                                marks: [
                                    {
                                    type: 'bold'
                                    }
                                ],
                                data: {}
                                },
                                {
                                nodeType: 'text',
                                value: '\n',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: '\nReturn policies have not yet been decided on and will be later displayed here. Please remember that by now this is a non binding reservation which will be converted to a binding reservation only with your active approval at a later point in time.',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: '',
                                marks: [],
                                data: {}
                                }
                            ]
                            },
                            {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                                {
                                nodeType: 'text',
                                value: '\n\n\n',
                                marks: [],
                                data: {}
                                }
                            ]
                            }
                        ]
                        },
                        backToTopButtonLabel: 'Back To Top',
                        printButtonLabel: 'Print',
                        country: {
                        metadata: {
                            tags: [],
                            concepts: []
                        },
                        sys: {
                            space: {
                            sys: {
                                type: 'Link',
                                linkType: 'Space',
                                id: 'n9bebhw263o0'
                            }
                            },
                            id: '7DX7badGk41XRSy4znPNFI',
                            type: 'Entry',
                            createdAt: '2023-05-18T03:24:01.186Z',
                            updatedAt: '2023-05-24T23:04:52.125Z',
                            environment: {
                            sys: {
                                id: 'sandbox',
                                type: 'Link',
                                linkType: 'Environment'
                            }
                            },
                            publishedVersion: 5,
                            revision: 2,
                            contentType: {
                            sys: {
                                type: 'Link',
                                linkType: 'ContentType',
                                id: 'country'
                            }
                            },
                            locale: 'en-US'
                        },
                        fields: {
                            name: 'Germany',
                            isocode: 'DE',
                            flag: {
                            metadata: {
                                tags: [],
                                concepts: []
                            },
                            sys: {
                                space: {
                                sys: {
                                    type: 'Link',
                                    linkType: 'Space',
                                    id: 'n9bebhw263o0'
                                }
                                },
                                id: '1PJ5nPASFqJbHZkqrkOloj',
                                type: 'Asset',
                                createdAt: '2023-05-24T23:04:44.544Z',
                                updatedAt: '2023-05-24T23:04:44.544Z',
                                environment: {
                                sys: {
                                    id: 'sandbox',
                                    type: 'Link',
                                    linkType: 'Environment'
                                }
                                },
                                publishedVersion: 5,
                                revision: 1,
                                locale: 'en-US'
                            },
                            fields: {
                                title: 'Germany Flag',
                                description: 'Germany Flag',
                                file: {
                                url: '//images.ctfassets.net/n9bebhw263o0/1PJ5nPASFqJbHZkqrkOloj/586177dc5c2d17ea76a41a972053c188/de_flag.svg',
                                details: {
                                    size: 1305,
                                    image: {
                                    width: 36,
                                    height: 26
                                    }
                                },
                                fileName: 'de_flag.svg',
                                contentType: 'image/svg+xml'
                                }
                            }
                            },
                            locales: [
                            'en-DE'
                            ]
                        }
                        }
                    }
                    }
                ]
                }
            }
            }
        }
        }
    },
    {
        metadata: {
        tags: [],
        concepts: []
        },
        sys: {
        space: {
            sys: {
            type: 'Link',
            linkType: 'Space',
            id: 'n9bebhw263o0'
            }
        },
        id: '2kHlohWHeSQbDJuOgoMZfO',
        type: 'Entry',
        createdAt: '2024-03-08T16:43:35.145Z',
        updatedAt: '2024-03-08T16:43:46.016Z',
        environment: {
            sys: {
            id: 'sandbox',
            type: 'Link',
            linkType: 'Environment'
            }
        },
        publishedVersion: 5,
        revision: 2,
        contentType: {
            sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'internalLink'
            }
        },
        locale: 'en-US'
        },
        fields: {
        title: 'Notice of Seasonal Return Window: COVID-19 Vaccine (2023/2024 Formula)',
        label: 'Notice of Seasonal Return Window',
        pageReference: {
            metadata: {
            tags: [],
            concepts: []
            },
            sys: {
            space: {
                sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'n9bebhw263o0'
                }
            },
            id: '1ss0StRsEFrdMIHmkvmgkW',
            type: 'Entry',
            createdAt: '2024-03-08T15:25:42.609Z',
            updatedAt: '2024-03-08T16:14:48.809Z',
            environment: {
                sys: {
                id: 'sandbox',
                type: 'Link',
                linkType: 'Environment'
                }
            },
            publishedVersion: 8,
            revision: 2,
            contentType: {
                sys: {
                type: 'Link',
                linkType: 'ContentType',
                id: 'page'
                }
            },
            locale: 'en-US'
            },
            fields: {
            name: 'Notice of Seasonal Return Window: COVID-19 Vaccine (2024/2025 Formula)',
            title: 'Notice of Seasonal Return Window: COVID-19 Vaccine (2024/2025 Formula)',
            slug: 'notice-of-seasonal-return-window',
            seo: {
                metadata: {
                tags: [],
                concepts: []
                },
                sys: {
                space: {
                    sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'n9bebhw263o0'
                    }
                },
                id: '6SzHWgqbri7KmD1Kqg9tee',
                type: 'Entry',
                createdAt: '2024-03-08T16:14:42.474Z',
                updatedAt: '2024-03-08T16:14:42.474Z',
                environment: {
                    sys: {
                    id: 'sandbox',
                    type: 'Link',
                    linkType: 'Environment'
                    }
                },
                publishedVersion: 2,
                revision: 1,
                contentType: {
                    sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'seo'
                    }
                },
                locale: 'en-US'
                },
                fields: {
                name: 'Notice of Seasonal Return Window: COVID-19 Vaccine (2023/2024 Formula)'
                }
            },
            content: {
                metadata: {
                tags: [],
                concepts: []
                },
                sys: {
                space: {
                    sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'n9bebhw263o0'
                    }
                },
                id: '5kvUx9OuWGlyAfzkeuWYmf',
                type: 'Entry',
                createdAt: '2024-03-08T15:25:40.478Z',
                updatedAt: '2024-03-08T15:25:40.478Z',
                environment: {
                    sys: {
                    id: 'sandbox',
                    type: 'Link',
                    linkType: 'Environment'
                    }
                },
                publishedVersion: 5,
                revision: 1,
                contentType: {
                    sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'richTextContentPageTemplate'
                    }
                },
                locale: 'en-US'
                },
                fields: {
                name: 'Notice of Seasonal Return Window > Rich Text',
                modules: [
                    {
                    metadata: {
                        tags: [],
                        concepts: []
                    },
                    sys: {
                        space: {
                        sys: {
                            type: 'Link',
                            linkType: 'Space',
                            id: 'n9bebhw263o0'
                        }
                        },
                        id: '4wIx2naddOy0wWDJuYy5aw',
                        type: 'Entry',
                        createdAt: '2024-03-08T15:25:01.040Z',
                        updatedAt: '2024-03-08T15:25:01.040Z',
                        environment: {
                        sys: {
                            id: 'sandbox',
                            type: 'Link',
                            linkType: 'Environment'
                        }
                        },
                        publishedVersion: 6,
                        revision: 1,
                        contentType: {
                        sys: {
                            type: 'Link',
                            linkType: 'ContentType',
                            id: 'bannerComponent'
                        }
                        },
                        locale: 'en-US'
                    },
                    fields: {
                        title: 'Notice of Seasonal Return Window > Rich Text > Banner',
                        headline: 'Notice of Seasonal Return Window: COVID-19 Vaccine (2023/2024 Formula)',
                        backgroundImage: {
                        metadata: {
                            tags: [],
                            concepts: []
                        },
                        sys: {
                            space: {
                            sys: {
                                type: 'Link',
                                linkType: 'Space',
                                id: 'n9bebhw263o0'
                            }
                            },
                            id: '1Px4l8fvDKjBGrRTCqfWrE',
                            type: 'Asset',
                            createdAt: '2022-12-29T16:44:45.722Z',
                            updatedAt: '2022-12-29T16:44:45.722Z',
                            environment: {
                            sys: {
                                id: 'sandbox',
                                type: 'Link',
                                linkType: 'Environment'
                            }
                            },
                            publishedVersion: 5,
                            revision: 1,
                            locale: 'en-US'
                        },
                        fields: {
                            title: 'Banner BG strand top right',
                            description: 'Banner BG strand top right',
                            file: {
                            url: '//images.ctfassets.net/n9bebhw263o0/1Px4l8fvDKjBGrRTCqfWrE/753e8312177899a7503bd1e5e8a8a3eb/Banner_BG_strand_right.png',
                            details: {
                                size: 47693,
                                image: {
                                width: 1920,
                                height: 511
                                }
                            },
                            fileName: 'Banner_BG_strand_right.png',
                            contentType: 'image/png'
                            }
                        }
                        },
                        country: {
                        metadata: {
                            tags: [],
                            concepts: []
                        },
                        sys: {
                            space: {
                            sys: {
                                type: 'Link',
                                linkType: 'Space',
                                id: 'n9bebhw263o0'
                            }
                            },
                            id: '7iOWBmppZrkK5s40UUIzOV',
                            type: 'Entry',
                            createdAt: '2023-09-28T22:24:03.948Z',
                            updatedAt: '2023-09-28T22:24:03.948Z',
                            environment: {
                            sys: {
                                id: 'sandbox',
                                type: 'Link',
                                linkType: 'Environment'
                            }
                            },
                            publishedVersion: 3,
                            revision: 1,
                            contentType: {
                            sys: {
                                type: 'Link',
                                linkType: 'ContentType',
                                id: 'country'
                            }
                            },
                            locale: 'en-US'
                        },
                        fields: {
                            name: 'United States',
                            isocode: 'US',
                            flag: {
                            metadata: {
                                tags: [],
                                concepts: []
                            },
                            sys: {
                                space: {
                                sys: {
                                    type: 'Link',
                                    linkType: 'Space',
                                    id: 'n9bebhw263o0'
                                }
                                },
                                id: '3aYCbZJiL8aoEKRdhjOXyy',
                                type: 'Asset',
                                createdAt: '2023-05-24T22:54:50.939Z',
                                updatedAt: '2023-05-24T22:54:50.939Z',
                                environment: {
                                sys: {
                                    id: 'sandbox',
                                    type: 'Link',
                                    linkType: 'Environment'
                                }
                                },
                                publishedVersion: 5,
                                revision: 1,
                                locale: 'en-US'
                            },
                            fields: {
                                title: 'usa flag',
                                description: 'USA Flag',
                                file: {
                                url: '//images.ctfassets.net/n9bebhw263o0/3aYCbZJiL8aoEKRdhjOXyy/f69a6f932a690dc632e7742c328c276d/usa_flag.svg',
                                details: {
                                    size: 2487,
                                    image: {
                                    width: 36,
                                    height: 26
                                    }
                                },
                                fileName: 'usa_flag.svg',
                                contentType: 'image/svg+xml'
                                }
                            }
                            },
                            locales: [
                            'en-US'
                            ]
                        }
                        }
                    }
                    },
                    {
                    metadata: {
                        tags: [],
                        concepts: []
                    },
                    sys: {
                        space: {
                        sys: {
                            type: 'Link',
                            linkType: 'Space',
                            id: 'n9bebhw263o0'
                        }
                        },
                        id: '3buMSfbhnLWdN0JQh411du',
                        type: 'Entry',
                        createdAt: '2024-03-08T15:25:24.958Z',
                        updatedAt: '2024-03-08T15:31:05.586Z',
                        environment: {
                        sys: {
                            id: 'sandbox',
                            type: 'Link',
                            linkType: 'Environment'
                        }
                        },
                        publishedVersion: 26,
                        revision: 2,
                        contentType: {
                        sys: {
                            type: 'Link',
                            linkType: 'ContentType',
                            id: 'richTextContentComponent'
                        }
                        },
                        locale: 'en-US'
                    },
                    fields: {
                        title: 'Notice of Seasonal Return Window > Rich Text > Content',
                        content: {
                        data: {},
                        content: [
                            {
                            data: {},
                            content: [
                                {
                                data: {},
                                marks: [],
                                value: 'Dear Valued Partner,',
                                nodeType: 'text'
                                }
                            ],
                            nodeType: 'paragraph'
                            },
                            {
                            data: {},
                            content: [
                                {
                                data: {},
                                marks: [],
                                value: 'On behalf of Moderna US, Inc. we are providing an important update regarding returnability of seasonal COVID-19 Vaccine Product (2023-2024 formulation). Pursuant to the Returned Goods Policy and Procedures in your purchase Agreement, at the end of each season a seasonal returns window will open and a percentage of the total volume of the Moderna COVID-19 Vaccine Product purchased directly from Moderna that is within your contracted returns allowance may be returned for credit. Any returns received in excess of your contracted return allowance will be destroyed without credit. ',
                                nodeType: 'text'
                                }
                            ],
                            nodeType: 'paragraph'
                            },
                            {
                            data: {},
                            content: [
                                {
                                data: {},
                                marks: [
                                    {
                                    type: 'bold'
                                    }
                                ],
                                value: 'On April 1, 2024, Moderna will open the seasonal returns window for Moderna’s COVID-19 Vaccine Product with two credit windows, as follows:',
                                nodeType: 'text'
                                }
                            ],
                            nodeType: 'paragraph'
                            },
                            {
                            data: {},
                            content: [
                                {
                                data: {},
                                content: [
                                    {
                                    data: {},
                                    content: [
                                        {
                                        data: {},
                                        marks: [],
                                        value: 'Expiring Product returned with an approved Return Authorization (RA) received by Inmar Pharmaceutical Services (“Inmar”) between April 1, 2024 and May 31, 2024 will be calculated for credit to be applied to your account upon processing of the returns information at the close of the return window.',
                                        nodeType: 'text'
                                        }
                                    ],
                                    nodeType: 'paragraph'
                                    }
                                ],
                                nodeType: 'list-item'
                                },
                                {
                                data: {},
                                content: [
                                    {
                                    data: {},
                                    content: [
                                        {
                                        data: {},
                                        marks: [],
                                        value: 'Product received with an approved RA received by Inmar between June 1, 2024 through August 31, 2024 will be credited to your account upon processing of the returns information at the close of the return window. Product received after August 31, 2024 will be destroyed and no credit will be issued.',
                                        nodeType: 'text'
                                        }
                                    ],
                                    nodeType: 'paragraph'
                                    }
                                ],
                                nodeType: 'list-item'
                                }
                            ],
                            nodeType: 'unordered-list'
                            },
                            {
                            data: {},
                            content: [
                                {
                                data: {},
                                marks: [
                                    {
                                    type: 'bold'
                                    },
                                    {
                                    type: 'underline'
                                    }
                                ],
                                value: 'Additional Considerations',
                                nodeType: 'text'
                                }
                            ],
                            nodeType: 'paragraph'
                            },
                            {
                            data: {},
                            content: [
                                {
                                data: {},
                                content: [
                                    {
                                    data: {},
                                    content: [
                                        {
                                        data: {},
                                        marks: [],
                                        value: 'We encourage you to maintain sufficient inventory to immunize through Spring and early Summer preceding the new COVID-19 presentations for 2024-25 becoming available.',
                                        nodeType: 'text'
                                        }
                                    ],
                                    nodeType: 'paragraph'
                                    }
                                ],
                                nodeType: 'list-item'
                                },
                                {
                                data: {},
                                content: [
                                    {
                                    data: {},
                                    content: [
                                        {
                                        data: {},
                                        marks: [],
                                        value: 'Please refer to your Moderna purchase Agreement for your defined return allowance percentage.',
                                        nodeType: 'text'
                                        }
                                    ],
                                    nodeType: 'paragraph'
                                    }
                                ],
                                nodeType: 'list-item'
                                },
                                {
                                data: {},
                                content: [
                                    {
                                    data: {},
                                    content: [
                                        {
                                        data: {},
                                        marks: [],
                                        value: 'IDNs should send returns in aggregate and provide a central payer (if applicable) so the contract return allowance % can be calculated at the IDN or Group Level. If returns are not provided in aggregate, each location will be calculated individually to assess their allowance for returns.',
                                        nodeType: 'text'
                                        }
                                    ],
                                    nodeType: 'paragraph'
                                    }
                                ],
                                nodeType: 'list-item'
                                },
                                {
                                data: {},
                                content: [
                                    {
                                    data: {},
                                    content: [
                                        {
                                        data: {},
                                        marks: [],
                                        value: 'If you have purchased through an Authorized Distributor of Record (ADR), please refer to their policies for seasonal returns and allow additional time for credits to be applied to your ADR account.',
                                        nodeType: 'text'
                                        }
                                    ],
                                    nodeType: 'paragraph'
                                    }
                                ],
                                nodeType: 'list-item'
                                }
                            ],
                            nodeType: 'unordered-list'
                            },
                            {
                            data: {},
                            content: [
                                {
                                data: {},
                                marks: [
                                    {
                                    type: 'bold'
                                    },
                                    {
                                    type: 'underline'
                                    }
                                ],
                                value: 'Procedure for Seasonal / Expired Product Returns ',
                                nodeType: 'text'
                                }
                            ],
                            nodeType: 'paragraph'
                            },
                            {
                            data: {},
                            content: [
                                {
                                data: {},
                                content: [
                                    {
                                    data: {},
                                    content: [
                                        {
                                        data: {},
                                        marks: [],
                                        value: 'Seasonal / expired product returns require a Return Authorization (RA) issued through Inmar . To request a RA from Inmar, please use one of the three options below. ',
                                        nodeType: 'text'
                                        }
                                    ],
                                    nodeType: 'paragraph'
                                    },
                                    {
                                    data: {},
                                    content: [
                                        {
                                        data: {},
                                        content: [
                                            {
                                            data: {},
                                            content: [
                                                {
                                                data: {},
                                                marks: [],
                                                value: 'Access the Inmar website at https://returns.healthcare.inmar.com, and upload a PDF copy of your debit memo.',
                                                nodeType: 'text'
                                                }
                                            ],
                                            nodeType: 'paragraph'
                                            }
                                        ],
                                        nodeType: 'list-item'
                                        },
                                        {
                                        data: {},
                                        content: [
                                            {
                                            data: {},
                                            content: [
                                                {
                                                data: {},
                                                marks: [],
                                                value: 'E-mail your debit memo to ',
                                                nodeType: 'text'
                                                },
                                                {
                                                data: {
                                                    uri: 'mailto:rarequest@inmar.com'
                                                },
                                                content: [
                                                    {
                                                    data: {},
                                                    marks: [],
                                                    value: 'rarequest@inmar.com',
                                                    nodeType: 'text'
                                                    }
                                                ],
                                                nodeType: 'hyperlink'
                                                },
                                                {
                                                data: {},
                                                marks: [],
                                                value: '.',
                                                nodeType: 'text'
                                                }
                                            ],
                                            nodeType: 'paragraph'
                                            }
                                        ],
                                        nodeType: 'list-item'
                                        },
                                        {
                                        data: {},
                                        content: [
                                            {
                                            data: {},
                                            content: [
                                                {
                                                data: {},
                                                marks: [],
                                                value: 'Fax your debit memo to Inmar at 817-868-5343.',
                                                nodeType: 'text'
                                                }
                                            ],
                                            nodeType: 'paragraph'
                                            }
                                        ],
                                        nodeType: 'list-item'
                                        }
                                    ],
                                    nodeType: 'unordered-list'
                                    }
                                ],
                                nodeType: 'list-item'
                                },
                                {
                                data: {},
                                content: [
                                    {
                                    data: {},
                                    content: [
                                        {
                                        data: {},
                                        marks: [],
                                        value: 'All requests for returns must include the following information or be subject to denial of Return Authorization.',
                                        nodeType: 'text'
                                        }
                                    ],
                                    nodeType: 'paragraph'
                                    },
                                    {
                                    data: {},
                                    content: [
                                        {
                                        data: {},
                                        content: [
                                            {
                                            data: {},
                                            content: [
                                                {
                                                data: {},
                                                marks: [],
                                                value: 'A copy of your invoice(s)',
                                                nodeType: 'text'
                                                }
                                            ],
                                            nodeType: 'paragraph'
                                            }
                                        ],
                                        nodeType: 'list-item'
                                        },
                                        {
                                        data: {},
                                        content: [
                                            {
                                            data: {},
                                            content: [
                                                {
                                                data: {},
                                                marks: [],
                                                value: 'IDs used to purchase as shown on invoice (including Customer Number, DEA and/or HIN#)',
                                                nodeType: 'text'
                                                }
                                            ],
                                            nodeType: 'paragraph'
                                            }
                                        ],
                                        nodeType: 'list-item'
                                        },
                                        {
                                        data: {},
                                        content: [
                                            {
                                            data: {},
                                            content: [
                                                {
                                                data: {},
                                                marks: [],
                                                value: 'Customer name as shown on invoice',
                                                nodeType: 'text'
                                                }
                                            ],
                                            nodeType: 'paragraph'
                                            }
                                        ],
                                        nodeType: 'list-item'
                                        },
                                        {
                                        data: {},
                                        content: [
                                            {
                                            data: {},
                                            content: [
                                                {
                                                data: {},
                                                marks: [],
                                                value: 'Customer billing address',
                                                nodeType: 'text'
                                                }
                                            ],
                                            nodeType: 'paragraph'
                                            }
                                        ],
                                        nodeType: 'list-item'
                                        },
                                        {
                                        data: {},
                                        content: [
                                            {
                                            data: {},
                                            content: [
                                                {
                                                data: {},
                                                marks: [],
                                                value: 'Customer shipping address as shown on invoice',
                                                nodeType: 'text'
                                                }
                                            ],
                                            nodeType: 'paragraph'
                                            }
                                        ],
                                        nodeType: 'list-item'
                                        },
                                        {
                                        data: {},
                                        content: [
                                            {
                                            data: {},
                                            content: [
                                                {
                                                data: {},
                                                marks: [],
                                                value: 'Contact name and phone and/or email',
                                                nodeType: 'text'
                                                }
                                            ],
                                            nodeType: 'paragraph'
                                            }
                                        ],
                                        nodeType: 'list-item'
                                        },
                                        {
                                        data: {},
                                        content: [
                                            {
                                            data: {},
                                            content: [
                                                {
                                                data: {},
                                                marks: [],
                                                value: 'Source of Purchase (ADR name or Moderna Direct)',
                                                nodeType: 'text'
                                                }
                                            ],
                                            nodeType: 'paragraph'
                                            }
                                        ],
                                        nodeType: 'list-item'
                                        },
                                        {
                                        data: {},
                                        content: [
                                            {
                                            data: {},
                                            content: [
                                                {
                                                data: {},
                                                marks: [],
                                                value: 'Wholesaler Debit memo number and Date (if applicable)',
                                                nodeType: 'text'
                                                }
                                            ],
                                            nodeType: 'paragraph'
                                            }
                                        ],
                                        nodeType: 'list-item'
                                        },
                                        {
                                        data: {},
                                        content: [
                                            {
                                            data: {},
                                            content: [
                                                {
                                                data: {},
                                                marks: [],
                                                value: 'Invoice Number and Invoice Date',
                                                nodeType: 'text'
                                                }
                                            ],
                                            nodeType: 'paragraph'
                                            }
                                        ],
                                        nodeType: 'list-item'
                                        },
                                        {
                                        data: {},
                                        content: [
                                            {
                                            data: {},
                                            content: [
                                                {
                                                data: {},
                                                marks: [],
                                                value: 'Product name and NDC number',
                                                nodeType: 'text'
                                                }
                                            ],
                                            nodeType: 'paragraph'
                                            }
                                        ],
                                        nodeType: 'list-item'
                                        },
                                        {
                                        data: {},
                                        content: [
                                            {
                                            data: {},
                                            content: [
                                                {
                                                data: {},
                                                marks: [],
                                                value: 'Product quantity to return',
                                                nodeType: 'text'
                                                }
                                            ],
                                            nodeType: 'paragraph'
                                            }
                                        ],
                                        nodeType: 'list-item'
                                        },
                                        {
                                        data: {},
                                        content: [
                                            {
                                            data: {},
                                            content: [
                                                {
                                                data: {},
                                                marks: [],
                                                value: 'Sale Unit price (Invoiced price)',
                                                nodeType: 'text'
                                                }
                                            ],
                                            nodeType: 'paragraph'
                                            }
                                        ],
                                        nodeType: 'list-item'
                                        },
                                        {
                                        data: {},
                                        content: [
                                            {
                                            data: {},
                                            content: [
                                                {
                                                data: {},
                                                marks: [],
                                                value: 'Serial number, GTIN, lot number, expiration date',
                                                nodeType: 'text'
                                                }
                                            ],
                                            nodeType: 'paragraph'
                                            }
                                        ],
                                        nodeType: 'list-item'
                                        },
                                        {
                                        data: {},
                                        content: [
                                            {
                                            data: {},
                                            content: [
                                                {
                                                data: {},
                                                marks: [],
                                                value: 'Reason for the return (i.e., return of seasonal product per contract T&C’s_',
                                                nodeType: 'text'
                                                }
                                            ],
                                            nodeType: 'paragraph'
                                            }
                                        ],
                                        nodeType: 'list-item'
                                        }
                                    ],
                                    nodeType: 'unordered-list'
                                    }
                                ],
                                nodeType: 'list-item'
                                },
                                {
                                data: {},
                                content: [
                                    {
                                    data: {},
                                    content: [
                                        {
                                        data: {},
                                        marks: [],
                                        value: 'For seasonal returns you may submit one request for the entire quantity that has multiple invoices but must include the information above in a formatted spreadsheet applicable for all returned Product.',
                                        nodeType: 'text'
                                        }
                                    ],
                                    nodeType: 'paragraph'
                                    }
                                ],
                                nodeType: 'list-item'
                                },
                                {
                                data: {},
                                content: [
                                    {
                                    data: {},
                                    content: [
                                        {
                                        data: {},
                                        marks: [],
                                        value: 'Inmar will send a box label to use when submitting returned Product.',
                                        nodeType: 'text'
                                        }
                                    ],
                                    nodeType: 'paragraph'
                                    }
                                ],
                                nodeType: 'list-item'
                                },
                                {
                                data: {},
                                content: [
                                    {
                                    data: {},
                                    content: [
                                        {
                                        data: {},
                                        marks: [],
                                        value: 'Once an RA is issued, the products must be shipped to Inmar within 30 days.',
                                        nodeType: 'text'
                                        }
                                    ],
                                    nodeType: 'paragraph'
                                    }
                                ],
                                nodeType: 'list-item'
                                },
                                {
                                data: {},
                                content: [
                                    {
                                    data: {},
                                    content: [
                                        {
                                        data: {},
                                        marks: [],
                                        value: 'If you have any questions, please contact Inmar at 1-800-967-5952 option 3. Mon. – Fri. 7am – 5pm CT',
                                        nodeType: 'text'
                                        }
                                    ],
                                    nodeType: 'paragraph'
                                    }
                                ],
                                nodeType: 'list-item'
                                },
                                {
                                data: {},
                                content: [
                                    {
                                    data: {},
                                    content: [
                                        {
                                        data: {},
                                        marks: [],
                                        value: 'Include the completed RA box label with your return. ',
                                        nodeType: 'text'
                                        }
                                    ],
                                    nodeType: 'paragraph'
                                    }
                                ],
                                nodeType: 'list-item'
                                },
                                {
                                data: {},
                                content: [
                                    {
                                    data: {},
                                    content: [
                                        {
                                        data: {},
                                        marks: [],
                                        value: 'Send returns to: ',
                                        nodeType: 'text'
                                        }
                                    ],
                                    nodeType: 'paragraph'
                                    }
                                ],
                                nodeType: 'list-item'
                                }
                            ],
                            nodeType: 'unordered-list'
                            },
                            {
                            data: {},
                            content: [
                                {
                                data: {},
                                marks: [
                                    {
                                    type: 'bold'
                                    }
                                ],
                                value: 'Inmar Rx Solutions\n3845 Grand Lakes Way\nSuite 125\nGrand Prairie, TX 75050',
                                nodeType: 'text'
                                }
                            ],
                            nodeType: 'paragraph'
                            },
                            {
                            data: {},
                            content: [
                                {
                                data: {},
                                content: [
                                    {
                                    data: {},
                                    content: [
                                        {
                                        data: {},
                                        marks: [],
                                        value: 'It is shipper’s responsibility to securely package all returned Products to prevent breakage during transit.',
                                        nodeType: 'text'
                                        }
                                    ],
                                    nodeType: 'paragraph'
                                    }
                                ],
                                nodeType: 'list-item'
                                },
                                {
                                data: {},
                                content: [
                                    {
                                    data: {},
                                    content: [
                                        {
                                        data: {},
                                        marks: [],
                                        value: 'If multiple RAs are being returned within a single delivery to Inmar , ensure returned Product with the associated RAs are distinctly separated (with appropriate labeling if needed) within the delivery. Failure to do so may result in inaccurate accounting of the return or a delay to the crediting process. ',
                                        nodeType: 'text'
                                        }
                                    ],
                                    nodeType: 'paragraph'
                                    }
                                ],
                                nodeType: 'list-item'
                                },
                                {
                                data: {},
                                content: [
                                    {
                                    data: {},
                                    content: [
                                        {
                                        data: {},
                                        marks: [],
                                        value: 'Returned Products do not require refrigerated packaging. ',
                                        nodeType: 'text'
                                        }
                                    ],
                                    nodeType: 'paragraph'
                                    }
                                ],
                                nodeType: 'list-item'
                                },
                                {
                                data: {},
                                content: [
                                    {
                                    data: {},
                                    content: [
                                        {
                                        data: {},
                                        marks: [],
                                        value: 'Transportation charges, including prepaid freight and insurance, are the responsibility of the customer. No fees of any kind will be approved for credit. Moderna is not responsible for return shipments lost in transit.',
                                        nodeType: 'text'
                                        }
                                    ],
                                    nodeType: 'paragraph'
                                    }
                                ],
                                nodeType: 'list-item'
                                },
                                {
                                data: {},
                                content: [
                                    {
                                    data: {},
                                    content: [
                                        {
                                        data: {},
                                        marks: [],
                                        value: 'Credit for accepted returned Product will be issued subject to the policies of original purchase. Refund for purchases made through an ADR will be credited through the customer account with their ADR, where applicable according to the ADR’s policies.',
                                        nodeType: 'text'
                                        }
                                    ],
                                    nodeType: 'paragraph'
                                    }
                                ],
                                nodeType: 'list-item'
                                }
                            ],
                            nodeType: 'unordered-list'
                            },
                            {
                            data: {},
                            content: [
                                {
                                data: {},
                                marks: [
                                    {
                                    type: 'bold'
                                    }
                                ],
                                value: 'Reservation of Rights',
                                nodeType: 'text'
                                }
                            ],
                            nodeType: 'paragraph'
                            },
                            {
                            data: {},
                            content: [
                                {
                                data: {},
                                marks: [],
                                value: 'Moderna reserves the right to modify and make exceptions to this Policy and to its implementation at any time, without advanced notice, for any reason, including due to business necessity or changes in applicable laws and regulations.',
                                nodeType: 'text'
                                }
                            ],
                            nodeType: 'paragraph'
                            },
                            {
                            data: {},
                            content: [
                                {
                                data: {},
                                marks: [
                                    {
                                    type: 'bold'
                                    }
                                ],
                                value: 'Any questions regarding Moderna’s Returned Goods Policy can be addressed by Moderna’s Customer Care Team at 1-866-MODERNA (663-3762).',
                                nodeType: 'text'
                                }
                            ],
                            nodeType: 'paragraph'
                            },
                            {
                            data: {},
                            content: [
                                {
                                data: {},
                                marks: [],
                                value: 'Best Regards,',
                                nodeType: 'text'
                                }
                            ],
                            nodeType: 'paragraph'
                            },
                            {
                            data: {},
                            content: [
                                {
                                data: {},
                                marks: [],
                                value: 'Moderna Contracts Team\nModerna US, Inc.',
                                nodeType: 'text'
                                }
                            ],
                            nodeType: 'paragraph'
                            }
                        ],
                        nodeType: 'document'
                        },
                        printButtonLabel: 'Print',
                        country: {
                        metadata: {
                            tags: [],
                            concepts: []
                        },
                        sys: {
                            space: {
                            sys: {
                                type: 'Link',
                                linkType: 'Space',
                                id: 'n9bebhw263o0'
                            }
                            },
                            id: '7iOWBmppZrkK5s40UUIzOV',
                            type: 'Entry',
                            createdAt: '2023-09-28T22:24:03.948Z',
                            updatedAt: '2023-09-28T22:24:03.948Z',
                            environment: {
                            sys: {
                                id: 'sandbox',
                                type: 'Link',
                                linkType: 'Environment'
                            }
                            },
                            publishedVersion: 3,
                            revision: 1,
                            contentType: {
                            sys: {
                                type: 'Link',
                                linkType: 'ContentType',
                                id: 'country'
                            }
                            },
                            locale: 'en-US'
                        },
                        fields: {
                            name: 'United States',
                            isocode: 'US',
                            flag: {
                            metadata: {
                                tags: [],
                                concepts: []
                            },
                            sys: {
                                space: {
                                sys: {
                                    type: 'Link',
                                    linkType: 'Space',
                                    id: 'n9bebhw263o0'
                                }
                                },
                                id: '3aYCbZJiL8aoEKRdhjOXyy',
                                type: 'Asset',
                                createdAt: '2023-05-24T22:54:50.939Z',
                                updatedAt: '2023-05-24T22:54:50.939Z',
                                environment: {
                                sys: {
                                    id: 'sandbox',
                                    type: 'Link',
                                    linkType: 'Environment'
                                }
                                },
                                publishedVersion: 5,
                                revision: 1,
                                locale: 'en-US'
                            },
                            fields: {
                                title: 'usa flag',
                                description: 'USA Flag',
                                file: {
                                url: '//images.ctfassets.net/n9bebhw263o0/3aYCbZJiL8aoEKRdhjOXyy/f69a6f932a690dc632e7742c328c276d/usa_flag.svg',
                                details: {
                                    size: 2487,
                                    image: {
                                    width: 36,
                                    height: 26
                                    }
                                },
                                fileName: 'usa_flag.svg',
                                contentType: 'image/svg+xml'
                                }
                            }
                            },
                            locales: [
                            'en-US'
                            ]
                        }
                        }
                    }
                    }
                ]
                }
            }
            }
        }
        }
    }
    ],
    accreditationsLabel: 'Accreditations',
    accreditationsLogo: nabp,
    nabpAccreditedUrl: 'https://app.us.openbadges.me/view/#!/badge?badgeid=0d1ec98f-a86a-4a75-8b8e-48cb523f210b'
}